import { Component, DoCheck, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterLink, RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SortPipe } from '../_helpers/sort.pipe';
import { HelpsectionComponent } from '../helpsection/helpsection.component';
import { SuppliertabComponent } from '../suppliertab/suppliertab.component';
import { Subject, of, from, forkJoin, firstValueFrom } from 'rxjs';
import { concatMap, map, takeUntil } from 'rxjs/operators';
import { appConfig } from '../app.config';
import { CommonService } from '../_service/common.service';
import * as XLSX from 'xlsx';
import { SupplierService } from '../_service/supplier.service';
import { SitesService } from '../_service/sites.service';
import { AddressService } from '../_service/address.service';
import { CountryService } from '../_service/country.service';
import { ContactsService } from '../_service/contacts.service';
import { ImportbvdService } from '../_service/importbvd.service';
import { BlankstatusService } from '../_service/blankstatus.service';

const TWO = 2;
const SIX = 6;
const EIGHT = 8;
const TEN = 10;
const DUNS_LENGTH = 9;
const BATCH_SIZE = 100;
const FIFTEEN_HUNDRED_MS = 1500;
const THREE_THOUSAND_MS = 3000;
const SIX_THOUSAND_MS = 6000;
const TEN_THOUSAND_MS = 10000;

@Component({
    selector: 'app-administration',
    templateUrl: './administration.component.html',
    styleUrls: ['./administration.component.scss'],
    standalone: true,
    imports: [
        CommonModule, FormsModule, ReactiveFormsModule, RouterLink, RouterModule,
        MatIconModule, MatFormFieldModule, MatInputModule, MatSelectModule,
        MatOptionModule, MatTooltipModule, MatProgressSpinnerModule,
        MatProgressBarModule, NgxPaginationModule, NgSelectModule, NgbModule,
        SortPipe, HelpsectionComponent, SuppliertabComponent
    ]
})
export class AdministrationComponent implements OnInit, OnDestroy, DoCheck {
  private ngUnsubscribe = new Subject();
  Config: any;
  public envHide: any = "";
  public roleVariableHide = false;
  public prodHide = false;
  public superUserShow = false;
  public showBuyerProfile = false;
  public showForConsult = false;
  showForSupplier: boolean;
  roleIsManager = false;

  loading = false;
  public CIdentifierTypes: any = [];
  public IdenKeywithId: any = [];
  CountryNameKeyIds: any = [];
  selectedCountry: string;
  CityNameKeyId: any = [];
  public newCategoryAssignment = '6';
  public newCategoryName = 'SUPPLIER SITE';
  public qualifierChangetoPending = ['P11', 'P05', 'P06', 'P19', 'P07', 'P09', 'P08'];
  siteCityModel: string;
  siteCountryModel: string;
  CaptCity: any = [];
  public cancelCpyHQProcessing = false;
  public cancelCpyAlcorProcessing = false;
  public cpyBatchBtn = 'Cancel';
  public pageCpyAlcorBatchNo = 0;
  public aliasTextDispCpyAlcor = '';
  public progressForCpyAlcor = '';


  fileToUpload: File = null;

  
  headers: any;
  public siteIdentTypesData: any = [];
  
  loadingText = '<img src="assets/images/loading.gif" alt="loading...">';

  
  
  filteredStatushighlight = false;
  timerForBatchStartForSiteAss: any;
  siteBatchPageHolder = '';
  siteBatchIsRunning = false;
  stopAlcorCpyBatch = false;
  public aliasTextDispForSiteAss = 'Loading Please Wait....';
  public pageBatchNoForSiteAss: any = '';
  public showDownloadLogForSiteAss = false;
  
  
  companyStatusRowid: any
  public siteSourceSystems: any = [];
  companyAliasAll: any = [];

  public cpyShortNameTypes: any = [];
  
  public alcorRowId: any;
  
  companyIdenKeys = [];
  CompanyStatusAll = [];
  CompanyStatusAllForGuo = [];
  public groupCategoryModel: any = '';

  errorMessArrImportAlcorBatch: any = [];
  logOfImportAlcorBatch: any;
  showDownloadLogForAlcorBatch = false;
  showSessionTimeoutAlcorBatch = false;
  showDownloadLogForAlcorBatchComplete = false;
  TextForCompleteUploadImportAlcor: any = '';
  public currentAlcorImporting: any = '';
  public importAlcorInError: any;
  public noOfAlcorImported: any = '';
  public totalAlcorToImport: any = '';
  public TextForAlcorInError: any = '';
  listObjForAlcor: any = [];
  inputFileVisibleForImportAlcor = false;
  currentAlcorImportingStarted = 0;
  inputFileVisibleForImportContacts = false;
  showDownloadLogForContactsBatch = false;
  showDownloadLogForContactsBatchComplete = false;
  TextForContactsInError = '';
  TextForCompleteUploadImportContacts = '';
  listObjForContacts: any = [];
  currentContactsImportingStarted = 0;
  PersonRoles = [];
  errorMessArrImportContactsBatch: any = [];
  importContactsInError: any = '';
  currentContactsImporting: any = '';
  noOfContactsImported: any = '';
  logOfImportContactsBatch = [];
  totalContactsToImport: any = '';
  showSessionTimeoutContactsBatch = false;


  inputFileVisibleForImportBvdId = false;
  showDownloadLogForBvdIdBatch = false;
  showDownloadLogForBvdIdBatchComplete = false;
  TextForBvdIdInError = '';
  TextForCompleteUploadImportBvdId = '';
  listObjForBvdId: any = [];
  currentBvdIdImportingStarted = 0;
  errorMessArrImportBvdIdBatch: any = [];
  importBvdIdInError:any = '';
  currentBvdIdImporting: any = '';
  noOfBvdIdImported: any = '';
  logOfImportBvdIdBatch = [];
  totalBvdIdsToProcess: any = '';
  currentBvdIdProcessing = '';
  currentBvdIdProcessingIndex = 0;
  showSessionTimeoutBvdIdBatch = false;
  bvdIdBatchIsRunning = false;
  uploadBvdIdDocError = false;

  

  TextForCompleteUploadDUNS: any = '';
  listObjForDUNS: any = [];
  currentDUNSImportingStarted = 0;
  showSessionTimeoutTaxBatch = false;
  errorMessArrImportDUNSBatch: any = [];
  public currentDUNSImporting: any = '';
  public noOfDUNSImported: any = '';
  public importDUNSInError: any = '';
  public TextForDUNSInError: any = '';
  showDownloadLogForDUNSBatchComplete = false;
  showDownloadLogForDUNSBatch = false;
  inputFileVisibleForImportDUNS = false;
  logOfImportDUNSBatch: any = '';
  totalDUNSToImport: any = ''
  
  errorMsg: string;
  
  uploadDocError: boolean;
  inputFileVisibleForImportSaer: boolean;
  public currentTaxImporting: any = '';
  public importTaxInError: any;
  public noOfTaxImported: any = '';
  public totalTaxToImport: any = '';
  public TextForTaxInError: any = '';
  AvalueSelected: any = [];
  Avalue: any = [];
  activityA: any[];
  optActivityA: { value: any, checked: boolean }[];
  activityLoaded: boolean;
  CompanySelected = false;
  updateTaxStarted = false;
  companyIds: any = [];
  BvDdata: any;
  CompanyIdentiTypes: any[];
  TaxIdentifierKeys: any[];
  TaxIdentifierType: any[];
  compAliasType: any[];
  businessEntityIdSite: any = '';
  errorMessArrImportTaxBatch: any = [];
  ImportTAxDisplayMsg = '';
  showDownloadLogForTaxBatch = false;
  
  listObjForTax: any = [];
  siteBvdofCurrentImporting: any = '';
  siteIdofCurrentImporting: any = '';
  TextForCompleteUploadTax = '';
  noOfTaxinError: any = 0;
  
  showSessionTimeoutDUNSBatch = false;
  taxImportedAlready: any = [];
  currentOrbisStatus: any;
  
  businessEntityValue: any;
  totalBvdIdToImport: any;
  TextForCompleteUploadBvdId: any;
  bvdDataToImport: any;
  SiteRowID: any = [];
  BvdHeaders: any;
  AlcorHeaders: any;
  SaerHeaders: any;
  displayMessage = '';
  showDownloadLogForSaerBatch: boolean;
  showDownloadLogForSaerBatchComplete: boolean;
  TextForCompleteUploadImportSaer = '';
  TextForSaerInError = '';
  errorMessArrImportSaerBatch = [];
  importSaerInError:any = '';
  currentSaerImporting: any;
  noOfSaerImported: any;
  currentSaerImportingStarted: any;
  logOfImportSaerBatch: any[];
  totalSaerToImport: string;
  listObjForSaer = []
  startUpload = 0;
  TextForCompleteUploadImportLatam: string;
  LatamHeaders: unknown;
  listObjForLatam: {}[];
  inputFileVisibleForImportLatam: boolean;
  showDownloadLogForLatamBatch: boolean;
  TextForLatamInError: string;
  errorMessArrImportLatamBatch: any[];
  importLatamInError: any;
  showDownloadLogForLatamBatchComplete: boolean;
  currentLatamImporting: any;
  noOfLatamImported: any;
  totalLatamToImport: any;
  logOfImportLatamBatch: any[];
  currentLatamImportingStarted: any;
  TextForCompleteUploadImportRNAIPL: string;
  RNAIPLHeaders: unknown;
  listObjForRNAIPL: {}[];
  inputFileVisibleForImportRNAIPL: boolean;
  showDownloadLogForRNAIPLBacth: boolean;
  TextForRNAIPLError: string;
  errorMessArrImportRNAIPLBacth: any[];
  importRNAIPLError: any;
  importRNAIPLinError: any;
  showDownloadLogForRNAIPLBacthComplete: boolean;
  currentRNAIPLImporting: any;
  noOfRNAIPLImported: any;
  totalRNAIPLToImport: any;
  logOfImportRNAIPLBacth: any[];
  currentRNAIPLImportingStarted: any;

  constructor(public apiService: CommonService, private supplierService: SupplierService, private router: Router, private bvdimportService: ImportbvdService, private sitesService: SitesService, private AddressService: AddressService, private countryService: CountryService, private contactsService: ContactsService, private blankupdate: BlankstatusService) {
    this.Config = appConfig;
  }

  ngOnInit() {

    this.bvdimportService.setOnConditionSatisfiedCallback(() => {
      this.finished();
    });
    this.bvdimportService.setOnConditionSatisfiedCallback2(() => {
      this.groupLinkError()
    });

    this.supplierService.getGroupAssignments(this.Config.ApiSupplierUrl + "group-assignments?apoStatus=ACTIVE&status=VALIDATED&companyId=" + "38289" + '&_page=1').subscribe((data: any) => {
      data['group-assignments'].forEach(_element => {

      });
    })
    this.checkLocalStorageForImpSaer();
    this.checkLocalStorageForImpLatam();
    this.checkLocalStorageForImpRNAIPL();
    this.checkLocalStorageForImpAlcor();
    this.checkLocalStorageForImpContacts();
    this.checkLocalStorageForImpDUNS();
    this.checkLocalStorageForImpTax();
    this.checkLocalStorageForImpBvd();

  }

  ngDoCheck() {
    this.getRoles();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next(undefined);
    this.ngUnsubscribe.complete();
    localStorage.setItem('cpyBatchRunning', 'no');
    localStorage.setItem('siteBatchRunning', 'no');
    localStorage.setItem('mainEntrBatchRunning', 'no');
  }

  getRoles() {
    let RoleByService = this.apiService.splitAndRolesAssign();
    this.checkAllProfilesAndEnv(RoleByService);
  }

  fileType(filename, fileExtension) {
    let splits = filename.name.split('.');
    let allowedFileTypes = [];

    if (fileExtension === 'xlsx') {
      allowedFileTypes = ['xlsx'];
    } else if (fileExtension === 'xls') {
      allowedFileTypes = ['xls', 'xlsx'];
    } else {
      allowedFileTypes = ['csv'];
    }

    let maxSplitLen = splits.length;
    let extension = splits[maxSplitLen - 1].toLowerCase();
    if (!allowedFileTypes.includes(extension)) {
      this.uploadDocError = true
      return true;
    } else {
      this.uploadDocError = false
      return false;
    }
  }

  checkAllProfilesAndEnv(RoleByService) {
    let c = RoleByService;

    if (c['buyer'] == 'yes') {
      this.showBuyerProfile = false;
    } else {
      this.showBuyerProfile = true;
    }
    if (c['env'] == 'qua' || c['env'] == 're7' || c['env'] == 'ope') {
      this.envHide = false;
    } else {
      this.envHide = true;
    }
    if (c['role'] == 'admin' || c['role'].includes('admin')) {
      this.roleVariableHide = true;
    } else {
      this.roleVariableHide = false;
    }
    if (c['role'] == 'manager') {
      this.roleIsManager = true;
    } else {
      this.roleIsManager = false;
    }
    if (c['superAdmin'] == 'yes') {
      this.superUserShow = true;
    } else {
      this.superUserShow = false;
      if (this.roleVariableHide == false) {
        console.info("Not authorized");
        this.router.navigateByUrl('/sites');
      }
    }
    if (c['env'] == 'ope') {
      this.prodHide = true;
    } else {
      this.prodHide = false;
    }


    if (c['role'] == 'consult' || c['role'].includes('consult')) {
      this.showForConsult = false;
    } else {
      this.showForConsult = true;
    }
    if (c['role'] == 'supplier') {
      this.showForSupplier = false;
    } else {
      this.showForSupplier = true;
    }
  }


  AllCompanyIdentifierTypes() {
    this.CIdentifierTypes = [];
    this.CIdentifierTypes[0] = 'Alliance Company ID';
    this.supplierService.getCompanyIdentifierKeys(this.Config.ApiSupplierUrl + 'company-identifier-keys').subscribe((data: any) => {
      if (data['company-identifier-keys'].length > 0) {
        data['company-identifier-keys'].forEach(element => {
          if (element.type.toLowerCase() == "oth" && element.name.toLowerCase() == 'alcor') {
            this.alcorRowId = element.row_id;
          }
          if (element['name'].toLowerCase() != "duns") {
            this.CIdentifierTypes.push(element['name']);
            this.IdenKeywithId[element['name'].toLowerCase()] = element['row_id'];
          }
        });
      }
      this.loading = false;
    }, _error => {
      this.AllCompanyIdentifierTypes();
    });
  }

  getSiteIdenTypes(page = 1, subscribeData = []) {
    this.sitesService.getIdentifierTypebyId(this.Config.ApiSitesUrl + 'identifier-types?_page=' + page).subscribe(data => {
      if (data['identifier-types'].length > 0) {
        data['identifier-types'].forEach(ele => {
          this.siteIdentTypesData[ele.name] = ele.rowId;
        });
        if (data['maxPage'] > 1 && data['maxPage'] != page) {
          this.getSiteIdenTypes(page + 1, subscribeData);
        }
      }
    });
  }


  changeUploadDUNSBatch(event) {
    this.TextForCompleteUploadDUNS = '';
    this.readImportDUNSBatchThis(event.target);
  }
  readImportDUNSBatchThis(inputValues: any) {
    this.fileToUpload = null;
    this.fileToUpload = inputValues.files[0];
    if (!this.fileType(this.fileToUpload, 'xlsx')) {
      const reader: FileReader = new FileReader();
      reader.readAsBinaryString(this.fileToUpload);
      reader.onload = (e: any) => {
        const binarystr: string = e.target.result;
        const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: 'binary' });
        const wsname: string = wb.SheetNames[0];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];
        const data = XLSX.utils.sheet_to_json(ws).map(row =>
          Object.keys(row).reduce((obj, key) => {
            obj[key.trim()] = row[key];
            return obj;
          }, {})
        );
        this.listObjForDUNS = data;

        console.info(data);

        this.currentAlcorImportingStarted = 0;

        console.info('1')
        this.importDUNSPreReq(data);
      };
    }
  }
  importDUNSBatchThis() {
    this.showDownloadLogForDUNSBatch = false;
    this.showDownloadLogForDUNSBatchComplete = false;
    this.TextForCompleteUploadDUNS = 'Uploading...';
    this.errorMessArrImportDUNSBatch = [];
    this.logOfImportDUNSBatch = [];
    this.CountryNameKeyIds = "";
    this.CountryNameKeyIds = [];
    this.importDUNSInError = 0;
    this.noOfDUNSImported = 0;
    this.currentDUNSImporting = 0;
    localStorage.setItem("tempDUNSInFileForLocal", JSON.stringify(this.listObjForDUNS));
    this.totalDUNSToImport = this.listObjForDUNS.length;
    localStorage.setItem("totalDUNSToImport", this.listObjForDUNS.length);
    this.importDUNSStartFn(this.listObjForDUNS);
  }
  onImportDUNSClick() {
    this.uploadDocError = false
    let tempDUNSInFileForLocal = JSON.parse(localStorage.getItem('tempDUNSInFileForLocal'));
    if (tempDUNSInFileForLocal == null) {
      this.inputFileVisibleForImportDUNS = true;
      this.showDownloadLogForDUNSBatch = false;
      this.showDownloadLogForDUNSBatchComplete = false;
      this.TextForDUNSInError = '';
      this.TextForCompleteUploadDUNS = '';
    }
  }
  importDUNSPreReq(_listObjforDUNS, _currentDUNSImporting = 0, _noOfDUNSImported = 0, _importDUNSInError = 0, reload = false) {
    if (reload == false) {
      this.importDUNSBatchThis();
    }
  }
  importDUNSStartFn(listObjforDUNS, currentDUNSImporting = 0, noOfDUNSImported = 0, importDUNSInError = 0) {
    this.showDownloadLogForDUNSBatch = false;
    this.showDownloadLogForDUNSBatchComplete = false;
    this.inputFileVisibleForImportDUNS = false;
    this.TextForCompleteUploadDUNS = 'Uploading...';
    console.info("listObjforDUNS", listObjforDUNS)
    if (importDUNSInError < 1) {
      this.TextForDUNSInError = '';
    } else {
      this.TextForDUNSInError = 'Error: ' + importDUNSInError;
    }
    this.TextForCompleteUploadDUNS = 'Importing ' + noOfDUNSImported + ' of ' + (listObjforDUNS.length) + ' ';
    this.importDUNSPreReq(listObjforDUNS, currentDUNSImporting, noOfDUNSImported, importDUNSInError, true);

    if (!this.checkFileFormat('CompanyID', listObjforDUNS)) {
      currentDUNSImporting = listObjforDUNS.length;
      this.errorMessArrImportDUNSBatch.push({ "error": "Please Upload a Valid file format " });
      localStorage.setItem("errorMessArrImportDUNSBatch", JSON.stringify(this.errorMessArrImportDUNSBatch));
      importDUNSInError++;
      this.importDUNSInError = importDUNSInError;
      this.TextForDUNSInError = 'Error: ' + importDUNSInError;
      localStorage.setItem("importDUNSInError", importDUNSInError.toString());
      this.TextForCompleteUploadDUNS = 'Imported ' + noOfDUNSImported + ' of ' + (listObjforDUNS.length) + '.';
      if (importDUNSInError > 0) {
        this.TextForDUNSInError = 'Error: ' + importDUNSInError;
      }
      setTimeout(() => {
        this.showDownloadLogForDUNSBatchComplete = true;
      }, TEN_THOUSAND_MS);
      console.info("done")
      this.showDownloadLogForDUNSBatch = true;
      this.inputFileVisibleForImportDUNS = false;
      this.currentDUNSImporting = null;
      this.noOfDUNSImported = null;
      this.importDUNSInError = null;
      localStorage.setItem("currentDUNSImporting", this.currentDUNSImporting);
      localStorage.setItem("tempDUNSInFileForLocal", null);
      localStorage.setItem("noOfDUNSImported", this.noOfDUNSImported);
      localStorage.setItem("importDUNSInError", this.importDUNSInError);
    } else {
      this.importDUNSByFile(listObjforDUNS, currentDUNSImporting, noOfDUNSImported, importDUNSInError);
    }
  }
  repeatLoopFnForImportDUNS(listObjforDUNS, currentDUNSImporting, noOfDUNSImported, importDUNSInError) {
    console.info("repeating the loop")
    let twentyMinutesLater = new Date();
    let curentmni = twentyMinutesLater.setMinutes(twentyMinutesLater.getMinutes());
    console.info('curentmni', curentmni)
    if (currentDUNSImporting < listObjforDUNS.length) {
      // if ((parseInt(localStorage.getItem('expiredtime')) - curentmni <= 120000 && (parseInt(localStorage.getItem('expiredtime')) - curentmni) > 0) || (parseInt(localStorage.getItem('IDPexpiredtime')) - curentmni <= 120000 && (parseInt(localStorage.getItem('IDPexpiredtime')) - curentmni) > 0)) {
      //   this.showSessionTimeoutDUNSBatch = true
      //   setTimeout(() => {
      //     console.info('Reloading Page now');
      //     window.location.reload();
      //   }, 122000);
      // }
      // else if (parseInt(localStorage.getItem('expiredtime')) >= curentmni || parseInt(localStorage.getItem('IDPexpiredtime')) >= curentmni) {
        this.showSessionTimeoutDUNSBatch = false

        if (currentDUNSImporting % BATCH_SIZE == 0) {
          setTimeout(() => {
            currentDUNSImporting++;
            if (this.currentDUNSImportingStarted != currentDUNSImporting) {
              this.importDUNSByFile(listObjforDUNS, currentDUNSImporting, noOfDUNSImported, importDUNSInError);
              this.currentDUNSImportingStarted = currentDUNSImporting;
            }
          }, FIFTEEN_HUNDRED_MS);
        } else {
          currentDUNSImporting++;
          if (this.currentDUNSImportingStarted != currentDUNSImporting) {
            this.importDUNSByFile(listObjforDUNS, currentDUNSImporting, noOfDUNSImported, importDUNSInError);
            this.currentDUNSImportingStarted = currentDUNSImporting;
          }

        }
      // } else {
      //   window.location.reload();
      // }
    }
  }
  async importDUNSByFile(listObjforDUNS, currentDUNSImporting, noOfDUNSImported, importDUNSInError) {
    if (currentDUNSImporting < listObjforDUNS.length) {
      console.info("currentDUNSImporting - ", currentDUNSImporting + ' - Company Id:' + this.leftFillNum(listObjforDUNS[currentDUNSImporting].CompanyID, SIX))
    } else {
      console.info("currentDUNSImporting - ", currentDUNSImporting)
    }
    this.currentDUNSImporting = currentDUNSImporting
    localStorage.setItem("currentDUNSImporting", this.currentDUNSImporting);
    try {
      if (currentDUNSImporting < listObjforDUNS.length) {
        if (this.CheckForRequiredFieldsImportDUNS(listObjforDUNS, currentDUNSImporting, noOfDUNSImported, importDUNSInError)) {
          const company = await this.handleApiCall(firstValueFrom(this.supplierService.getBusinessEntities(this.Config.ApiSupplierUrl + 'business-entities?companyAllianceIdentifier=' + this.leftFillNum(listObjforDUNS[currentDUNSImporting].CompanyID, SIX) + '&isHQ=Y')), 'error in getting Company', listObjforDUNS, currentDUNSImporting, noOfDUNSImported, importDUNSInError, 'DUNS')
          if (company['business-entities'].length == 1) {
            this.logOfImportDUNSBatch.push({ "error": "Check if CompanyID:" + this.leftFillNum(listObjforDUNS[currentDUNSImporting].CompanyID, SIX) + " already exists or not?" });
            let DUNSData =
            {
              "businessEntityIdentifierTypeName": "DUNS",
              "endDate": "",
              "businessEntityIdentifierType": "OTHER",
              "businessEntityId": company['business-entities'][0].row_id,
              "businessEntityAllianceIdentifier": company['business-entities'][0].identifier,
              "businessEntityIdentifierTypeId": "2",
              "value": listObjforDUNS[currentDUNSImporting].DUNS,
              "startDate": this.apiService.getTodayDate(),
            }
            const DUNSValue = await this.handleApiCall(firstValueFrom(this.supplierService.getBusinessEntityIdentifiers(this.Config.ApiSupplierUrl + 'business-entity-identifiers?businessEntityId=' + company['business-entities'][0].row_id + '&businessEntityIdentifierTypeName=DUNS')), 'Error in getting', listObjforDUNS, currentDUNSImporting, noOfDUNSImported, importDUNSInError, 'DUNS')
            if (DUNSValue['business-entity-identifiers'].length == 0) {
              await this.handleApiCall(firstValueFrom(this.supplierService.CreateBusinessEntityIdentifiers(this.Config.ApiSupplierUrl + 'business-entity-identifiers?businessEntityId=' + company['business-entities'][0].row_id, DUNSData)), " Error in Updating DUNS in business-entity-identifiers", listObjforDUNS, currentDUNSImporting, noOfDUNSImported, importDUNSInError, 'DUNS')
              noOfDUNSImported++;
              this.TextForCompleteUploadDUNS = 'Importing ' + noOfDUNSImported + ' of ' + (listObjforDUNS.length) + ' ';
              localStorage.setItem("noOfDUNSImported", noOfDUNSImported);
              this.repeatLoopFnForImportDUNS(listObjforDUNS, currentDUNSImporting, noOfDUNSImported, importDUNSInError);
            } else {
              const value = await this.handleApiCall(firstValueFrom(this.supplierService.getBusinessEntityIdentifiers(this.Config.ApiSupplierUrl + 'business-entity-identifiers?businessEntityId=' + company['business-entities'][0].row_id + '&row_id=' + DUNSValue['business-entity-identifiers'][0].row_id + '&businessEntityIdentifierTypeName=DUNS')), 'Erron in getting business-entity-identifiers', listObjforDUNS, currentDUNSImporting, noOfDUNSImported, importDUNSInError, 'DUNS')
              let DUNSData1 = {
                "value": listObjforDUNS[currentDUNSImporting].DUNS,
                "businessEntityIdentifierTypeName": "DUNS",
                "businessEntityIdentifierTypeId": "2",
                "row_id": value['business-entity-identifiers'][0].row_id,
                "startDate": value['business-entity-identifiers'][0].startDate,
              }
              await this.handleApiCall(firstValueFrom(this.supplierService.updateBusinessEntityIdentifiers(this.Config.ApiSupplierUrl + 'business-entity-identifiers/' + value['business-entity-identifiers'][0].row_id, DUNSData1)), 'Error in Updating DUNS in business-entity-identifiers', listObjforDUNS, currentDUNSImporting, noOfDUNSImported, importDUNSInError, 'DUNS')
              noOfDUNSImported++;
              this.TextForCompleteUploadDUNS = 'Importing ' + noOfDUNSImported + ' of ' + (listObjforDUNS.length) + ' ';
              localStorage.setItem("noOfDUNSImported", noOfDUNSImported);
              this.repeatLoopFnForImportDUNS(listObjforDUNS, currentDUNSImporting, noOfDUNSImported, importDUNSInError);
            }
          }
          else if (company['business-entities'].length > 1) {
            this.LogErrorforImportDUNS(listObjforDUNS, currentDUNSImporting, noOfDUNSImported, importDUNSInError, " is having more than 1 Headquaters")
          } else {
            this.LogErrorforImportDUNS(listObjforDUNS, currentDUNSImporting, noOfDUNSImported, importDUNSInError, " is not Found ")
          }
        }
      }
    } catch (error) {
      console.info(error)
      this.errorMessArrImportDUNSBatch.push({ "error": "Company Id:" + this.leftFillNum(listObjforDUNS[currentDUNSImporting].CompanyID, SIX) + "- Error occured while importing " });
      localStorage.setItem("errorMessArrImportDUNSBatch", JSON.stringify(this.errorMessArrImportDUNSBatch));
      this.TextForCompleteUploadDUNS = 'Imported ' + noOfDUNSImported + ' of ' + (listObjforDUNS.length) + '.';
      if (importDUNSInError > 0) {
        this.TextForDUNSInError = 'Error: ' + importDUNSInError;
      }
      setTimeout(() => {
        this.showDownloadLogForDUNSBatchComplete = true;

      }, TEN_THOUSAND_MS);
      console.info("done")
      this.showDownloadLogForDUNSBatch = true;
      this.inputFileVisibleForImportDUNS = false;
      this.currentDUNSImporting = null;
      this.noOfDUNSImported = null;
      this.importDUNSInError = null;
      localStorage.setItem("currentDUNSImporting", this.currentDUNSImporting);
      localStorage.setItem("tempDUNSInFileForLocal", null);
      localStorage.setItem("noOfDUNSImported", this.noOfDUNSImported);
      localStorage.setItem("importDUNSInError", this.importDUNSInError);
    }
    if (currentDUNSImporting == listObjforDUNS.length) {
      setTimeout(() => {
        this.TextForCompleteUploadDUNS = 'Imported ' + noOfDUNSImported + ' of ' + (listObjforDUNS.length) + '.';
        if (importDUNSInError > 0) {
          this.TextForDUNSInError = 'Error: ' + importDUNSInError;
        }
        setTimeout(() => {
          this.showDownloadLogForDUNSBatchComplete = true;
        }, TEN_THOUSAND_MS);
        console.info("done")
        this.showDownloadLogForDUNSBatch = true;
        this.inputFileVisibleForImportDUNS = false;
        this.currentDUNSImporting = null;
        this.noOfDUNSImported = null;
        this.importDUNSInError = null;
        localStorage.setItem("currentDUNSImporting", this.currentDUNSImporting);
        localStorage.setItem("tempDUNSInFileForLocal", null);
        localStorage.setItem("noOfDUNSImported", this.noOfDUNSImported);
        localStorage.setItem("importDUNSInError", this.importDUNSInError);
      }, THREE_THOUSAND_MS);
    }
  }
  CheckForRequiredFieldsImportDUNS(listObjforDUNS, currentDUNSImporting, noOfDUNSImported, importDUNSInError) {
    let isrequired = true;
    let keys = ['CompanyID', 'DUNS']
    keys.forEach(field => {
      if (this.IsNullValue(listObjforDUNS[currentDUNSImporting][field])) {
        this.errorMessArrImportDUNSBatch.push({ "error": "There is no value for " + field });
        localStorage.setItem("errorMessArrImportDUNSBatch", JSON.stringify(this.errorMessArrImportDUNSBatch));
        importDUNSInError++;
        this.importDUNSInError = importDUNSInError;
        this.TextForAlcorInError = 'Error: ' + importDUNSInError;
        localStorage.setItem("importDUNSInError", importDUNSInError);
        this.repeatLoopFnForImportDUNS(listObjforDUNS, currentDUNSImporting, noOfDUNSImported, importDUNSInError);
        isrequired = false;
      } else {
        if (field == 'DUNS') {
          if (listObjforDUNS[currentDUNSImporting].DUNS.toString().length < DUNS_LENGTH) {
            this.errorMessArrImportDUNSBatch.push({ "error": "DUNS: " + this.leftFillNum(listObjforDUNS[currentDUNSImporting].DUNS, SIX) + " length is not Correct" });
            localStorage.setItem("errorMessArrImportDUNSBatch", JSON.stringify(this.errorMessArrImportDUNSBatch));
            importDUNSInError++;
            this.importDUNSInError = importDUNSInError;
            this.TextForDUNSInError = 'Error: ' + importDUNSInError;
            localStorage.setItem("importDUNSInError", importDUNSInError.toString());
            this.repeatLoopFnForImportDUNS(listObjforDUNS, currentDUNSImporting, noOfDUNSImported, importDUNSInError);
          }
        }
      }
    })
    return isrequired;
  }
  downloadLogFileForImportDUNSBatch() {
    let element = document.getElementById('excelTableLogForImportDUNSBatch');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Import DUNS Batch');
    XLSX.writeFile(wb, 'ImportDUNSBatch.xlsx');
  }

  downloadLogFileForLogOfImportDUNSBatch() {
    let element = document.getElementById('excelTableLogForLogOfImportDUNSBatch');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Import DUNS Batch complete log');
    XLSX.writeFile(wb, 'ImportDUNSBatchCompleteLog.xlsx');
  }
  checkLocalStorageForImpDUNS() {
    let tempDUNSInFileForLocal = JSON.parse(localStorage.getItem('tempDUNSInFileForLocal'));
    let errorMessArrImportDUNSBatch = (localStorage.getItem('errorMessArrImportDUNSBatch') == null || localStorage.getItem('errorMessArrImportDUNSBatch') == undefined ||
      localStorage.getItem('errorMessArrImportDUNSBatch') == '') ? null : JSON.parse(localStorage.getItem('errorMessArrImportDUNSBatch'));
    let logOfImportDUNSBatch = JSON.parse(localStorage.getItem('logOfImportDUNSBatch'));
    let currentDUNSImporting = localStorage.getItem("currentDUNSImporting");
    let noOfDUNSImported = localStorage.getItem("noOfDUNSImported");
    let importDUNSInError = localStorage.getItem("importDUNSInError");
    let totalDUNSToImport = localStorage.getItem("totalDUNSToImport");
    console.info("no of DUNS rows complete", localStorage.getItem("currentDUNSImporting"))
    console.info("no of DUNS already uploaded ", localStorage.getItem("noOfDUNSImported"))
    console.info("no of DUNS in error ", localStorage.getItem("importDUNSInError"))
    console.info("no of DUNS in total ", localStorage.getItem("totalDUNSToImport"))
    if (currentDUNSImporting != null && currentDUNSImporting != 'null') {

      if (noOfDUNSImported == null || noOfDUNSImported == 'null') {
        noOfDUNSImported = '0';
      }
      if (importDUNSInError == null || importDUNSInError == 'null') {
        importDUNSInError = '0';
      }

      if (errorMessArrImportDUNSBatch == null || errorMessArrImportDUNSBatch == 'null') {
        this.errorMessArrImportDUNSBatch = [];
      } else {
        this.errorMessArrImportDUNSBatch = errorMessArrImportDUNSBatch;
      }
      if (logOfImportDUNSBatch == null || logOfImportDUNSBatch == 'null') {
        this.logOfImportDUNSBatch = [];
      } else {
        this.logOfImportDUNSBatch = logOfImportDUNSBatch;
      }
      if (totalDUNSToImport == null || totalDUNSToImport == 'null') {
        this.totalDUNSToImport = '0';
      } else {
        this.totalDUNSToImport = totalDUNSToImport;
      }
      console.info("exc alcor")


      setTimeout(() => {
        this.importDUNSPreReqForReload(tempDUNSInFileForLocal, parseInt(currentDUNSImporting), parseInt(noOfDUNSImported), parseInt(importDUNSInError));
      }, FIFTEEN_HUNDRED_MS);

      document.getElementById('btnForImportDUNSBatch').click();
      this.inputFileVisibleForImportDUNS = false;
    } else {
      this.inputFileVisibleForImportDUNS = true;
      this.TextForCompleteUploadDUNS = "";
      this.errorMessArrImportDUNSBatch = [];
      this.logOfImportDUNSBatch = [];
      this.totalDUNSToImport = null;
      this.currentDUNSImporting = null;
      localStorage.setItem("errorMessArrImportDUNSBatch", null);
      localStorage.setItem("logOfImportDUNSBatch", null);
      localStorage.setItem("totalDUNSToImport", this.totalDUNSToImport);

      this.TextForAlcorInError = "";

    }
  }
  checkLocalStorageForImpBvd() {
    let tempBvdIdInFileForLocal = JSON.parse(localStorage.getItem('tempBvdIdInFileForLocal'));
    this.listObjForBvdId = tempBvdIdInFileForLocal;
    let errorMessArrImportBvdIdBatch = (localStorage.getItem('errorMessArrImportBvdIdBatch') == null || localStorage.getItem('errorMessArrImportBvdIdBatch') == undefined ||
      localStorage.getItem('errorMessArrImportBvdIdBatch') == '') ? null : JSON.parse(localStorage.getItem('errorMessArrImportBvdIdBatch'));

    let currentBvdIdImporting = localStorage.getItem("currentBvdIdImporting");
    let noOfBvdIdImported = localStorage.getItem("noOfBvdIdImported");
    let importBvdIdInError = localStorage.getItem("importBvdIdInError");

    console.info("no of BVD rows complete", localStorage.getItem("currentBvdIdImporting"))
    console.info("no of BVD already uploaded ", localStorage.getItem("noOfBvdIdImported"))
    console.info("no of BVD in error ", localStorage.getItem("importBvdIdInError"))
    if (currentBvdIdImporting != null && currentBvdIdImporting != 'null') {

      if (noOfBvdIdImported == null || noOfBvdIdImported == 'null') {
        noOfBvdIdImported = '0';
      }
      if (importBvdIdInError == null || importBvdIdInError == 'null') {
        importBvdIdInError = '0';
      }

      if (errorMessArrImportBvdIdBatch == null || errorMessArrImportBvdIdBatch == 'null') {
        this.errorMessArrImportBvdIdBatch = [];
      } else {
        this.errorMessArrImportBvdIdBatch = errorMessArrImportBvdIdBatch;
      }
      console.info("exc alcor")
      setTimeout(() => {
        this.importBvdIdByFile(tempBvdIdInFileForLocal, parseInt(currentBvdIdImporting), parseInt(noOfBvdIdImported), parseInt(importBvdIdInError));
        document.getElementById('btnForImportBvdIdBatch').click();
      }, FIFTEEN_HUNDRED_MS);
      this.inputFileVisibleForImportBvdId = false;
    } else {
      this.inputFileVisibleForImportBvdId = true;
      this.TextForCompleteUploadBvdId = "";
      this.errorMessArrImportBvdIdBatch = [];
      this.logOfImportBvdIdBatch = [];
      this.totalBvdIdToImport = null;
      this.currentBvdIdImporting = null;
      localStorage.setItem("errorMessArrImportBvdIdBatch", null);
      localStorage.setItem("logOfImportBvdIdBatch", null);
      localStorage.setItem("totalBvdIdToImport", this.totalBvdIdToImport);

      this.TextForBvdIdInError = "";

    }
  }
  checkLocalStorageForImpTax() {
    let errorMessArrImportTaxBatch = (localStorage.getItem('errorMessArrImportTaxBatch') == null || localStorage.getItem('errorMessArrImportTaxBatch') == undefined ||
      localStorage.getItem('errorMessArrImportTaxBatch') == '') ? null : JSON.parse(localStorage.getItem('errorMessArrImportTaxBatch'));
    let currentTaxImporting = localStorage.getItem("currentTaxImporting");
    let noOfTaxImported = localStorage.getItem("noOfTaxImported");
    let totalTaxToImport = localStorage.getItem("totalTaxToImport");
    let listObjForTax = JSON.parse(localStorage.getItem("listObjForTax"))
    let noOfTaxinError = localStorage.getItem("noOfTaxinError")
    let taxImportedAlready = JSON.parse(localStorage.getItem("taxImportedAlready"))


    let selectedcomp = localStorage.getItem("selectedCompany");

    console.info("no of company  rows complete", localStorage.getItem("currentTaxImporting"))
    console.info("no of company already added with TAx identifiers ", localStorage.getItem("noOfTaxImported"))
    console.info("no of company in total ", localStorage.getItem("totalTaxToImport"))
    if (currentTaxImporting != null && currentTaxImporting != 'null' && currentTaxImporting != '') {
      this.currentTaxImporting = currentTaxImporting;
      if (selectedcomp == null || selectedcomp == 'null' || selectedcomp == '') {
        this.AvalueSelected = [];

      } else {
        this.AvalueSelected = [];
        this.AvalueSelected.push(selectedcomp)
      }
      if (noOfTaxinError == null || noOfTaxinError == 'null' || selectedcomp == '') {
        this.noOfTaxinError = 0;

      } else {
        this.noOfTaxinError = parseInt(noOfTaxinError);
      }
      if (errorMessArrImportTaxBatch == null || errorMessArrImportTaxBatch == 'null') {
        this.errorMessArrImportTaxBatch = [];
      } else {
        this.errorMessArrImportTaxBatch = errorMessArrImportTaxBatch;
      }
      if (listObjForTax == null || listObjForTax == 'null') {
        this.companyIds = [];
      }
      else {

        this.companyIds = listObjForTax;

      }
      if (totalTaxToImport == null || totalTaxToImport == 'null') {
        this.totalTaxToImport = 0;
      } else {
        this.totalTaxToImport = totalTaxToImport;

      }
      if (taxImportedAlready == null || taxImportedAlready == 'null') {
        this.taxImportedAlready = [];
      } else {
        this.taxImportedAlready = taxImportedAlready;

      }
      console.info("exc alcor")


      setTimeout(() => {
        this.importTaxPreReqForReload(parseInt(currentTaxImporting), parseInt(noOfTaxImported));
      }, FIFTEEN_HUNDRED_MS);

      document.getElementById('btnForImportTaxBatch').click();
      this.updateTaxStarted = false;
    } else {
      this.updateTaxStarted = true;
      this.TextForCompleteUploadTax = "";
      this.ImportTAxDisplayMsg = ""
      this.errorMessArrImportTaxBatch = [];
      this.totalTaxToImport = null;
      this.currentDUNSImporting = null;
      this.AvalueSelected = [];
      this.companyAliasAll = []
      this.taxImportedAlready = []
      localStorage.setItem("listObjForTax", null);
      localStorage.setItem("noOfTaxImported", null);
      localStorage.setItem("currentTaxImporting", null);
      localStorage.setItem("totalTaxToImport", null);
      localStorage.setItem("taxImportedAlready", null);
      localStorage.setItem("errorMessArrImportTaxBatch", null);
      this.TextForTaxInError = "";
      localStorage.setItem("noOfTaxinError", null);


    }
  }
  importDUNSPreReqForReload(listObjforDUNS, currentDUNSImporting = 0, noOfDUNSImported = 0, importDUNSInError = 0) {
    this.importDUNSStartFn(listObjforDUNS, currentDUNSImporting, noOfDUNSImported, importDUNSInError)
  }
  importTaxPreReqForReload(currentTaxImporting = 0, noOfTaxImported = 0, _importTaxInError = 0) {
    this.updateTaxStarted = true;
    this.activityLoaded = true;
    this.ImportTAxDisplayMsg = 'Importing ' + currentTaxImporting + ' of ' + noOfTaxImported
    this.updateidentifiers(currentTaxImporting)
  }

  changeImportSaerSupplierBatch($event) {
    this.TextForCompleteUploadImportSaer = '';
    this.readImportSaerSupplierBatchThis($event.target);
  }
  readImportSaerSupplierBatchThis(inputValue: any) {
    this.fileToUpload = null;
    this.fileToUpload = inputValue.files[0];

    if (!this.fileType(this.fileToUpload, 'xlsx')) {
      const reader: FileReader = new FileReader();
      reader.readAsBinaryString(this.fileToUpload);


      reader.onload = (e: any) => {
        const binarystr: string = e.target.result;
        const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: 'binary' });
        const wsname: string = wb.SheetNames[0];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];
        this.SaerHeaders = XLSX.utils.sheet_to_json(ws, { header: 1 })[0];
        const data = XLSX.utils.sheet_to_json(ws).map(row =>
          Object.keys(row).reduce((obj, key) => {
            obj[key.trim()] = row[key];
            return obj;
          }, {})
        );
        this.listObjForSaer = data;

        console.info(data);
        this.importSaerPreReq();
        this.CompanyStatusAll = [];

        this.importSaerSupplierBatchThis();
      };
    }
  }
  onImportSaerClick() {
    this.uploadDocError = false
    let tempSaerInFileForLocal = JSON.parse(localStorage.getItem('tempSaerInFileForLocal'));
    if (tempSaerInFileForLocal == null) {
      this.inputFileVisibleForImportSaer = true;
      this.showDownloadLogForSaerBatch = false;
      this.TextForCompleteUploadImportSaer = '';
      this.TextForSaerInError = '';
      this.errorMessArrImportSaerBatch = [];
    }
  }
  importSaerPreReq() {

    this.supplierService.getCompanySatus(this.Config.ApiSupplierUrl + 'company-status').subscribe((data: any) => {

      data['company-status'].forEach(element10 => {
        if (element10['code'] == 'Approved') {
          this.CompanyStatusAll.push(element10);
        }
        if (element10['code'] == 'Identified') {
          this.CompanyStatusAllForGuo.push(element10);
        }
      });
    });
    this.getSiteIdenTypes();
    this.getSourceSytemId();
    this.busEntIdentifiers();
    this.getCpyShortNameTypes();
    this.AllCompanyIdentifierTypes();

  }
  importSaerPreReqonReload(listObjForSaer, currentSaerImporting, noOfSaerImported, importSaerInError) {

    setTimeout(() => {
      this.supplierService.getCompanySatus(this.Config.ApiSupplierUrl + 'company-status').subscribe((data: any) => {

        data['company-status'].forEach(element10 => {
          if (element10['code'] == 'Approved') {
            this.CompanyStatusAll.push(element10);
          }
          if (element10['code'] == 'Identified') {
            this.CompanyStatusAllForGuo.push(element10);
          }
        });
        this.getSiteIdenTypes();
        this.getSourceSytemId();
        this.busEntIdentifiers();
        this.getCpyShortNameTypes();
        this.AllCompanyIdentifierTypes();
        this.importSaerByFileFunction(listObjForSaer, currentSaerImporting, noOfSaerImported, importSaerInError)

      }, (_err) => {
        currentSaerImporting = listObjForSaer.length;
        this.errorMessArrImportSaerBatch.push({
          "error": 'ERROR : Creating getting  company-status'
        });
        localStorage.setItem("errorMessArrImportSaerBatch", JSON.stringify(this.errorMessArrImportSaerBatch));
        importSaerInError++;
        this.importSaerInError = importSaerInError;
        this.TextForCompleteUploadImportSaer = 'Imported ' + noOfSaerImported + ' of ' + (listObjForSaer.length) + '.';
        if (importSaerInError > 0) {
          this.TextForSaerInError = 'Error: ' + importSaerInError;
        }
        setTimeout(() => {
        this.showDownloadLogForSaerBatchComplete = true;
      }, TEN_THOUSAND_MS)
        console.info("done")
        this.showDownloadLogForSaerBatch = true;
        this.inputFileVisibleForImportSaer = false;
        this.currentSaerImporting = null;
        this.noOfSaerImported = null;
        this.importSaerInError = null;
        localStorage.setItem("currentSaerImporting", this.currentSaerImporting);
        localStorage.setItem("tempSaerInFileForLocal", null);
        localStorage.setItem("noOfSaerImported", this.noOfSaerImported);
        localStorage.setItem("importSaerInError", this.importSaerInError);
      });

    }, TEN_THOUSAND_MS)
  }
  importSaerSupplierBatchThis() {
    this.showDownloadLogForSaerBatch = false;

    this.TextForCompleteUploadImportSaer = 'Uploading...';
    this.errorMessArrImportSaerBatch = [];
    this.CountryNameKeyIds = "";
    this.CountryNameKeyIds = [];
    this.importSaerInError = 0;
    this.noOfSaerImported = 0;
    this.currentSaerImporting = 0;
    localStorage.setItem("tempSaerInFileForLocal", JSON.stringify(this.listObjForSaer));
    this.totalSaerToImport = this.listObjForSaer.length.toString();
    localStorage.setItem("totalSaerToImport", this.listObjForSaer.length.toString());
    this.importSaerStartFn(this.listObjForSaer)
  }

  checkLocalStorageForImpSaer() {
    let tempSaerInFileForLocal = JSON.parse(localStorage.getItem('tempSaerInFileForLocal'));
    this.listObjForSaer = tempSaerInFileForLocal;
    let errorMessArrImportSaerBatch = (localStorage.getItem('errorMessArrImportSaerBatch') == null || localStorage.getItem('errorMessArrImportSaerBatch') == undefined ||
    localStorage.getItem('errorMessArrImportSaerBatch') == '') ? null : JSON.parse(localStorage.getItem('errorMessArrImportSaerBatch'));
    let logOfImportSaerBatch = JSON.parse(localStorage.getItem('logOfImportSaerBatch'));
    let currentSaerImporting = localStorage.getItem("currentSaerImporting");
    let noOfSaerImported = localStorage.getItem("noOfSaerImported");
    let importSaerInError = localStorage.getItem("importSaerInError");
    let totalSaerToImport = localStorage.getItem("totalSaerToImport");
    console.info("no of Saer rows complete", localStorage.getItem("currentSaerImporting"))
    console.info("no of Saer already uploaded ", localStorage.getItem("noOfSaerImported"))
    console.info("no of Saer in error ", localStorage.getItem("importSaerInError"))
    console.info("no of Saer in total ", localStorage.getItem("totalSaerToImport"))
    if (currentSaerImporting != null && currentSaerImporting != 'null') {
      if (noOfSaerImported == null || noOfSaerImported == 'null') {
        noOfSaerImported = '0';
      }
      if (importSaerInError == null || importSaerInError == 'null') {
        importSaerInError = '0';
      }
      if (errorMessArrImportSaerBatch == null || errorMessArrImportSaerBatch == 'null') {
        this.errorMessArrImportSaerBatch = [];
      } else {
        this.errorMessArrImportSaerBatch = errorMessArrImportSaerBatch;
      }
      if (logOfImportSaerBatch == null || logOfImportSaerBatch == 'null') {
        this.logOfImportSaerBatch = [];
      } else {
        this.logOfImportSaerBatch = logOfImportSaerBatch;
      }
      if (totalSaerToImport == null || totalSaerToImport == 'null') {
        this.totalSaerToImport = '0';
      } else {
        this.totalSaerToImport = totalSaerToImport;
      }
      console.info("exc saer")
      setTimeout(() => {
        this.importSaerPreReqonReload(tempSaerInFileForLocal, parseInt(currentSaerImporting), parseInt(noOfSaerImported), parseInt(importSaerInError));
      }, FIFTEEN_HUNDRED_MS);

      document.getElementById('btnForImportSaerBatch').click();
      this.updateSaerProgress(parseInt(noOfSaerImported), parseInt(importSaerInError), tempSaerInFileForLocal.length)
      this.inputFileVisibleForImportSaer = false;
    } else {
      this.inputFileVisibleForImportSaer = true;
      this.TextForCompleteUploadImportSaer = "";
      this.errorMessArrImportSaerBatch = [];
      this.logOfImportSaerBatch = [];
      this.totalSaerToImport = null;
      localStorage.setItem("errorMessArrImportSaerBatch", null);
      localStorage.setItem("logOfImportSaerBatch", null);
      localStorage.setItem("totalSaerToImport", this.totalSaerToImport);
      this.TextForSaerInError = "";
    }
  }

  importSaerStartFn(listObjForSaer, currentSaerImporting = 0, noOfSaerImported = 0, importSaerInError = 0) {
    this.showDownloadLogForSaerBatch = false;
    this.showDownloadLogForSaerBatchComplete = false;
    this.inputFileVisibleForImportSaer = false;
    this.TextForCompleteUploadImportSaer = 'Uploading...';
    console.info("listObjForSaer", listObjForSaer)
    if (importSaerInError < 1) {
      this.TextForSaerInError = '';
    } else {
      this.TextForSaerInError = 'Error: ' + importSaerInError;
    }
    this.TextForCompleteUploadImportSaer = 'Importing ' + noOfSaerImported + ' of ' + (listObjForSaer.length) + ' ';
    if (!this.checkFileFormat('SAER_CODE', listObjForSaer)) {
      currentSaerImporting = listObjForSaer.length;
      this.errorMessArrImportSaerBatch.push({ "error": "Please Upload a Valid file format " });
      localStorage.setItem("errorMessArrImportSaerBatch", JSON.stringify(this.errorMessArrImportSaerBatch));
      importSaerInError++;
      this.importSaerInError = importSaerInError;
      this.TextForSaerInError = 'Error: ' + importSaerInError;
      localStorage.setItem("importSaerInError", importSaerInError.toString());

      this.TextForCompleteUploadImportSaer = 'Imported ' + noOfSaerImported + ' of ' + (listObjForSaer.length) + '.';
      if (importSaerInError > 0) {
        this.TextForSaerInError = 'Error: ' + importSaerInError;
      }
      setTimeout(() => {
        this.showDownloadLogForSaerBatchComplete = true;
      }, TEN_THOUSAND_MS);
      console.info("done")
      this.showDownloadLogForSaerBatch = true;
      this.inputFileVisibleForImportSaer = false;
      this.currentSaerImporting = null;
      this.noOfSaerImported = null;
      this.importSaerInError = null;
      localStorage.setItem("currentSaerImporting", this.currentSaerImporting);
      localStorage.setItem("tempSaerInFileForLocal", null);
      localStorage.setItem("noOfSaerImported", this.noOfSaerImported);
      localStorage.setItem("importSaerInError", this.importSaerInError);
    } else {
      this.importSaerByFileFunction(listObjForSaer, currentSaerImporting, noOfSaerImported, importSaerInError);
    }
  }
  async importSaerByFileFunction(listObjForSaer, currentSaerImporting, noOfSaerImported, importSaerInError) {
    if (currentSaerImporting < listObjForSaer.length) {
      console.info("currentSaerImporting - ", currentSaerImporting + ' - SAER CODE:' + listObjForSaer[currentSaerImporting]['SAER-CODE'])
    } else {
      console.info("currentSaerImporting - ", currentSaerImporting)
    }
    this.currentSaerImporting = currentSaerImporting;
    this.startUpload = 0; // Reset startUpload at the beginning of each iteration
    localStorage.setItem("currentSaerImporting", this.currentSaerImporting.toString());
    try {
      if (currentSaerImporting < listObjForSaer.length) {
        let BvDAssignBvd = listObjForSaer[currentSaerImporting]['BVD-ID']
        let data
        let param
        let saerCode = await this.handleApiCall(this.sitesService.getAccessPointIdentifiers(this.Config.ApiSitesUrl + 'access-point-identifiers?identifierTypeName=SAER_CODE&identifierValue=' + listObjForSaer[currentSaerImporting]['SAER-CODE']).toPromise(), 'Error in getting accesspointIdentifier', listObjForSaer, currentSaerImporting, noOfSaerImported, importSaerInError, 'saer')
        if (saerCode['access-point-identifiers'].length == 0) {
          if (/^ST\d{8}$/.test(BvDAssignBvd)) {
            data = await this.handleApiCall(this.sitesService.getSites(this.Config.ApiSitesUrl + 'sites?identifier=' + BvDAssignBvd).toPromise(), 'Error in getting site assignments', listObjForSaer, currentSaerImporting, noOfSaerImported, importSaerInError, 'saer')
            if (data['sites'].length == 1) {
              this.startUpload = 1
              param = 'reaIdentifier=' + BvDAssignBvd
            } else if (data['sites'].length > 1) {
              this.startUpload = TWO
            }
          } else {
            data = await this.handleApiCall(this.supplierService.getBusinessEntityIdentifiers(this.Config.ApiSupplierUrl + 'business-entity-identifiers?businessEntityIdentifierTypeName=BVD ID&value=' + BvDAssignBvd).toPromise(), 'Error in getting business entity identifiers', listObjForSaer, currentSaerImporting, noOfSaerImported, importSaerInError, 'saer')
            if (data['business-entity-identifiers'].length == 1) {
              this.startUpload = 1
              param = 'businessEntityAllianceIdentifier=' + data['business-entity-identifiers'][0]['businessEntityAllianceIdentifier']
            } else if (data['business-entity-identifiers'].length > 1) {
              this.startUpload = TWO
            }
          }
          if (this.startUpload == 1) {
            if ((listObjForSaer[currentSaerImporting]['SAER-CODE'] != undefined && listObjForSaer[currentSaerImporting]['SAER-CODE'] != '' && !isNaN(listObjForSaer[currentSaerImporting]['SAER-CODE']) && (listObjForSaer[currentSaerImporting]['SAER-CODE']).toString().length == EIGHT)) {
              if ((listObjForSaer[currentSaerImporting]['SAER-NAME'] != undefined && listObjForSaer[currentSaerImporting]['SAER-NAME'] != '') && listObjForSaer[currentSaerImporting]['SAER-NAME'].length <= TEN) {

                let siteAssgnData = await this.handleApiCall(this.supplierService.getSiteAssignments(this.Config.ApiSupplierUrl + 'site-assignments?' + param).toPromise(), 'Error in getting site assignments', listObjForSaer, currentSaerImporting, noOfSaerImported, importSaerInError, 'saer')
                if (siteAssgnData['site-assignments'].length > 0) {
                  const rowId = siteAssgnData['site-assignments'][0]['site']['href'].split('/')
                  const siteIdentifierFromAssignment = siteAssgnData['site-assignments'][0]['reaIdentifier'];
                  const siteDatas = {
                    activeStatus: 'ACTIVE',
                    realEstateAssetId: rowId[1],
                    label: siteAssgnData['site-assignments'][0]['businessEntityCompanyLegalName'],
                    type: 'P11',
                    effectiveDate: this.apiService.getTodayDate(),
                    irnAuthor: 'IRN-71016',
                    siaAuthor: 'IAF',
                    activity: 'A10'
                  };
                  this.sitesService.createAccessPoint(this.Config.ApiSitesUrl + 'access-points', siteDatas).pipe(

                    concatMap((acpCreation: any) => {
                      const acpRowId = acpCreation['rowId'];
                      return this.sitesService
                        .getAccessPoints(this.Config.ApiSitesUrl + 'access-points?siteIdentifier=' + siteIdentifierFromAssignment + '&type=in(' + "'P14'" + ')')
                        .pipe(
                          concatMap((p14Data: any) => {
                            const p14Identifier = p14Data && p14Data['access-points'] && p14Data['access-points'][0] ? p14Data['access-points'][0]['identifier'] : null;
                            if (!p14Identifier) {
                              return of({ acpCreation, acpRowId });
                            }
                            return this.sitesService
                              .getAccessPointAddresses(this.Config.ApiSitesUrl + 'access-points-addresses?accessPointIdentifier=' + p14Identifier)
                              .pipe(
                                concatMap((addrData: any) => {
                                  const addrList = (addrData && addrData['access-points-addresses']) ? addrData['access-points-addresses'] : [];
                                  if (!addrList.length) {
                                    return of({ acpCreation, acpRowId });
                                  }
                                  const createCalls = addrList.map((a: any) => {
                                    const payload = { accessPointId: acpRowId, addressId: a['addressId'] };
                                    return this.sitesService.createAccessPointAddress(this.Config.ApiSitesUrl + 'access-points-addresses', payload);
                                  });
                                  return forkJoin(createCalls).pipe(map(() => ({ acpCreation, acpRowId })));
                                })
                              );
                          })
                        );
                    }),

                    concatMap(({ acpCreation, acpRowId }: { acpCreation: any; acpRowId: any }) => {
                      const siteDatasSaerCode = {
                        identifierId: this.siteIdentTypesData['SAER_CODE'],
                        sourceSystemId: this.siteSourceSystems['SAER'],
                        accessPointRowId: acpRowId,
                        identifierValue: listObjForSaer[currentSaerImporting]['SAER-CODE'],
                        siteIdentifier: acpCreation['siteIdentifier'],
                        accessPointIdentifier: acpCreation['identifier'],
                        effectiveDate: this.apiService.getTodayDate()
                      };
                      return this.sitesService.createAccessPointIdentifier(this.Config.ApiSitesUrl + 'access-point-identifiers', siteDatasSaerCode).pipe(
                        map(() => ({ acpCreation, acpRowId }))
                      );
                    }),

                    concatMap(({ acpCreation, acpRowId }: { acpCreation: any; acpRowId: any }) => {
                      const siteDatasSaerName = {
                        identifierId: this.siteIdentTypesData['SOCIAL_RAISON'],
                        sourceSystemId: this.siteSourceSystems['SAER'],
                        accessPointRowId: acpRowId,
                        identifierValue: listObjForSaer[currentSaerImporting]['SAER-NAME'],
                        siteIdentifier: acpCreation['siteIdentifier'],
                        accessPointIdentifier: acpCreation['identifier'],
                        effectiveDate: this.apiService.getTodayDate()
                      };
                      return this.sitesService.createAccessPointIdentifier(this.Config.ApiSitesUrl + 'access-point-identifiers', siteDatasSaerName);
                    }),

                    concatMap(() => {
                      const siteId = rowId[1];
                      return from(this.blankupdate.siteBlankStatusUpdateAsync(siteId));
                    })
                  ).subscribe({
                    next: () => {
                      noOfSaerImported++;
                      this.updateSaerProgress(noOfSaerImported, importSaerInError, listObjForSaer.length)
                      this.repeatLoopFnForImportSaer(listObjForSaer, currentSaerImporting, noOfSaerImported, importSaerInError);
                    },
                    error: (err) => {
                      this.errorMessArrImportSaerBatch.push({ "error": "BVD-ID: " + listObjForSaer[currentSaerImporting]['BVD-ID'] + " SAER creation failed: " + (err?.message || err) });
                      importSaerInError++;
                      this.updateSaerProgress(noOfSaerImported, importSaerInError, listObjForSaer.length);
                      this.repeatLoopFnForImportSaer(listObjForSaer, currentSaerImporting, noOfSaerImported, importSaerInError);
                      localStorage.setItem("errorMessArrImportSaerBatch", JSON.stringify(this.errorMessArrImportSaerBatch));
                      this.importSaerInError = importSaerInError;
                    }
                  })
                } else {
                  // No site assignments found - log error and continue
                  console.info("[SAER-IMPORT] No site assignments found for BVD-ID:", listObjForSaer[currentSaerImporting]['BVD-ID']);
                  this.errorMessArrImportSaerBatch.push({ "error": "BVD-ID: " + listObjForSaer[currentSaerImporting]['BVD-ID'] + " No site assignments found" });
                  importSaerInError++;
                  this.updateSaerProgress(noOfSaerImported, importSaerInError, listObjForSaer.length);
                  this.repeatLoopFnForImportSaer(listObjForSaer, currentSaerImporting, noOfSaerImported, importSaerInError);
                  localStorage.setItem("errorMessArrImportSaerBatch", JSON.stringify(this.errorMessArrImportSaerBatch));
                  this.importSaerInError = importSaerInError;
                }
              } else {
                console.info("[SAER-IMPORT] SAER Names is Not OK:", listObjForSaer[currentSaerImporting]['BVD-ID']);
                this.errorMessArrImportSaerBatch.push({ "error": "BVD-ID: " + listObjForSaer[currentSaerImporting]['BVD-ID'] + " Saer Name " + listObjForSaer[currentSaerImporting]['SAER-NAME'] + " is not OK" });
                importSaerInError++;
                this.updateSaerProgress(noOfSaerImported, importSaerInError, listObjForSaer.length)
                this.repeatLoopFnForImportSaer(listObjForSaer, currentSaerImporting, noOfSaerImported, importSaerInError);
                localStorage.setItem("errorMessArrImportSaerBatch", JSON.stringify(this.errorMessArrImportSaerBatch));
                this.importSaerInError = importSaerInError;
              }
            } else {
              console.info("[SAER-IMPORT] SAER Codes is Not OK:", listObjForSaer[currentSaerImporting]['BVD-ID']);
              this.errorMessArrImportSaerBatch.push({ "error": "BVD-ID: " + listObjForSaer[currentSaerImporting]['BVD-ID'] + " Saer Code " + listObjForSaer[currentSaerImporting]['SAER-CODE'] + " is not OK" });
              importSaerInError++;
              this.updateSaerProgress(noOfSaerImported, importSaerInError, listObjForSaer.length)
              this.repeatLoopFnForImportSaer(listObjForSaer, currentSaerImporting, noOfSaerImported, importSaerInError);
              localStorage.setItem("errorMessArrImportSaerBatch", JSON.stringify(this.errorMessArrImportSaerBatch));
              this.importSaerInError = importSaerInError;
            }
          } else if (this.startUpload == TWO) {
            console.info("[SAER-IMPORT] More than one occurrence in RFF for BVD-ID:", listObjForSaer[currentSaerImporting]['BVD-ID']);
            this.errorMessArrImportSaerBatch.push({ "error": 'There is more than one occurrence for ' + listObjForSaer[currentSaerImporting]['BVD-ID'] });
            importSaerInError++;
            this.updateSaerProgress(noOfSaerImported, importSaerInError, listObjForSaer.length)
            this.repeatLoopFnForImportSaer(listObjForSaer, currentSaerImporting, noOfSaerImported, importSaerInError);
            localStorage.setItem("errorMessArrImportSaerBatch", JSON.stringify(this.errorMessArrImportSaerBatch));
            this.importSaerInError = importSaerInError;
          } else {
            console.info("[SAER-IMPORT] BVD-ID not found in RFF:", listObjForSaer[currentSaerImporting]['BVD-ID']);
            this.errorMessArrImportSaerBatch.push({ "error": "BVD-ID: " + listObjForSaer[currentSaerImporting]['BVD-ID'] + " Not in RFF" });
            importSaerInError++;
            this.updateSaerProgress(noOfSaerImported, importSaerInError, listObjForSaer.length)
            this.repeatLoopFnForImportSaer(listObjForSaer, currentSaerImporting, noOfSaerImported, importSaerInError);
            localStorage.setItem("errorMessArrImportSaerBatch", JSON.stringify(this.errorMessArrImportSaerBatch));
            this.importSaerInError = importSaerInError;
          }
        } else {
          console.info("[SAER-IMPORT] Already in RFF:", listObjForSaer[currentSaerImporting]['BVD-ID']);
          this.errorMessArrImportSaerBatch.push({ "error": "BVD-ID: " + listObjForSaer[currentSaerImporting]['BVD-ID'] + " Saer Code " + listObjForSaer[currentSaerImporting]['SAER-CODE'] + " already in RFS " + saerCode['access-point-identifiers'][0]['siteIdentifier'] + ' with this SAER code' });
          importSaerInError++;
          this.updateSaerProgress(noOfSaerImported, importSaerInError, listObjForSaer.length)
          this.repeatLoopFnForImportSaer(listObjForSaer, currentSaerImporting, noOfSaerImported, importSaerInError);
          localStorage.setItem("errorMessArrImportSaerBatch", JSON.stringify(this.errorMessArrImportSaerBatch));
          this.importSaerInError = importSaerInError;
        }
      }
    } catch (error) {

    }
    if (currentSaerImporting == listObjForSaer.length) {
      setTimeout(() => {

        this.TextForCompleteUploadImportSaer = 'Imported ' + noOfSaerImported + ' of ' + (listObjForSaer.length) + '.';
        if (importSaerInError > 0) {
          this.TextForSaerInError = 'Error: ' + importSaerInError;
        }
        setTimeout(() => {
          this.showDownloadLogForSaerBatchComplete = true;
        }, TEN_THOUSAND_MS);
        console.info("done")
        this.showDownloadLogForSaerBatch = true;
        this.inputFileVisibleForImportSaer = false;
        this.currentSaerImporting = null;
        this.noOfSaerImported = null;
        this.importSaerInError = null;
        localStorage.setItem("currentSaerImporting", this.currentSaerImporting);
        localStorage.setItem("tempSaerInFileForLocal", null);
        localStorage.setItem("noOfSaerImported", this.noOfSaerImported);
        localStorage.setItem("importSaerInError", this.importSaerInError);
        localStorage.setItem('errorMessArrImportSaerBatch', null);
        localStorage.setItem('totalSaerToImport', null)
      }, THREE_THOUSAND_MS);
    }
  }
  private updateSaerProgress(noOfSaerImported: number, importSaerInError: number, total: number) {
    const successPortion = 'Importing ' + noOfSaerImported + ' of ' + total + '.';
    this.TextForCompleteUploadImportSaer = successPortion;
    if (importSaerInError > 0) {
      this.TextForSaerInError = 'Error: ' + importSaerInError;
    }

    localStorage.setItem('noOfSaerImported', noOfSaerImported.toString());
    localStorage.setItem('importSaerInError', importSaerInError.toString());
    if (Array.isArray(this.errorMessArrImportSaerBatch)) {
      localStorage.setItem('errorMessArrImportSaerBatch', JSON.stringify(this.errorMessArrImportSaerBatch));
    }
  }
  async repeatLoopFnForImportSaer(listObjForSaer, currentSaerImporting, noOfSaerImported, importSaerInError): Promise<void> {
    console.info("repeating the loop")
    this.SiteRowID = []
    let twentyMinutesLater = new Date();
    let curentmni = twentyMinutesLater.setMinutes(twentyMinutesLater.getMinutes());
    console.info('curentmni', curentmni)
    if (currentSaerImporting < listObjForSaer.length) {
      // if ((parseInt(localStorage.getItem('expiredtime')) - curentmni <= 120000 && (parseInt(localStorage.getItem('expiredtime')) - curentmni) > 0) || (parseInt(localStorage.getItem('IDPexpiredtime')) - curentmni <= 120000 && (parseInt(localStorage.getItem('IDPexpiredtime')) - curentmni) > 0)) {
      //   return Promise.resolve();
      // }
      // else if (parseInt(localStorage.getItem('expiredtime')) >= curentmni || parseInt(localStorage.getItem('IDPexpiredtime')) >= curentmni) {
        this.showSessionTimeoutAlcorBatch = false

        if (currentSaerImporting % BATCH_SIZE == 0) {
          return new Promise<void>((resolve) => {
            setTimeout(() => {
              currentSaerImporting++;
              if (this.currentSaerImportingStarted != currentSaerImporting) {
                this.importSaerByFileFunction(listObjForSaer, currentSaerImporting, noOfSaerImported, importSaerInError);
                this.currentSaerImportingStarted = currentSaerImporting;
              }
              resolve();
            }, SIX_THOUSAND_MS);
          });
        } else {
          currentSaerImporting++;
          if (this.currentSaerImportingStarted != currentSaerImporting) {
            this.importSaerByFileFunction(listObjForSaer, currentSaerImporting, noOfSaerImported, importSaerInError);
            this.currentSaerImportingStarted = currentSaerImporting;
          }
          return Promise.resolve();
        }
      // } else {
      //   window.location.reload();
      //   return Promise.resolve();
      // }
    }
    return Promise.resolve();
  }

  LogErrorforImportSaer(listObjForSaer, currentSaerImporting, noOfSaerImported, importSaerInError, errorMsg) {
    this.errorMessArrImportDUNSBatch.push({ "error": "BVD-ID: " + listObjForSaer[currentSaerImporting]['BVD-ID'] + errorMsg });
    localStorage.setItem("errorMessArrImportAlcorBatch", JSON.stringify(this.errorMessArrImportAlcorBatch));
    importSaerInError++;
    this.importContactsInError = importSaerInError;
    this.TextForContactsInError = 'Error: ' + importSaerInError;
    localStorage.setItem("importSaerInError", importSaerInError);
    this.repeatLoopFnForImportSaer(listObjForSaer, currentSaerImporting, noOfSaerImported, importSaerInError);
  }

  downloadLogFileForImportSupplierSaerBatch() {
    let element = document.getElementById('excelTableLogForImportSaerBatch');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Import Saer Batch');
    XLSX.writeFile(wb, 'ImportSaerBatch.xlsx');
  }

  
  isValidLength(value: string): boolean {
    return value.length >= 1 && value.length <= 6;
  }


  changeImportLatamSupplierBatch($event) {
      this.TextForCompleteUploadImportLatam = '';
      this.readImportLatamSupplierBatchThis($event.target);
    }
    readImportLatamSupplierBatchThis(inputValue: any) {
      this.fileToUpload = null;
      this.fileToUpload = inputValue.files[0];
  
      if (!this.fileType(this.fileToUpload, 'xlsx')) {
        const reader: FileReader = new FileReader();
        reader.readAsBinaryString(this.fileToUpload);
  
  
        reader.onload = (e: any) => {
          const binarystr: string = e.target.result;
          const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: 'binary' });
          const wsname: string = wb.SheetNames[0];
          const ws: XLSX.WorkSheet = wb.Sheets[wsname];
          this.LatamHeaders = XLSX.utils.sheet_to_json(ws, { header: 1 })[0];
          const data = XLSX.utils.sheet_to_json(ws).map(row =>
            Object.keys(row).reduce((obj, key) => {
              obj[key.trim()] = row[key];
              return obj;
            }, {})
          );
          this.listObjForLatam = data;
  
          console.info(data);
          this.importLatamPreReq();
          this.CompanyStatusAll = [];
  
          this.importLatamSupplierBatchThis();
        };
      }
    }
    onImportLatamClick() {
      this.uploadDocError = false
      let tempLatamInFileForLocal = JSON.parse(localStorage.getItem('tempLatamInFileForLocal'));
      if (tempLatamInFileForLocal == null) {
        this.inputFileVisibleForImportLatam = true;
        this.showDownloadLogForLatamBatch = false;
        this.TextForCompleteUploadImportLatam = '';
        this.TextForLatamInError = '';
        this.errorMessArrImportLatamBatch = [];
      }
    }
    importLatamPreReq() {
  
      this.supplierService.getCompanySatus(this.Config.ApiSupplierUrl + 'company-status').subscribe((data: any) => {
  
        data['company-status'].forEach(element10 => {
          if (element10['code'] == 'Approved') {
            this.CompanyStatusAll.push(element10);
          }
          if (element10['code'] == 'Identified') {
            this.CompanyStatusAllForGuo.push(element10);
          }
        });
      });
      this.getSiteIdenTypes();
      this.getSourceSytemId();
      this.busEntIdentifiers();
      this.getCpyShortNameTypes();
      this.AllCompanyIdentifierTypes();
  
    }
    importLatamPreReqonReload(listObjForLatam, currentLatamImporting, noOfLatamImported, importLatamInError) {
  
      setTimeout(() => {
        this.supplierService.getCompanySatus(this.Config.ApiSupplierUrl + 'company-status').subscribe((data: any) => {
  
          data['company-status'].forEach(element10 => {
            if (element10['code'] == 'Approved') {
              this.CompanyStatusAll.push(element10);
            }
            if (element10['code'] == 'Identified') {
              this.CompanyStatusAllForGuo.push(element10);
            }
          });
          this.getSiteIdenTypes();
          this.getSourceSytemId();
          this.busEntIdentifiers();
          this.getCpyShortNameTypes();
          this.AllCompanyIdentifierTypes();
          this.importLatamByFileFunction(listObjForLatam, currentLatamImporting, noOfLatamImported, importLatamInError)
  
        }, (_err) => {
          currentLatamImporting = listObjForLatam.length;
          this.errorMessArrImportLatamBatch.push({
            "error": 'ERROR : Creating getting  company-status'
          });
          localStorage.setItem("errorMessArrImportLatamBatch", JSON.stringify(this.errorMessArrImportLatamBatch));
          importLatamInError++;
          this.importLatamInError = importLatamInError;
          this.TextForCompleteUploadImportLatam = 'Imported ' + noOfLatamImported + ' of ' + (listObjForLatam.length) + '.';
          if (importLatamInError > 0) {
            this.TextForLatamInError = 'Error: ' + importLatamInError;
          }
          setTimeout(() => {
          this.showDownloadLogForLatamBatchComplete = true;
        }, TEN_THOUSAND_MS)
          console.info("done")
          this.showDownloadLogForLatamBatch = true;
          this.inputFileVisibleForImportLatam = false;
          this.currentLatamImporting = null;
          this.noOfLatamImported = null;
          this.importLatamInError = null;
          localStorage.setItem("currentLatamImporting", this.currentLatamImporting);
          localStorage.setItem("tempLatamInFileForLocal", null);
          localStorage.setItem("noOfLatamImported", this.noOfLatamImported);
          localStorage.setItem("importLatamInError", this.importLatamInError);
        });
  
      }, TEN_THOUSAND_MS)
    }
    importLatamSupplierBatchThis() {
      this.showDownloadLogForLatamBatch = false;
  
      this.TextForCompleteUploadImportLatam = 'Uploading...';
      this.errorMessArrImportLatamBatch = [];
      this.CountryNameKeyIds = "";
      this.CountryNameKeyIds = [];
      this.importLatamInError = 0;
      this.noOfLatamImported = 0;
      this.currentLatamImporting = 0;
      localStorage.setItem("tempLatamInFileForLocal", JSON.stringify(this.listObjForLatam));
      this.totalLatamToImport = this.listObjForLatam.length.toString();
      localStorage.setItem("totalLatamToImport", this.listObjForLatam.length.toString());
      this.importLatamStartFn(this.listObjForLatam)
    }
  
    checkLocalStorageForImpLatam() {
      let tempLatamInFileForLocal = JSON.parse(localStorage.getItem('tempLatamInFileForLocal'));
      this.listObjForLatam = tempLatamInFileForLocal;
      let errorMessArrImportLatamBatch = (localStorage.getItem('errorMessArrImportLatamBatch') == null || localStorage.getItem('errorMessArrImportLatamBatch') == undefined ||
      localStorage.getItem('errorMessArrImportLatamBatch') == '') ? null : JSON.parse(localStorage.getItem('errorMessArrImportLatamBatch'));
      let logOfImportLatamBatch = JSON.parse(localStorage.getItem('logOfImportLatamBatch'));
      let currentLatamImporting = localStorage.getItem("currentLatamImporting");
      let noOfLatamImported = localStorage.getItem("noOfLatamImported");
      let importLatamInError = localStorage.getItem("importLatamInError");
      let totalLatamToImport = localStorage.getItem("totalLatamToImport");
      console.info("no of Latam rows complete", localStorage.getItem("currentLatamImporting"))
      console.info("no of Latam already uploaded ", localStorage.getItem("noOfLatamImported"))
      console.info("no of Latam in error ", localStorage.getItem("importLatamInError"))
      console.info("no of Latam in total ", localStorage.getItem("totalLatamToImport"))
      if (currentLatamImporting != null && currentLatamImporting != 'null') {
        if (noOfLatamImported == null || noOfLatamImported == 'null') {
          noOfLatamImported = '0';
        }
        if (importLatamInError == null || importLatamInError == 'null') {
          importLatamInError = '0';
        }
        if (errorMessArrImportLatamBatch == null || errorMessArrImportLatamBatch == 'null') {
          this.errorMessArrImportLatamBatch = [];
        } else {
          this.errorMessArrImportLatamBatch = errorMessArrImportLatamBatch;
        }
        if (logOfImportLatamBatch == null || logOfImportLatamBatch == 'null') {
          this.logOfImportLatamBatch = [];
        } else {
          this.logOfImportLatamBatch = logOfImportLatamBatch;
        }
        if (totalLatamToImport == null || totalLatamToImport == 'null') {
          this.totalLatamToImport = '0';
        } else {
          this.totalLatamToImport = totalLatamToImport;
        }
        console.info("exc Latam")
        this.showDownloadLogForLatamBatch = false;
        setTimeout(() => {
          this.importLatamPreReqonReload(tempLatamInFileForLocal, parseInt(currentLatamImporting), parseInt(noOfLatamImported), parseInt(importLatamInError));
        }, FIFTEEN_HUNDRED_MS);
  
        setTimeout(() => {
          const btnElement = document.getElementById('btnForImportLatamBatch');
          if (btnElement) {
            btnElement.click();
          }
        })
        this.updateLatamProgress(parseInt(noOfLatamImported), parseInt(importLatamInError), tempLatamInFileForLocal.length)
        this.inputFileVisibleForImportLatam = false;
      } else {
        this.inputFileVisibleForImportLatam = true;
        this.TextForCompleteUploadImportLatam = "";
        this.errorMessArrImportLatamBatch = [];
        this.logOfImportLatamBatch = [];
        this.totalLatamToImport = null;
        localStorage.setItem("errorMessArrImportLatamBatch", null);
        localStorage.setItem("logOfImportLatamBatch", null);
        localStorage.setItem("totalLatamToImport", this.totalLatamToImport);
        this.TextForLatamInError = "";
      }
    }
  
    importLatamStartFn(listObjForLatam, currentLatamImporting = 0, noOfLatamImported = 0, importLatamInError = 0) {
      this.showDownloadLogForLatamBatch = false;
      this.showDownloadLogForLatamBatchComplete = false;
      this.inputFileVisibleForImportLatam = false;
      this.TextForCompleteUploadImportLatam = 'Uploading...';
      console.info("listObjForLatam", listObjForLatam)
      if (importLatamInError < 1) {
        this.TextForLatamInError = '';
      } else {
        this.TextForLatamInError = 'Error: ' + importLatamInError;
      }
      this.TextForCompleteUploadImportLatam = 'Importing ' + noOfLatamImported + ' of ' + (listObjForLatam.length) + ' ';
      if (!this.checkFileFormat('LATAM_CODE', listObjForLatam)) {
        currentLatamImporting = listObjForLatam.length;
        this.errorMessArrImportLatamBatch.push({ "error": "Please Upload a Valid file format " });
        localStorage.setItem("errorMessArrImportLatamBatch", JSON.stringify(this.errorMessArrImportLatamBatch));
        importLatamInError++;
        this.importLatamInError = importLatamInError;
        this.TextForLatamInError = 'Error: ' + importLatamInError;
        localStorage.setItem("importLatamInError", importLatamInError.toString());
  
        this.TextForCompleteUploadImportLatam = 'Imported ' + noOfLatamImported + ' of ' + (listObjForLatam.length) + '.';
        if (importLatamInError > 0) {
          this.TextForLatamInError = 'Error: ' + importLatamInError;
        }
        setTimeout(() => {
          this.showDownloadLogForLatamBatchComplete = true;
        }, TEN_THOUSAND_MS);
        console.info("done")
        this.showDownloadLogForLatamBatch = true;
        this.inputFileVisibleForImportLatam = false;
        this.currentLatamImporting = null;
        this.noOfLatamImported = null;
        this.importLatamInError = null;
        localStorage.setItem("currentLatamImporting", this.currentLatamImporting);
        localStorage.setItem("tempLatamInFileForLocal", null);
        localStorage.setItem("noOfLatamImported", this.noOfLatamImported);
        localStorage.setItem("importLatamInError", this.importLatamInError);
      } else {
        this.importLatamByFileFunction(listObjForLatam, currentLatamImporting, noOfLatamImported, importLatamInError);
      }
    }
  async importLatamByFileFunction(listObjForLatam, currentLatamImporting, noOfLatamImported, importLatamInError) {
    if (currentLatamImporting < listObjForLatam.length) {
      console.info("currentLatamImporting - ", currentLatamImporting + ' - Latam CODE:' + listObjForLatam[currentLatamImporting]['LATAM-CODE'])
    } else {
      console.info("currentLatamImporting - ", currentLatamImporting)
    }
    this.currentLatamImporting = currentLatamImporting;
    this.startUpload = 0; // Reset startUpload at the beginning of each iteration
    localStorage.setItem("currentLatamImporting", this.currentLatamImporting.toString());
    try {
      if (currentLatamImporting < listObjForLatam.length) {
        let BvDAssignBvd = listObjForLatam[currentLatamImporting]['BVD-ID']
        let data
        let param
        let data2 = await this.handleApiCall(this.sitesService.getAccessPointIdentifiers(this.Config.ApiSitesUrl + 'access-point-identifiers?identifierTypeName=AP_LATAM_CODE&identifierValue=' + listObjForLatam[currentLatamImporting]['LATAM-CODE']).toPromise(), 'Error in getting accesspointIdentifier', listObjForLatam, currentLatamImporting, noOfLatamImported, importLatamInError, 'Latam')
        if (data2['access-point-identifiers'].length == 0) {
          if (/^ST\d{8}$/.test(BvDAssignBvd)) {
            data = await this.handleApiCall(this.sitesService.getSites(this.Config.ApiSitesUrl + 'sites?identifier=' + BvDAssignBvd).toPromise(), 'Error in getting site assignments', listObjForLatam, currentLatamImporting, noOfLatamImported, importLatamInError, 'Latam')
            if (data['sites'].length == 1) {
              this.startUpload = 1
              param = 'reaIdentifier=' + BvDAssignBvd
            } else if (data['sites'].length > 1) {
              this.startUpload = TWO
            }
          } else {
            data = await this.handleApiCall(this.supplierService.getBusinessEntityIdentifiers(this.Config.ApiSupplierUrl + 'business-entity-identifiers?businessEntityIdentifierTypeName=BVD ID&value=' + BvDAssignBvd).toPromise(), 'Error in getting business entity identifiers', listObjForLatam, currentLatamImporting, noOfLatamImported, importLatamInError, 'Latam')
            if (data['business-entity-identifiers'].length == 1) {
              this.startUpload = 1
              param = 'businessEntityAllianceIdentifier=' + data['business-entity-identifiers'][0]['businessEntityAllianceIdentifier']
            } else if (data['business-entity-identifiers'].length > 1) {
              this.startUpload = TWO
            }
          }
          if (this.startUpload == 1) {
            if ((listObjForLatam[currentLatamImporting]['LATAM-CODE'] != undefined && listObjForLatam[currentLatamImporting]['LATAM-CODE'] != '' && !isNaN(listObjForLatam[currentLatamImporting]['LATAM-CODE']) && this.isValidLength(listObjForLatam[currentLatamImporting]['LATAM-CODE'].toString()))) {
              if ((listObjForLatam[currentLatamImporting]['LATAM-NAME'] != undefined && listObjForLatam[currentLatamImporting]['LATAM-NAME'] != '') && listObjForLatam[currentLatamImporting]['LATAM-NAME'].length <= TEN) {
                let siteAssgnData = await this.handleApiCall(this.supplierService.getSiteAssignments(this.Config.ApiSupplierUrl + 'site-assignments?' + param).toPromise(), 'Error in getting site assignments', listObjForLatam, currentLatamImporting, noOfLatamImported, importLatamInError, 'Latam')
                if (siteAssgnData['site-assignments'].length > 0) {
                  const rowId = siteAssgnData['site-assignments'][0]['site']['href'].split('/')
                  const siteIdentifierFromAssignment = siteAssgnData['site-assignments'][0]['reaIdentifier'];
                  const siteDatas = {
                    activeStatus: 'ACTIVE',
                    realEstateAssetId: rowId[1],
                    label: siteAssgnData['site-assignments'][0]['businessEntityCompanyLegalName'],
                    type: 'P11',
                    effectiveDate: this.apiService.getTodayDate(),
                    irnAuthor: 'IRN-71016',
                    siaAuthor: 'IAF',
                    activity: 'A10'
                  };
                  this.sitesService.createAccessPoint(this.Config.ApiSitesUrl + 'access-points', siteDatas).pipe(

                    concatMap((acpCreation: any) => {
                      const acpRowId = acpCreation['rowId'];
                      return this.sitesService
                        .getAccessPoints(this.Config.ApiSitesUrl + 'access-points?siteIdentifier=' + siteIdentifierFromAssignment + '&type=in(' + "'P14'" + ')')
                        .pipe(
                          concatMap((p14Data: any) => {
                            const p14Identifier = p14Data && p14Data['access-points'] && p14Data['access-points'][0] ? p14Data['access-points'][0]['identifier'] : null;
                            if (!p14Identifier) {
                              return of({ acpCreation, acpRowId });
                            }
                            return this.sitesService
                              .getAccessPointAddresses(this.Config.ApiSitesUrl + 'access-points-addresses?accessPointIdentifier=' + p14Identifier)
                              .pipe(
                                concatMap((addrData: any) => {
                                  const addrList = (addrData && addrData['access-points-addresses']) ? addrData['access-points-addresses'] : [];
                                  if (!addrList.length) {
                                    return of({ acpCreation, acpRowId });
                                  }
                                  const createCalls = addrList.map((a: any) => {
                                    const payload = { accessPointId: acpRowId, addressId: a['addressId'] };
                                    return this.sitesService.createAccessPointAddress(this.Config.ApiSitesUrl + 'access-points-addresses', payload);
                                  });
                                  return forkJoin(createCalls).pipe(map(() => ({ acpCreation, acpRowId })));
                                })
                              );
                          })
                        );
                    }),

                    concatMap(({ acpCreation, acpRowId }: { acpCreation: any; acpRowId: any }) => {
                      const siteDatasLatamCode = {
                        identifierId: this.siteIdentTypesData['AP_LATAM_CODE'],
                        sourceSystemId: this.siteSourceSystems['LATAM'],
                        accessPointRowId: acpRowId,
                        identifierValue: listObjForLatam[currentLatamImporting]['LATAM-CODE'],
                        siteIdentifier: acpCreation['siteIdentifier'],
                        accessPointIdentifier: acpCreation['identifier'],
                        effectiveDate: this.apiService.getTodayDate()
                      };
                      return this.sitesService.createAccessPointIdentifier(this.Config.ApiSitesUrl + 'access-point-identifiers', siteDatasLatamCode).pipe(
                        map(() => ({ acpCreation, acpRowId }))
                      );
                    }),

                    concatMap(({ acpCreation, acpRowId }: { acpCreation: any; acpRowId: any }) => {
                      const siteDatasLatamName = {
                        identifierId: this.siteIdentTypesData['SOCIAL_RAISON'],
                        sourceSystemId: this.siteSourceSystems['LATAM'],
                        accessPointRowId: acpRowId,
                        identifierValue: listObjForLatam[currentLatamImporting]['LATAM-NAME'],
                        siteIdentifier: acpCreation['siteIdentifier'],
                        accessPointIdentifier: acpCreation['identifier'],
                        effectiveDate: this.apiService.getTodayDate()
                      };
                      return this.sitesService.createAccessPointIdentifier(this.Config.ApiSitesUrl + 'access-point-identifiers', siteDatasLatamName);
                    }),

                    concatMap(() => {
                      const siteId = rowId[1];
                      return from(this.blankupdate.siteBlankStatusUpdateAsync(siteId));
                    })
                  ).subscribe({
                    next: () => {
                      noOfLatamImported++;
                      this.updateLatamProgress(noOfLatamImported, importLatamInError, listObjForLatam.length)
                      this.repeatLoopFnForImportLatam(listObjForLatam, currentLatamImporting, noOfLatamImported, importLatamInError);
                    },
                    error: (err) => {
                      this.errorMessArrImportLatamBatch.push({ "error": "BVD-ID: " + listObjForLatam[currentLatamImporting]['BVD-ID'] + " Latam creation failed: " + (err?.message || err) });
                      importLatamInError++;
                      this.updateLatamProgress(noOfLatamImported, importLatamInError, listObjForLatam.length);
                      this.repeatLoopFnForImportLatam(listObjForLatam, currentLatamImporting, noOfLatamImported, importLatamInError);
                      localStorage.setItem("errorMessArrImportLatamBatch", JSON.stringify(this.errorMessArrImportLatamBatch));
                      this.importLatamInError = importLatamInError;
                    }
                  })
                } else {
                  // No site assignments found - log error and continue
                  console.info("[Latam-IMPORT] No site assignments found for BVD-ID:", listObjForLatam[currentLatamImporting]['BVD-ID']);
                  this.errorMessArrImportLatamBatch.push({ "error": "BVD-ID: " + listObjForLatam[currentLatamImporting]['BVD-ID'] + " No site assignments found" });
                  importLatamInError++;
                  this.updateLatamProgress(noOfLatamImported, importLatamInError, listObjForLatam.length);
                  this.repeatLoopFnForImportLatam(listObjForLatam, currentLatamImporting, noOfLatamImported, importLatamInError);
                  localStorage.setItem("errorMessArrImportLatamBatch", JSON.stringify(this.errorMessArrImportLatamBatch));
                  this.importLatamInError = importLatamInError;
                }

              } else {
                console.info("[Latam-IMPORT] Latam Names is Not OK:", listObjForLatam[currentLatamImporting]['BVD-ID']);
                this.errorMessArrImportLatamBatch.push({ "error": "BVD-ID: " + listObjForLatam[currentLatamImporting]['BVD-ID'] + " Latam Name " + listObjForLatam[currentLatamImporting]['LATAM-NAME'] + " is not OK" });
                importLatamInError++;
                this.updateLatamProgress(noOfLatamImported, importLatamInError, listObjForLatam.length)
                this.repeatLoopFnForImportLatam(listObjForLatam, currentLatamImporting, noOfLatamImported, importLatamInError);
                localStorage.setItem("errorMessArrImportLatamBatch", JSON.stringify(this.errorMessArrImportLatamBatch));
                this.importLatamInError = importLatamInError;
              }
            } else {
              console.info("[Latam-IMPORT] Latam Codes is Not OK:", listObjForLatam[currentLatamImporting]['BVD-ID']);
              this.errorMessArrImportLatamBatch.push({ "error": "BVD-ID: " + listObjForLatam[currentLatamImporting]['BVD-ID'] + " Latam Code " + listObjForLatam[currentLatamImporting]['LATAM-CODE'] + " is not OK" });
              importLatamInError++;
              this.updateLatamProgress(noOfLatamImported, importLatamInError, listObjForLatam.length)
              this.repeatLoopFnForImportLatam(listObjForLatam, currentLatamImporting, noOfLatamImported, importLatamInError);
              localStorage.setItem("errorMessArrImportLatamBatch", JSON.stringify(this.errorMessArrImportLatamBatch));
              this.importLatamInError = importLatamInError;
            }
          } else if (this.startUpload == TWO) {
            console.info("[Latam-IMPORT] More than one occurrence in RFF for BVD-ID:", listObjForLatam[currentLatamImporting]['BVD-ID']);
            this.errorMessArrImportLatamBatch.push({ "error": 'There is more than one occurrence for ' + listObjForLatam[currentLatamImporting]['BVD-ID'] });
            importLatamInError++;
            this.updateLatamProgress(noOfLatamImported, importLatamInError, listObjForLatam.length)
            this.repeatLoopFnForImportLatam(listObjForLatam, currentLatamImporting, noOfLatamImported, importLatamInError);
            localStorage.setItem("errorMessArrImportLatamBatch", JSON.stringify(this.errorMessArrImportLatamBatch));
            this.importLatamInError = importLatamInError;
          } else {
            console.info("[Latam-IMPORT] BVD-ID not found in RFF:", listObjForLatam[currentLatamImporting]['BVD-ID']);
            this.errorMessArrImportLatamBatch.push({ "error": "BVD-ID: " + listObjForLatam[currentLatamImporting]['BVD-ID'] + " Not in RFF" });
            importLatamInError++;
            this.updateLatamProgress(noOfLatamImported, importLatamInError, listObjForLatam.length)
            this.repeatLoopFnForImportLatam(listObjForLatam, currentLatamImporting, noOfLatamImported, importLatamInError);
            localStorage.setItem("errorMessArrImportLatamBatch", JSON.stringify(this.errorMessArrImportLatamBatch));
            this.importLatamInError = importLatamInError;
          }
        } else {
          console.info("[Latam-IMPORT] Already in RFF:", listObjForLatam[currentLatamImporting]['BVD-ID']);
          this.errorMessArrImportLatamBatch.push({ "error": "BVD-ID: " + listObjForLatam[currentLatamImporting]['BVD-ID'] + " Latam Code " + listObjForLatam[currentLatamImporting]['LATAM-CODE'] + " already in RFS " + data2['access-point-identifiers'][0]['siteIdentifier'] + ' with this Latam code' });
          importLatamInError++;
          this.updateLatamProgress(noOfLatamImported, importLatamInError, listObjForLatam.length)
          this.repeatLoopFnForImportLatam(listObjForLatam, currentLatamImporting, noOfLatamImported, importLatamInError);
          localStorage.setItem("errorMessArrImportLatamBatch", JSON.stringify(this.errorMessArrImportLatamBatch));
          this.importLatamInError = importLatamInError;
        }
      }
    } catch (error) {

    }
    if (currentLatamImporting == listObjForLatam.length) {
      setTimeout(() => {

        this.TextForCompleteUploadImportLatam = 'Imported ' + noOfLatamImported + ' of ' + (listObjForLatam.length) + '.';
        if (importLatamInError > 0) {
          this.TextForLatamInError = 'Error: ' + importLatamInError;
        }
        setTimeout(() => {
          this.showDownloadLogForLatamBatchComplete = true;
        }, TEN_THOUSAND_MS);
        console.info("done")
        this.showDownloadLogForLatamBatch = true;
        this.inputFileVisibleForImportLatam = false;
        this.currentLatamImporting = null;
        this.noOfLatamImported = null;
        this.importLatamInError = null;
        localStorage.setItem("currentLatamImporting", this.currentLatamImporting);
        localStorage.setItem("tempLatamInFileForLocal", null);
        localStorage.setItem("noOfLatamImported", this.noOfLatamImported);
        localStorage.setItem("importLatamInError", this.importLatamInError);
        localStorage.setItem('errorMessArrImportLatamBatch', null);
        localStorage.setItem('totalLatamToImport', null)
      }, THREE_THOUSAND_MS);
    }
  }
    private updateLatamProgress(noOfLatamImported: number, importLatamInError: number, total: number) {
      const successPortion = 'Importing ' + noOfLatamImported + ' of ' + total + '.';
      this.TextForCompleteUploadImportLatam = successPortion;
      if (importLatamInError > 0) {
        this.TextForLatamInError = 'Error: ' + importLatamInError;
      }
  
      localStorage.setItem('noOfLatamImported', noOfLatamImported.toString());
      localStorage.setItem('importLatamInError', importLatamInError.toString());
      if (Array.isArray(this.errorMessArrImportLatamBatch)) {
        localStorage.setItem('errorMessArrImportLatamBatch', JSON.stringify(this.errorMessArrImportLatamBatch));
      }
    }
    async repeatLoopFnForImportLatam(listObjForLatam, currentLatamImporting, noOfLatamImported, importLatamInError): Promise<void> {
      console.info("repeating the loop")
      this.SiteRowID = []
      let twentyMinutesLater = new Date();
      let curentmni = twentyMinutesLater.setMinutes(twentyMinutesLater.getMinutes());
      console.info('curentmni', curentmni)
      if (currentLatamImporting < listObjForLatam.length) {
          this.showSessionTimeoutAlcorBatch = false
  
          if (currentLatamImporting % BATCH_SIZE == 0) {
            return new Promise<void>((resolve) => {
              setTimeout(() => {
                currentLatamImporting++;
                if (this.currentLatamImportingStarted != currentLatamImporting) {
                  this.importLatamByFileFunction(listObjForLatam, currentLatamImporting, noOfLatamImported, importLatamInError);
                  this.currentLatamImportingStarted = currentLatamImporting;
                }
                resolve();
              }, SIX_THOUSAND_MS);
            });
          } else {
            currentLatamImporting++;
            if (this.currentLatamImportingStarted != currentLatamImporting) {
              this.importLatamByFileFunction(listObjForLatam, currentLatamImporting, noOfLatamImported, importLatamInError);
              this.currentLatamImportingStarted = currentLatamImporting;
            }
            return Promise.resolve();
          }
        // } else {
        //   window.location.reload();
        //   return Promise.resolve();
        // }
      }
      return Promise.resolve();
    }
  
    LogErrorforImportLatam(listObjForLatam, currentLatamImporting, noOfLatamImported, importLatamInError, errorMsg) {
      this.errorMessArrImportDUNSBatch.push({ "error": "BVD-ID: " + listObjForLatam[currentLatamImporting]['BVD-ID'] + errorMsg });
      localStorage.setItem("errorMessArrImportAlcorBatch", JSON.stringify(this.errorMessArrImportAlcorBatch));
      importLatamInError++;
      this.importContactsInError = importLatamInError;
      this.TextForContactsInError = 'Error: ' + importLatamInError;
      localStorage.setItem("importLatamInError", importLatamInError);
      this.repeatLoopFnForImportLatam(listObjForLatam, currentLatamImporting, noOfLatamImported, importLatamInError);
    }
  
    downloadLogFileForImportSupplierLatamBatch() {
      let element = document.getElementById('excelTableLogForImportLatamBatch');
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Import Latam Batch');
      XLSX.writeFile(wb, 'ImportLatamBatch.xlsx');
    }

    changeImportRNAIPLSupplierBatch($event) {
      this.TextForCompleteUploadImportRNAIPL = '';
      this.readImportRNAIPLSupplierBatchThis($event.target);
    }
    readImportRNAIPLSupplierBatchThis(inputValue: any) {
      this.fileToUpload = null;
      this.fileToUpload = inputValue.files[0];
  
      if (!this.fileType(this.fileToUpload, 'xlsx')) {
        const reader: FileReader = new FileReader();
        reader.readAsBinaryString(this.fileToUpload);
  
  
        reader.onload = (e: any) => {
          const binarystr: string = e.target.result;
          const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: 'binary' });
          const wsname: string = wb.SheetNames[0];
          const ws: XLSX.WorkSheet = wb.Sheets[wsname];
          this.RNAIPLHeaders = XLSX.utils.sheet_to_json(ws, { header: 1 })[0];
          const data = XLSX.utils.sheet_to_json(ws).map(row =>
            Object.keys(row).reduce((obj, key) => {
              obj[key.trim()] = row[key];
              return obj;
            }, {})
          );
          this.listObjForRNAIPL = data;
  
          console.info(data);
          this.importRNAIPLPreReq();
          this.CompanyStatusAll = [];
  
          this.importRNAIPLSupplierBatchThis();
        };
      }
    }
    onImportRNAIPLClick() {
      this.uploadDocError = false
      let tempRNAIPLinFileForLocal = JSON.parse(localStorage.getItem('tempRNAIPLinFileForLocal'));
      if (tempRNAIPLinFileForLocal == null) {
        this.inputFileVisibleForImportRNAIPL = true;
        this.showDownloadLogForRNAIPLBacth = false;
        this.TextForCompleteUploadImportRNAIPL = '';
        this.TextForRNAIPLError = '';
        this.errorMessArrImportRNAIPLBacth = [];
      }
    }
    importRNAIPLPreReq() {
  
      this.supplierService.getCompanySatus(this.Config.ApiSupplierUrl + 'company-status').subscribe((data: any) => {
  
        data['company-status'].forEach(element10 => {
          if (element10['code'] == 'Approved') {
            this.CompanyStatusAll.push(element10);
          }
          if (element10['code'] == 'Identified') {
            this.CompanyStatusAllForGuo.push(element10);
          }
        });
      });
      this.getSiteIdenTypes();
      this.getSourceSytemId();
      this.busEntIdentifiers();
      this.getCpyShortNameTypes();
      this.AllCompanyIdentifierTypes();
  
    }
    importRNAIPLPreReqonReload(listObjForRNAIPL, currentRNAIPLImporting, noOfRNAIPLImported, importRNAIPLinError) {
  
      setTimeout(() => {
        this.supplierService.getCompanySatus(this.Config.ApiSupplierUrl + 'company-status').subscribe((data: any) => {
  
          data['company-status'].forEach(element10 => {
            if (element10['code'] == 'Approved') {
              this.CompanyStatusAll.push(element10);
            }
            if (element10['code'] == 'Identified') {
              this.CompanyStatusAllForGuo.push(element10);
            }
          });
          this.getSiteIdenTypes();
          this.getSourceSytemId();
          this.busEntIdentifiers();
          this.getCpyShortNameTypes();
          this.AllCompanyIdentifierTypes();
          this.importRNAIPLByFileFunction(listObjForRNAIPL, currentRNAIPLImporting, noOfRNAIPLImported, importRNAIPLinError)
  
        }, (_err) => {
          currentRNAIPLImporting = listObjForRNAIPL.length;
          this.errorMessArrImportRNAIPLBacth.push({
            "error": 'ERROR : Creating getting  company-status'
          });
          localStorage.setItem("errorMessArrImportRNAIPLBacth", JSON.stringify(this.errorMessArrImportRNAIPLBacth));
          importRNAIPLinError++;
          this.importRNAIPLinError = importRNAIPLinError;
          this.TextForCompleteUploadImportRNAIPL = 'Imported ' + noOfRNAIPLImported + ' of ' + (listObjForRNAIPL.length) + '.';
          if (importRNAIPLinError > 0) {
            this.TextForRNAIPLError = 'Error: ' + importRNAIPLinError;
          }
          setTimeout(() => {
          this.showDownloadLogForRNAIPLBacthComplete = true;
        }, TEN_THOUSAND_MS)
          console.info("done")
          this.showDownloadLogForRNAIPLBacth = true;
          this.inputFileVisibleForImportRNAIPL = false;
          this.currentRNAIPLImporting = null;
          this.noOfRNAIPLImported = null;
          this.importRNAIPLinError = null;
          localStorage.setItem("currentRNAIPLImporting", this.currentRNAIPLImporting);
          localStorage.setItem("tempRNAIPLinFileForLocal", null);
          localStorage.setItem("noOfRNAIPLImported", this.noOfRNAIPLImported);
          localStorage.setItem("importRNAIPLinError", this.importRNAIPLinError);
        });
  
      }, TEN_THOUSAND_MS)
    }
    importRNAIPLSupplierBatchThis() {
      this.showDownloadLogForRNAIPLBacth = false;
  
      this.TextForCompleteUploadImportRNAIPL = 'Uploading...';
      this.errorMessArrImportRNAIPLBacth = [];
      this.CountryNameKeyIds = "";
      this.CountryNameKeyIds = [];
      this.importRNAIPLinError = 0;
      this.noOfRNAIPLImported = 0;
      this.currentRNAIPLImporting = 0;
      localStorage.setItem("tempRNAIPLinFileForLocal", JSON.stringify(this.listObjForRNAIPL));
      this.totalRNAIPLToImport = this.listObjForRNAIPL.length.toString();
      localStorage.setItem("totalRNAIPLToImport", this.listObjForRNAIPL.length.toString());
      this.importRNAIPLStartFn(this.listObjForRNAIPL)
    }
  
    checkLocalStorageForImpRNAIPL() {
      let tempRNAIPLinFileForLocal = JSON.parse(localStorage.getItem('tempRNAIPLinFileForLocal'));
      this.listObjForRNAIPL = tempRNAIPLinFileForLocal;
      let errorMessArrImportRNAIPLBacth = (localStorage.getItem('errorMessArrImportRNAIPLBacth') == null || localStorage.getItem('errorMessArrImportRNAIPLBacth') == undefined ||
      localStorage.getItem('errorMessArrImportRNAIPLBacth') == '') ? null : JSON.parse(localStorage.getItem('errorMessArrImportRNAIPLBacth'));
      let logOfImportRNAIPLBacth = JSON.parse(localStorage.getItem('logOfImportRNAIPLBacth'));
      let currentRNAIPLImporting = localStorage.getItem("currentRNAIPLImporting");
      let noOfRNAIPLImported = localStorage.getItem("noOfRNAIPLImported");
      let importRNAIPLinError = localStorage.getItem("importRNAIPLinError");
      let totalRNAIPLToImport = localStorage.getItem("totalRNAIPLToImport");
      console.info("no of RNAIPL rows complete", localStorage.getItem("currentRNAIPLImporting"))
      console.info("no of RNAIPL already uploaded ", localStorage.getItem("noOfRNAIPLImported"))
      console.info("no of RNAIPL in error ", localStorage.getItem("importRNAIPLinError"))
      console.info("no of RNAIPL in total ", localStorage.getItem("totalRNAIPLToImport"))
      if (currentRNAIPLImporting != null && currentRNAIPLImporting != 'null') {
        if (noOfRNAIPLImported == null || noOfRNAIPLImported == 'null') {
          noOfRNAIPLImported = '0';
        }
        if (importRNAIPLinError == null || importRNAIPLinError == 'null') {
          importRNAIPLinError = '0';
        }
        if (errorMessArrImportRNAIPLBacth == null || errorMessArrImportRNAIPLBacth == 'null') {
          this.errorMessArrImportRNAIPLBacth = [];
        } else {
          this.errorMessArrImportRNAIPLBacth = errorMessArrImportRNAIPLBacth;
        }
        if (logOfImportRNAIPLBacth == null || logOfImportRNAIPLBacth == 'null') {
          this.logOfImportRNAIPLBacth = [];
        } else {
          this.logOfImportRNAIPLBacth = logOfImportRNAIPLBacth;
        }
        if (totalRNAIPLToImport == null || totalRNAIPLToImport == 'null') {
          this.totalRNAIPLToImport = '0';
        } else {
          this.totalRNAIPLToImport = totalRNAIPLToImport;
        }
        console.info("exc Latam")
        this.showDownloadLogForRNAIPLBacth = false;
        setTimeout(() => {
          this.importRNAIPLPreReqonReload(tempRNAIPLinFileForLocal, parseInt(currentRNAIPLImporting), parseInt(noOfRNAIPLImported), parseInt(importRNAIPLinError));
        }, FIFTEEN_HUNDRED_MS);
  
        setTimeout(() => {
          const btnElement = document.getElementById('btnForImportRNAIPLBacth');
          if (btnElement) {
            btnElement.click();
          }
        })
        this.updateRNAIPLProgress(parseInt(noOfRNAIPLImported), parseInt(importRNAIPLinError), tempRNAIPLinFileForLocal.length)
        this.inputFileVisibleForImportRNAIPL = false;
      } else {
        this.inputFileVisibleForImportRNAIPL = true;
        this.TextForCompleteUploadImportRNAIPL = "";
        this.errorMessArrImportRNAIPLBacth = [];
        this.logOfImportRNAIPLBacth = [];
        this.totalRNAIPLToImport = null;
        localStorage.setItem("errorMessArrImportRNAIPLBacth", null);
        localStorage.setItem("logOfImportRNAIPLBacth", null);
        localStorage.setItem("totalRNAIPLToImport", this.totalRNAIPLToImport);
        this.TextForRNAIPLError = "";
      }
    }
  
    importRNAIPLStartFn(listObjForRNAIPL, currentRNAIPLImporting = 0, noOfRNAIPLImported = 0, importRNAIPLinError = 0) {
      this.showDownloadLogForRNAIPLBacth = false;
      this.showDownloadLogForRNAIPLBacthComplete = false;
      this.inputFileVisibleForImportRNAIPL = false;
      this.TextForCompleteUploadImportRNAIPL = 'Uploading...';
      console.info("listObjForRNAIPL", listObjForRNAIPL)
      if (importRNAIPLinError < 1) {
        this.TextForRNAIPLError = '';
      } else {
        this.TextForRNAIPLError = 'Error: ' + importRNAIPLinError;
      }
      this.TextForCompleteUploadImportRNAIPL = 'Importing ' + noOfRNAIPLImported + ' of ' + (listObjForRNAIPL.length) + ' ';
      if (!this.checkFileFormat('RNAIPL_CODE', listObjForRNAIPL)) {
        currentRNAIPLImporting = listObjForRNAIPL.length;
        this.errorMessArrImportRNAIPLBacth.push({ "error": "Please Upload a Valid file format " });
        localStorage.setItem("errorMessArrImportRNAIPLBacth", JSON.stringify(this.errorMessArrImportRNAIPLBacth));
        importRNAIPLinError++;
        this.importRNAIPLinError = importRNAIPLinError;
        this.TextForRNAIPLError = 'Error: ' + importRNAIPLinError;
        localStorage.setItem("importRNAIPLinError", importRNAIPLinError.toString());
  
        this.TextForCompleteUploadImportRNAIPL = 'Imported ' + noOfRNAIPLImported + ' of ' + (listObjForRNAIPL.length) + '.';
        if (importRNAIPLinError > 0) {
          this.TextForRNAIPLError = 'Error: ' + importRNAIPLinError;
        }
        setTimeout(() => {
          this.showDownloadLogForRNAIPLBacthComplete = true;
        }, TEN_THOUSAND_MS);
        console.info("done")
        this.showDownloadLogForRNAIPLBacth = true;
        this.inputFileVisibleForImportRNAIPL = false;
        this.currentRNAIPLImporting = null;
        this.noOfRNAIPLImported = null;
        this.importRNAIPLinError = null;
        localStorage.setItem("currentRNAIPLImporting", this.currentRNAIPLImporting);
        localStorage.setItem("tempRNAIPLLinFileForLocal", null);
        localStorage.setItem("noOfRNAIPLImported", this.noOfRNAIPLImported);
        localStorage.setItem("importRNAIPLinError", this.importRNAIPLinError);
      } else {
        this.importRNAIPLByFileFunction(listObjForRNAIPL, currentRNAIPLImporting, noOfRNAIPLImported, importRNAIPLinError);
      }
    }
  async importRNAIPLByFileFunction(listObjForRNAIPL, currentRNAIPLImporting, noOfRNAIPLImported, importRNAIPLError) {
    this.importRNAIPLError = importRNAIPLError;
    if (currentRNAIPLImporting < listObjForRNAIPL.length) {
      console.info("currentRNAIPLImporting - ", currentRNAIPLImporting + ' - RNAIPL CODE:' + listObjForRNAIPL[currentRNAIPLImporting]['RNAIPL-CODE'])
    } else {
      console.info("currentRNAIPLImporting - ", currentRNAIPLImporting)
    }
    this.currentRNAIPLImporting = currentRNAIPLImporting;
    this.startUpload = 0; // Reset startUpload at the beginning of each iteration
    localStorage.setItem("currentRNAIPLImporting", this.currentRNAIPLImporting.toString());
    try {
      if (currentRNAIPLImporting < listObjForRNAIPL.length) {
        let BvDAssignBvd = listObjForRNAIPL[currentRNAIPLImporting]['BVD-ID']
        let data
        let param
        let data2 = await this.handleApiCall(this.sitesService.getAccessPointIdentifiers(this.Config.ApiSitesUrl + 'access-point-identifiers?identifierTypeName=AP_RNAIPL_CODE&identifierValue=' + listObjForRNAIPL[currentRNAIPLImporting]['RNAIPL-CODE']).toPromise(), 'Error in getting accesspointIdentifier', listObjForRNAIPL, currentRNAIPLImporting, noOfRNAIPLImported, importRNAIPLError, 'RNAIPL')
        if (data2['access-point-identifiers'].length == 0) {
          if (/^ST\d{8}$/.test(BvDAssignBvd)) {
            data = await this.handleApiCall(this.sitesService.getSites(this.Config.ApiSitesUrl + 'sites?identifier=' + BvDAssignBvd).toPromise(), 'Error in getting site assignments', listObjForRNAIPL, currentRNAIPLImporting, noOfRNAIPLImported, importRNAIPLError, 'RNAIPL')
            if (data['sites'].length == 1) {
              this.startUpload = 1
              param = 'reaIdentifier=' + BvDAssignBvd
            } else if (data['sites'].length > 1) {
              this.startUpload = TWO
            }
          } else {
            data = await this.handleApiCall(this.supplierService.getBusinessEntityIdentifiers(this.Config.ApiSupplierUrl + 'business-entity-identifiers?businessEntityIdentifierTypeName=BVD ID&value=' + BvDAssignBvd).toPromise(), 'Error in getting business entity identifiers', listObjForRNAIPL, currentRNAIPLImporting, noOfRNAIPLImported, importRNAIPLError, 'RNAIPL')
            if (data['business-entity-identifiers'].length == 1) {
              this.startUpload = 1
              param = 'businessEntityAllianceIdentifier=' + data['business-entity-identifiers'][0]['businessEntityAllianceIdentifier']
            } else if (data['business-entity-identifiers'].length > 1) {
              this.startUpload = TWO
            }
          }
          if (this.startUpload == 1) {
            if ((listObjForRNAIPL[currentRNAIPLImporting]['RNAIPL-CODE'] != undefined && listObjForRNAIPL[currentRNAIPLImporting]['RNAIPL-CODE'] != '' && this.isValidLength(listObjForRNAIPL[currentRNAIPLImporting]['RNAIPL-CODE'].toString()))) {
              if ((listObjForRNAIPL[currentRNAIPLImporting]['RNAIPL-NAME'] != undefined && listObjForRNAIPL[currentRNAIPLImporting]['RNAIPL-NAME'] != '') && listObjForRNAIPL[currentRNAIPLImporting]['RNAIPL-NAME'].length <= TEN) {
                let siteAssgnData = await this.handleApiCall(this.supplierService.getSiteAssignments(this.Config.ApiSupplierUrl + 'site-assignments?' + param).toPromise(), 'Error in getting site assignments', listObjForRNAIPL, currentRNAIPLImporting, noOfRNAIPLImported, importRNAIPLError, 'RNAIPL')
                if (siteAssgnData['site-assignments'].length > 0) {
                  const rowId = siteAssgnData['site-assignments'][0]['site']['href'].split('/')
                  const siteIdentifierFromAssignment = siteAssgnData['site-assignments'][0]['reaIdentifier'];
                  const siteDatas = {
                    activeStatus: 'ACTIVE',
                    realEstateAssetId: rowId[1],
                    label: siteAssgnData['site-assignments'][0]['businessEntityCompanyLegalName'],
                    type: 'P11',
                    effectiveDate: this.apiService.getTodayDate(),
                    irnAuthor: 'IRN-71016',
                    siaAuthor: 'IAF',
                    activity: 'A10'
                  };
                  this.sitesService.createAccessPoint(this.Config.ApiSitesUrl + 'access-points', siteDatas).pipe(

                    concatMap((acpCreation: any) => {
                      const acpRowId = acpCreation['rowId'];
                      return this.sitesService
                        .getAccessPoints(this.Config.ApiSitesUrl + 'access-points?siteIdentifier=' + siteIdentifierFromAssignment + '&type=in(' + "'P14'" + ')')
                        .pipe(
                          concatMap((p14Data: any) => {
                            const p14Identifier = p14Data && p14Data['access-points'] && p14Data['access-points'][0] ? p14Data['access-points'][0]['identifier'] : null;
                            if (!p14Identifier) {
                              return of({ acpCreation, acpRowId });
                            }
                            return this.sitesService
                              .getAccessPointAddresses(this.Config.ApiSitesUrl + 'access-points-addresses?accessPointIdentifier=' + p14Identifier)
                              .pipe(
                                concatMap((addrData: any) => {
                                  const addrList = (addrData && addrData['access-points-addresses']) ? addrData['access-points-addresses'] : [];
                                  if (!addrList.length) {
                                    return of({ acpCreation, acpRowId });
                                  }
                                  const createCalls = addrList.map((a: any) => {
                                    const payload = { accessPointId: acpRowId, addressId: a['addressId'] };
                                    return this.sitesService.createAccessPointAddress(this.Config.ApiSitesUrl + 'access-points-addresses', payload);
                                  });
                                  return forkJoin(createCalls).pipe(map(() => ({ acpCreation, acpRowId })));
                                })
                              );
                          })
                        );
                    }),

                    concatMap(({ acpCreation, acpRowId }: { acpCreation: any; acpRowId: any }) => {
                      const siteDatasRNAIPLCode = {
                        identifierId: this.siteIdentTypesData['AP_RNAIPL_CODE'],
                        sourceSystemId: this.siteSourceSystems['RNAIPL'],
                        accessPointRowId: acpRowId,
                        identifierValue: listObjForRNAIPL[currentRNAIPLImporting]['RNAIPL-CODE'],
                        siteIdentifier: acpCreation['siteIdentifier'],
                        accessPointIdentifier: acpCreation['identifier'],
                        effectiveDate: this.apiService.getTodayDate()
                      };
                      return this.sitesService.createAccessPointIdentifier(this.Config.ApiSitesUrl + 'access-point-identifiers', siteDatasRNAIPLCode).pipe(
                        map(() => ({ acpCreation, acpRowId }))
                      );
                    }),

                    concatMap(({ acpCreation, acpRowId }: { acpCreation: any; acpRowId: any }) => {
                      const siteDatasRNAIPLName = {
                        identifierId: this.siteIdentTypesData['SOCIAL_RAISON'],
                        sourceSystemId: this.siteSourceSystems['RNAIPL'],
                        accessPointRowId: acpRowId,
                        identifierValue: listObjForRNAIPL[currentRNAIPLImporting]['RNAIPL-NAME'],
                        siteIdentifier: acpCreation['siteIdentifier'],
                        accessPointIdentifier: acpCreation['identifier'],
                        effectiveDate: this.apiService.getTodayDate()
                      };
                      return this.sitesService.createAccessPointIdentifier(this.Config.ApiSitesUrl + 'access-point-identifiers', siteDatasRNAIPLName);
                    }),

                    concatMap(() => {
                      const siteId = rowId[1];
                      return from(this.blankupdate.siteBlankStatusUpdateAsync(siteId));
                    })
                  ).subscribe({
                    next: () => {
                      noOfRNAIPLImported++;
                      this.updateRNAIPLProgress(noOfRNAIPLImported, this.importRNAIPLError, listObjForRNAIPL.length)
                      this.repeatLoopFnForImportRNAIPL(listObjForRNAIPL, currentRNAIPLImporting, noOfRNAIPLImported, this.importRNAIPLError);
                    },
                    error: (err) => {
                      this.errorMessArrImportRNAIPLBacth.push({ "error": "BVD-ID: " + listObjForRNAIPL[currentRNAIPLImporting]['BVD-ID'] + " RNAIPL creation failed: " + (err?.message || err) });
                      this.importRNAIPLError++;
                      this.updateRNAIPLProgress(noOfRNAIPLImported, this.importRNAIPLError, listObjForRNAIPL.length);
                      this.repeatLoopFnForImportRNAIPL(listObjForRNAIPL, currentRNAIPLImporting, noOfRNAIPLImported, this.importRNAIPLError);
                      localStorage.setItem("errorMessArrImportRNAIPLBacth", JSON.stringify(this.errorMessArrImportRNAIPLBacth));
                    }
                  })
                } else {
                  // No site assignments found - log error and continue
                  console.info("[RNAIPL-IMPORT] No site assignments found for BVD-ID:", listObjForRNAIPL[currentRNAIPLImporting]['BVD-ID']);
                  this.errorMessArrImportRNAIPLBacth.push({ "error": "BVD-ID: " + listObjForRNAIPL[currentRNAIPLImporting]['BVD-ID'] + " No site assignments found" });
                  this.importRNAIPLError++;
                  this.updateRNAIPLProgress(noOfRNAIPLImported, this.importRNAIPLError, listObjForRNAIPL.length);
                  this.repeatLoopFnForImportRNAIPL(listObjForRNAIPL, currentRNAIPLImporting, noOfRNAIPLImported, this.importRNAIPLError);
                  localStorage.setItem("errorMessArrImportRNAIPLBacth", JSON.stringify(this.errorMessArrImportRNAIPLBacth));
                }

              } else {
                console.info("[RNAIPL-IMPORT] RNAIPL Names is Not OK:", listObjForRNAIPL[currentRNAIPLImporting]['BVD-ID']);
                this.errorMessArrImportRNAIPLBacth.push({ "error": "BVD-ID: " + listObjForRNAIPL[currentRNAIPLImporting]['BVD-ID'] + " RNAIPL Name " + listObjForRNAIPL[currentRNAIPLImporting]['RNAIPL-NAME'] + " is not OK" });
                this.importRNAIPLError++;
                this.updateRNAIPLProgress(noOfRNAIPLImported, this.importRNAIPLError, listObjForRNAIPL.length)
                this.repeatLoopFnForImportRNAIPL(listObjForRNAIPL, currentRNAIPLImporting, noOfRNAIPLImported, this.importRNAIPLError);
                localStorage.setItem("errorMessArrImportRNAIPLBacth", JSON.stringify(this.errorMessArrImportRNAIPLBacth));
              }
            } else {
              console.info("[RNAIPL-IMPORT] RNAIPL Codes is Not OK:", listObjForRNAIPL[currentRNAIPLImporting]['BVD-ID']);
              this.errorMessArrImportRNAIPLBacth.push({ "error": "BVD-ID: " + listObjForRNAIPL[currentRNAIPLImporting]['BVD-ID'] + " RNAIPL Code " + listObjForRNAIPL[currentRNAIPLImporting]['RNAIPL-CODE'] + " is not OK" });
              this.importRNAIPLError++;
              this.updateRNAIPLProgress(noOfRNAIPLImported, this.importRNAIPLError, listObjForRNAIPL.length)
              this.repeatLoopFnForImportRNAIPL(listObjForRNAIPL, currentRNAIPLImporting, noOfRNAIPLImported, this.importRNAIPLError);
              localStorage.setItem("errorMessArrImportRNAIPLBacth", JSON.stringify(this.errorMessArrImportRNAIPLBacth));
            }
          } else if (this.startUpload == TWO) {
            console.info("[RNAIPL-IMPORT] More than one occurrence in RFF for BVD-ID:", listObjForRNAIPL[currentRNAIPLImporting]['BVD-ID']);
            this.errorMessArrImportRNAIPLBacth.push({ "error": 'There is more than one occurrence for ' + listObjForRNAIPL[currentRNAIPLImporting]['BVD-ID'] });
            this.importRNAIPLError++;
            this.updateRNAIPLProgress(noOfRNAIPLImported, this.importRNAIPLError, listObjForRNAIPL.length)
            this.repeatLoopFnForImportRNAIPL(listObjForRNAIPL, currentRNAIPLImporting, noOfRNAIPLImported, this.importRNAIPLError);
            localStorage.setItem("errorMessArrImportRNAIPLBacth", JSON.stringify(this.errorMessArrImportRNAIPLBacth));
          } else {
            console.info("[RNAIPL-IMPORT] BVD-ID not found in RFF:", listObjForRNAIPL[currentRNAIPLImporting]['BVD-ID']);
            this.errorMessArrImportRNAIPLBacth.push({ "error": "BVD-ID: " + listObjForRNAIPL[currentRNAIPLImporting]['BVD-ID'] + " Not in RFF" });
            this.importRNAIPLError++;
            this.updateRNAIPLProgress(noOfRNAIPLImported, this.importRNAIPLError, listObjForRNAIPL.length)
            this.repeatLoopFnForImportRNAIPL(listObjForRNAIPL, currentRNAIPLImporting, noOfRNAIPLImported, this.importRNAIPLError);
            localStorage.setItem("errorMessArrImportRNAIPLBacth", JSON.stringify(this.errorMessArrImportRNAIPLBacth));
          }
        } else {
          console.info("[RNAIPL-IMPORT] Already in RFF:", listObjForRNAIPL[currentRNAIPLImporting]['BVD-ID']);
          this.errorMessArrImportRNAIPLBacth.push({ "error": "BVD-ID: " + listObjForRNAIPL[currentRNAIPLImporting]['BVD-ID'] + " RNAIPL Code " + listObjForRNAIPL[currentRNAIPLImporting]['RNAIPL-CODE'] + " already in RFS " + data2['access-point-identifiers'][0]['siteIdentifier'] + ' with this RNAIPL code' });
          this.importRNAIPLError++;
          this.updateRNAIPLProgress(noOfRNAIPLImported, this.importRNAIPLError, listObjForRNAIPL.length)
          this.repeatLoopFnForImportRNAIPL(listObjForRNAIPL, currentRNAIPLImporting, noOfRNAIPLImported, this.importRNAIPLError);
          localStorage.setItem("errorMessArrImportRNAIPLBacth", JSON.stringify(this.errorMessArrImportRNAIPLBacth));
        }
      }
    } catch (error) {

    }
    if (currentRNAIPLImporting == listObjForRNAIPL.length) {
      setTimeout(() => {

        this.TextForCompleteUploadImportRNAIPL = 'Imported ' + noOfRNAIPLImported + ' of ' + (listObjForRNAIPL.length) + '.';
        if (this.importRNAIPLError > 0) {
          this.TextForRNAIPLError = 'Error: ' + this.importRNAIPLError;
        }
        setTimeout(() => {
          this.showDownloadLogForRNAIPLBacthComplete = true;
        }, TEN_THOUSAND_MS);
        console.info("done")
        this.showDownloadLogForRNAIPLBacth = true;
        this.inputFileVisibleForImportRNAIPL = false;
        this.currentRNAIPLImporting = null;
        this.noOfRNAIPLImported = null;
        this.importRNAIPLError = null;
        localStorage.setItem("currentRNAIPLImporting", this.currentRNAIPLImporting);
        localStorage.setItem("tempRNAIPLInFileForLocal", null);
        localStorage.setItem("noOfRNAIPLImported", this.noOfRNAIPLImported);
        localStorage.setItem("importRNAIPLError", this.importRNAIPLError);
        localStorage.setItem('errorMessArrImportRNAIPLBacth', null);
        localStorage.setItem('totalRNAIPLToImport', null)
      }, THREE_THOUSAND_MS);
    }
  }
    private updateRNAIPLProgress(noOfRNAIPLImported: number, importRNAIPLError: number, total: number) {
      const successPortion = 'Importing ' + noOfRNAIPLImported + ' of ' + total + '.';
      this.TextForCompleteUploadImportRNAIPL = successPortion;
      if (importRNAIPLError > 0) {
        this.TextForRNAIPLError = 'Error: ' + importRNAIPLError;
      }
  
      localStorage.setItem('noOfRNAIPLImported', noOfRNAIPLImported.toString());
      localStorage.setItem('importRNAIPLError', importRNAIPLError.toString());
      if (Array.isArray(this.errorMessArrImportRNAIPLBacth)) {
        localStorage.setItem('errorMessArrImportRNAIPLBacth', JSON.stringify(this.errorMessArrImportRNAIPLBacth));
      }
    }
    async repeatLoopFnForImportRNAIPL(listObjForRNAIPL, currentRNAIPLImporting, noOfRNAIPLImported, importRNAIPLError): Promise<void> {
      console.info("repeating the loop")
      this.SiteRowID = []
      let twentyMinutesLater = new Date();
      let curentmni = twentyMinutesLater.setMinutes(twentyMinutesLater.getMinutes());
      console.info('curentmni', curentmni)
      if (currentRNAIPLImporting < listObjForRNAIPL.length) {
          this.showSessionTimeoutAlcorBatch = false
  
          if (currentRNAIPLImporting % BATCH_SIZE == 0) {
            return new Promise<void>((resolve) => {
              setTimeout(() => {
                currentRNAIPLImporting++;
                if (this.currentRNAIPLImportingStarted != currentRNAIPLImporting) {
                  this.importRNAIPLByFileFunction(listObjForRNAIPL, currentRNAIPLImporting, noOfRNAIPLImported, importRNAIPLError);
                  this.currentRNAIPLImportingStarted = currentRNAIPLImporting;
                }
                resolve();
              }, SIX_THOUSAND_MS);
            });
          } else {
            currentRNAIPLImporting++;
            if (this.currentRNAIPLImportingStarted != currentRNAIPLImporting) {
              this.importRNAIPLByFileFunction(listObjForRNAIPL, currentRNAIPLImporting, noOfRNAIPLImported, importRNAIPLError);
              this.currentRNAIPLImportingStarted = currentRNAIPLImporting;
            }
            return Promise.resolve();
          }
        // } else {
        //   window.location.reload();
        //   return Promise.resolve();
        // }
      }
      return Promise.resolve();
    }
  
    LogErrorforImportRNAIPL(listObjForRNAIPL, currentRNAIPLImporting, noOfRNAIPLImported, importRNAIPLError, errorMsg) {
      this.errorMessArrImportRNAIPLBacth.push({ "error": "BVD-ID: " + listObjForRNAIPL[currentRNAIPLImporting]['BVD-ID'] + errorMsg });
      localStorage.setItem("errorMessArrImportRNAIPLBacth", JSON.stringify(this.errorMessArrImportRNAIPLBacth));
      importRNAIPLError++;
      this.importContactsInError = importRNAIPLError;
      this.TextForContactsInError = 'Error: ' + importRNAIPLError;
      localStorage.setItem("importRNAIPLError", importRNAIPLError);
      this.repeatLoopFnForImportRNAIPL(listObjForRNAIPL, currentRNAIPLImporting, noOfRNAIPLImported, importRNAIPLError);
    }
  
    downloadLogFileForImportSupplierRNAIPLBacth() {
      let element = document.getElementById('excelTableLogForImportRNAIPLBacth');
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Import RNAIPL Batch');
      XLSX.writeFile(wb, 'ImportRNAIPLBacth.xlsx');
    }

  getSelectedValue(value) {
    this.AvalueSelected = [];
    this.AvalueSelected.push(value.value)
    this.CompanySelected = true;
    localStorage.setItem("selectedCompany", value.value);

    console.info('checked', this.AvalueSelected)
  }
  updateTaxidentifier() {
    this.updateTaxStarted = true;
    this.ImportTAxDisplayMsg = 'Updating TAX Identifiers...';
    this.GetCompanySelected()
    console.info('updateTaxidentifier')
  }

  GetCompanySelected(index = 0, subscribeData = [], page = 1) {
    this.supplierService.getCompanyNames(this.Config.ApiSupplierUrl + 'company-names?companyNameTypeName=SUPPLIER%20ACTIVITY&value=*' + encodeURIComponent('#' + this.AvalueSelected[index].trim()) + "&_page=" + page).subscribe((data: any) => {
      data['company-names'].forEach(dataC => {
        subscribeData.push(dataC)
        console.info('this.companyIds', this.companyIds)
        if (this.companyIds.findIndex(x => x == dataC['companyId']) == -1) {
          this.companyIds.push(dataC)
        }

      })
      if (data['maxPage'] > 1 && data['maxPage'] != page) {
        this.GetCompanySelected(index, subscribeData, page + 1)
      } else {
        if (this.companyIds.length > 0) {
          console.info('companyId', this.companyIds)
          this.totalTaxToImport = this.companyIds.length;
          localStorage.setItem("totalTaxToImport", this.totalTaxToImport);
          this.taxImportedAlready = []
          this.listObjForTax = this.companyIds;
          localStorage.setItem("listObjForTax", JSON.stringify(this.companyIds));
          localStorage.setItem("noOfTaxinError", this.noOfTaxinError);
          localStorage.setItem("taxImportedAlready", JSON.stringify(this.taxImportedAlready));


          this.updateidentifiers()
        }
        else {
          setTimeout(() => {
            this.ImportTAxDisplayMsg = "No companies to import";
            this.TextForCompleteUploadTax = ""
            localStorage.setItem("listObjForTax", null);
            localStorage.setItem("noOfTaxImported", null);
            localStorage.setItem("currentTaxImporting", null);
            localStorage.setItem("totalTaxToImport", null);
            localStorage.setItem("noOfTaxImported", null);
            this.showDownloadLogForTaxBatch = true;
          }, FIFTEEN_HUNDRED_MS);

        }
      }

    })
  }
  async updateidentifiers(CurrentTaximporting = 0, _importTaxInError = 0) {
    let ele = this.companyIds[CurrentTaximporting]['companyId']
    if (ele != undefined) {



      let count = CurrentTaximporting + 1;
      console.info("currentTaxIdImporting - ", +count + ' - Company Id:' + this.companyIds[CurrentTaximporting]['companyAllianceIdentifier'])

      this.ImportTAxDisplayMsg = "Importing " + count + " of " + this.totalTaxToImport;
      this.currentTaxImporting = CurrentTaximporting;
      localStorage.setItem("currentTaxImporting", this.currentTaxImporting);
      this.siteIdofCurrentImporting = '';
      this.businessEntityIdSite = '';
      this.siteBvdofCurrentImporting = '';

      let siteData = await this.handleApiCallTax(firstValueFrom(this.supplierService.getSiteAssignments(this.Config.ApiSupplierUrl + 'site-assignments?businessEntityCompanyId=' + ele + '&isHQ=Y&validityEndDate=is null')), 'Error fetching site-assignments of company', CurrentTaximporting, CurrentTaximporting + 1)
      console.info('siteData', siteData)
      if (siteData != undefined || siteData != null ? siteData['site-assignments'].length > 0 : 0) {
        this.siteIdofCurrentImporting = siteData['site-assignments'][0] ? siteData['site-assignments'][0]['reaIdentifier'] : null;
        let Bvd = await this.handleApiCallTax(firstValueFrom(this.supplierService.getBusinessEntityIdentifiers(this.Config.ApiSupplierUrl + 'business-entity-identifiers?businessEntityId=' + siteData['site-assignments'][0].businessEntityId)), 'Error fetching business entity identifiers', CurrentTaximporting, CurrentTaximporting + 1)
        this.siteBvdofCurrentImporting = ''
        this.businessEntityValue = Bvd['business-entity-identifiers']
        if (Bvd['business-entity-identifiers'].length > 0) {
          let siteBvdId = Bvd['business-entity-identifiers'].filter(x => x.businessEntityIdentifierTypeName == 'BVD ID')
          if (siteBvdId.length > 0) {
            this.siteBvdofCurrentImporting = siteBvdId[0].value;

            const bvdConst = { 'bvd-id': siteBvdId[0].value }
            let data = await this.handleApiCallTax(firstValueFrom(this.supplierService.createBvdInterface(this.Config.ApiSupplierUrl + 'bvd-interface', bvdConst)), 'Error fetching Bvd of the site:' + siteBvdId[0].value, CurrentTaximporting, CurrentTaximporting + 1)

            let bVdDatas = JSON.parse(data.result);
            if (bVdDatas['Data'][0] != undefined && bVdDatas['Data'][0] != null) {
              this.BvDdata = bVdDatas['Data'][0];
              this.currentOrbisStatus = bVdDatas['Data'][0]['STATUS'][0] != null ? bVdDatas['Data'][0]['STATUS'][0] : ''
            }
            console.info('this.bvdData', this.BvDdata);
            console.info('bVdDatas', bVdDatas);
            let variable = [];
            if (this.BvDdata != undefined && bVdDatas['Data'].length > 0) {

              if (bVdDatas['Data'][0]['NATIONAL_ID_LABEL'] != null) {
                console.info("bVdDatas['Data'][0]['NATIONAL_ID_LABEL']", bVdDatas['Data'][0]['NATIONAL_ID_LABEL'])
                if (typeof bVdDatas['Data'][0]['NATIONAL_ID_LABEL'] != "string") {
                  variable = bVdDatas['Data'][0]['NATIONAL_ID_LABEL'].filter(d1 => { return d1 != null });
                  bVdDatas['Data'][0]['NATIONAL_ID_LABEL'] = variable;
                }
                if (bVdDatas['Data'][0]['NATIONAL_ID_LABEL'].length > 0 && bVdDatas['Data'][0]['NATIONAL_ID_LABEL'] != null) {
                  let nationalIdLabel = [];
                  let nationalId = [];
                  nationalIdLabel = bVdDatas['Data'][0]['NATIONAL_ID_LABEL'];
                  nationalId = bVdDatas['Data'][0]['NATIONAL_ID'];
                  this.identifierTypes(CurrentTaximporting, nationalIdLabel, nationalId);
                  this.businessEntityIdSite = siteData['site-assignments'][0].businessEntityId


                }
              } else {
                this.noOfTaxinError++;
                localStorage.setItem("noOfTaxinError", this.noOfTaxinError);
                this.LogErrorforImportTax(this.currentTaxImporting, this.noOfTaxImported, 'No NATIONAL_ID_LABEL for bvd id')
                this.siteBvdofCurrentImporting = ''

              }

            } else {
              let busIdens = Bvd['business-entity-identifiers'].filter(x => x.businessEntityIdentifierTypeName != 'BVD ID')
              let temps = {};
              console.info('companyAliasAll', this.companyAliasAll)
              busIdens.forEach(e => {
                if (e.endDate == "") {
                  if (!this.companyAliasAll[e.businessEntityIdentifierTypeName]) {
                    this.companyAliasAll[e.businessEntityIdentifierTypeName] = [];
                  }
                  temps = { 'val': e.value, 'key': e.row_id, 'endDate': 'notarchived' }
                } else {
                  if (!this.companyAliasAll[e.businessEntityIdentifierTypeName]) {
                    this.companyAliasAll[e.businessEntityIdentifierTypeName] = [];
                  }
                  temps = { 'val': e.value, 'key': e.row_id, 'endDate': 'archived' }
                }
                this.companyAliasAll[e.businessEntityIdentifierTypeName].push(temps);
              })
              await this.deleteAllBusinesIdens(0, [], CurrentTaximporting);


            }
            console.info("BvDdata", this.BvDdata);



          } else {
            this.noOfTaxinError++;
            localStorage.setItem("noOfTaxinError", this.noOfTaxinError);
            this.LogErrorforImportTax(this.currentTaxImporting, this.noOfTaxImported, 'No BVD id for the site' + this.siteIdofCurrentImporting)
            this.siteBvdofCurrentImporting = ''

          }
        } else {
          this.noOfTaxinError++;
          localStorage.setItem("noOfTaxinError", this.noOfTaxinError);
          this.LogErrorforImportTax(this.currentTaxImporting, this.noOfTaxImported, 'No business-entity-identifiers for the site' + this.siteIdofCurrentImporting)
          this.siteBvdofCurrentImporting = ''

        }
      } else {
        this.noOfTaxinError++;
        localStorage.setItem("noOfTaxinError", this.noOfTaxinError);
        this.LogErrorforImportTax(this.currentTaxImporting, this.noOfTaxImported, 'No site -assignment for the company')
        this.siteIdofCurrentImporting = ''

      }

    } else {
      if (CurrentTaximporting == this.companyIds.length - 1) {
        setTimeout(() => {
          CurrentTaximporting++;
          this.ImportTAxDisplayMsg = "Imported " + CurrentTaximporting + " of " + this.companyIds.length + " ";
          this.TextForCompleteUploadTax = "Import done successfully"
          localStorage.setItem("listObjForTax", null);
          localStorage.setItem("noOfTaxImported", null);
          localStorage.setItem("currentTaxImporting", null);
          localStorage.setItem("totalTaxToImport", null);
          localStorage.setItem("taxImportedAlready", null);

          this.updateTaxStarted = false;
          this.showDownloadLogForTaxBatch = true;

        }, FIFTEEN_HUNDRED_MS);
      }
    }
  }
  async deleteAllBusinesIdens(page = 0, subscribeData = [], index) {
    let data = await this.handleApiCallTax(firstValueFrom(this.supplierService.getBuinessEntityIdentifierTypes(this.Config.ApiSupplierUrl + 'business-entity-identifier-types?type=TAXATION&_page=' + page)), 'Error fetching business entity identifier types', index, index + 1)

    this.CompanyIdentiTypes = [];
    this.TaxIdentifierKeys = [];
    this.TaxIdentifierType = [];
    this.compAliasType = [];
    data['business-entity-identifier-types'].forEach(element => {
      subscribeData.push(element)
    })
    if (data['maxPage'] > 1 && data['maxPage'] != page) {
      this.deleteAllBusinesIdens(page + 1, subscribeData, index);
    } else if (data['maxPage'] == page) {
      const setEndDate = { endDate: this.apiService.getTodayDate() }

      subscribeData.forEach(element => {
        this.TaxIdentifierKeys.push(element['name'])
        this.TaxIdentifierType.push(element);
      })
      const commonValues = this.TaxIdentifierKeys.filter(value => this.companyAliasAll[value] != undefined);
      console.info('commonValues', commonValues)
      if (commonValues.length > 0) {
        await commonValues.forEach(async (e, Taxindex) => {
          if (this.companyAliasAll[e]) {
            let errorOccured = false;
            for (let i = 0; i < this.companyAliasAll[e].length && !errorOccured; i++) {
              const ele = this.companyAliasAll[e][i];
              try {
                let data = await this.handleApiCallTaxwithoutlog(firstValueFrom(this.supplierService.updateBusinessEntityIdentifiers(this.Config.ApiSupplierUrl + 'business-entity-identifiers/' + ele.key + '?endDate=' + this.apiService.getTodayDate() + '&type=TAXATION', setEndDate)), 'Error while updating business entity identifiers to archived status', index, index + 1);
                if (Taxindex + 1 == commonValues.length) {
                  this.LogErrorforImportTax(index, index + 1, 'Imported Successfully');
                }
                console.info('archived', data);
              } catch (err) {
                console.info('errorMessage', err);
                this.noOfTaxinError++;
                errorOccured = true;
                localStorage.setItem("noOfTaxinError", this.noOfTaxinError);
                this.LogErrorforImportTax(index, index + 1, 'Error while updating business entity identifiers to archived status');
              }
            }
          }
        });
      }
      else {
        this.noOfTaxinError++;
        localStorage.setItem("noOfTaxinError", this.noOfTaxinError);
        this.LogErrorforImportTax(index, index + 1, 'Error while updating business entity identifiers to archived status');
      }
      console.info("TaxIdentifierType", this.TaxIdentifierType)

    }
  }
  async createNewIdentifiers(index, allNAKeyNames, nationalIdLabel, nationalId) {
    console.info('allNAKeyNames', allNAKeyNames);
    let errorOccured = false;
    for (let Keyindex = 0; Keyindex < allNAKeyNames.length; Keyindex++) {
      try {
        const e = allNAKeyNames[Keyindex];
        const createIden = { 'name': e, 'type': 'TAXATION' }
        let data = await this.handleApiCallTaxwithoutlog(firstValueFrom(this.supplierService.createBuinessEntityIdentifierTypes(this.Config.ApiSupplierUrl + 'business-entity-identifier-types', createIden)), 'Error while creating business entity identifier types', index, index + 1)

        if (Keyindex + 1 == allNAKeyNames.length) {
          await this.manageNewBeIdentifiers(index, nationalIdLabel, nationalId);
        }
      } catch (err) {
        console.info('errorMessage', err);
        this.noOfTaxinError++;
        errorOccured = true;
        localStorage.setItem("noOfTaxinError", this.noOfTaxinError);
        this.LogErrorforImportTax(index, index + 1, 'Error while creating business entity identifier types');

        break;
      }
    }
  }
  async deletePreviousIdentifiers2(Compindex, nationalIdLabel, nationalId, subscribeData = [], delBvdIds = [], page = 1) {
    let data = await this.handleApiCallTax(firstValueFrom(this.supplierService.getBusinessEntityIdentifiers(this.Config.ApiSupplierUrl + 'business-entity-identifiers?businessEntityId=in(' + this.businessEntityIdSite + ')&businessEntityIdentifierType=TAXATION&_page=' + page)), 'Error while fetching business entity identifier', Compindex, Compindex + 1)

    if (data['business-entity-identifiers'].length > 0) {
      data['business-entity-identifiers'].forEach(e => {
        if (e.businessEntityIdentifierTypeName != 'BVD ID') {
          delBvdIds.push(e);
        }
      });
    }
    if (data['maxPage'] > 1 && data['maxPage'] != page) {
      this.deletePreviousIdentifiers2(Compindex, nationalIdLabel, nationalId, subscribeData, delBvdIds, page + 1);
    } else if (data['maxPage'] == page) {
      const setEndDate = { endDate: this.apiService.getTodayDate() }
      let errorOccured = false;
      if (delBvdIds.length > 0) {
        for (let index = 0; index < delBvdIds.length && !errorOccured; index++) {
          const e = delBvdIds[index];
          try {
            if (e.endDate == "") {
              let data = await this.handleApiCallTaxwithoutlog(firstValueFrom(this.supplierService.updateBusinessEntityIdentifiers(this.Config.ApiSupplierUrl + 'business-entity-identifiers/' + e.row_id + '?endDate=' + this.apiService.getTodayDate(), setEndDate)), 'Error while archiving the business entity identifiers', Compindex, Compindex + 1)

              if (index + 1 == delBvdIds.length) {
                await this.postNewBeIdentifiers(Compindex, nationalIdLabel, nationalId, delBvdIds);
              }

            } else {
              if (index + 1 == delBvdIds.length) {
                await this.postNewBeIdentifiers(Compindex, nationalIdLabel, nationalId, delBvdIds);
              }
            }
          } catch (err) {
            console.info('errorMessage', err);
            this.noOfTaxinError++;
            errorOccured = true;
            localStorage.setItem("noOfTaxinError", this.noOfTaxinError);
            this.LogErrorforImportTax(Compindex, Compindex + 1, 'Error while archiving the business entity identifiers');

            break;
          }
        };
      } else {
        await this.postNewBeIdentifiers(Compindex, nationalIdLabel, nationalId, delBvdIds);
      }
    }

  }
  async postNewBeIdentifiers(index, nationalIdLabel, nationalId, archivedBIs) {
    let setDate = { "endDate": '', "startDate": this.apiService.getTodayDate() }
    let errorOccured = false;
    if (nationalId != null && nationalId != undefined) {
      for (let i = 0; i < nationalIdLabel.length && !errorOccured; i++) {
        try {
          if (nationalId[i] != undefined && nationalId[i] != null && this.businessEntityIdSite != '' && this.businessEntityIdSite != undefined) {
            setDate['value'] = "";
            const const2 = {
              "businessEntityIdentifierTypeId": this.companyIdenKeys[nationalIdLabel[i].toLowerCase()],
              "businessEntityIdentifierTypeName": nationalIdLabel[i],
              "startDate": this.apiService.getTodayDate(),
              "businessEntityId": this.businessEntityIdSite,
              "value": nationalId[i]
            }
            setDate['value'] = nationalId[i];

            let isExists = archivedBIs.filter(x => x.businessEntityIdentifierTypeId == const2.businessEntityIdentifierTypeId && x.value.replace(/[\. ,:-]+/g, "") == const2.value.replace(/[\. ,:-]+/g, ""))
            if (isExists.length == 0) {

              let data = await this.handleApiCallTaxwithoutlog(firstValueFrom(this.supplierService.CreateBusinessEntityIdentifiers(this.Config.ApiSupplierUrl + 'business-entity-identifiers', const2)), 'Error while creating the business entity identifiers', index, index + 1)
              if (i + 1 == nationalIdLabel.length) {

                this.LogErrorforImportTax(index, index + 1, 'Imported Successfully')

              }

            } else {

              let data = await this.handleApiCallTaxwithoutlog(firstValueFrom(this.supplierService.updateBusinessEntityIdentifiers(this.Config.ApiSupplierUrl + 'business-entity-identifiers/' + isExists[0].row_id + '?startDate=' + this.apiService.getTodayDate() + '&endDate=""', setDate)), 'Error while updating the business entity identifiers', index, index + 1)
              if (i + 1 == nationalIdLabel.length) {
                this.LogErrorforImportTax(index, index + 1, 'Imported Successfully')


              }


            }
          } else {
            if (i + 1 == nationalIdLabel.length) {
              this.noOfTaxinError++;
              localStorage.setItem("noOfTaxinError", this.noOfTaxinError);
              this.LogErrorforImportTax(index, index + 1, 'National ID doesnt exists for National label ' + nationalIdLabel[i])
            }
          }
        } catch (err) {
          console.error('errorMessage', err);
          this.noOfTaxinError++;
          errorOccured = true;
          localStorage.setItem("noOfTaxinError", this.noOfTaxinError);
          this.LogErrorforImportTax(index, index + 1, 'Error while updating the business entity identifiers');

          break;
        }
      }
    } else {
      this.noOfTaxinError++;
      localStorage.setItem("noOfTaxinError", this.noOfTaxinError);
      this.LogErrorforImportTax(index, index + 1, 'National ID doesnt existsfrom BVD orbis ')
      this.siteBvdofCurrentImporting = ''

    }
  }
  async manageNewBeIdentifiers(index, nationalIdLabel, nationalId, allKeyNames = [], allNAKeyNames = [], _subscribeData = [], _page = 1) {
    nationalIdLabel.forEach(e => {
      if (allKeyNames.indexOf(e.toLowerCase()) == -1) {
        allNAKeyNames.push(e);
      }
    });
    if (allNAKeyNames.length > 0) {
      await this.createNewIdentifiers(index, allNAKeyNames, nationalIdLabel, nationalId);
    } else {
      await this.deletePreviousIdentifiers2(index, nationalIdLabel, nationalId);
    }
  }

  identifierTypes(CurrentTaximporting = 0, nationalIdLabel = [], nationalId = [], idenType = [], allKeyNames = [], page = 1): any {
    this.supplierService.getBuinessEntityIdentifierTypes(this.Config.ApiSupplierUrl + 'business-entity-identifier-types?_page=' + page).subscribe((data: any) => {
      if (data['business-entity-identifier-types'].length > 0) {
        data['business-entity-identifier-types'].forEach(element => {
          idenType.push(element);
          allKeyNames.push(element['name'].toLowerCase())
        });
      } if (data['maxPage'] > 1 && data['maxPage'] != page) {
        this.identifierTypes(CurrentTaximporting, nationalIdLabel, nationalId, idenType, allKeyNames, page + 1);
      } else if (data['maxPage'] == page) {
        idenType.forEach(element => {
          if (element['name'] != undefined) {
            this.companyIdenKeys[element['name'].toLowerCase()] = element['row_id'];
          }
        });
        this.addOrbisStatus()
        this.manageNewBeIdentifiers(CurrentTaximporting, nationalIdLabel, nationalId, allKeyNames);
      }
    })
  }
  addOrbisStatus() {
    let orbisStatus = this.businessEntityValue.filter(d1 => { return d1['businessEntityIdentifierTypeName'] === 'ORBIS-STATUS' })
    if (orbisStatus.length == 1) {
      orbisStatus.forEach(entity => {
        if (entity.value == this.currentOrbisStatus) {
          const update = {
            "startDate": this.apiService.getTodayDate(),
            "endDate": ''
          }
          this.supplierService.updateBusinessEntityIdentifiers(this.Config.ApiSupplierUrl + 'business-entity-identifiers/' + entity['row_id'], update).subscribe(_data => {

          })
        } else {
          this.newOrbisStatus();
        }
      })
    } else if (orbisStatus.length > 1) {
      let neworbisStatus = orbisStatus.filter(d1 => { return d1['value'] === this.currentOrbisStatus })
      if (neworbisStatus.length == 0) {
        this.newOrbisStatus();
      }
      else if (neworbisStatus.length == 1) {
        neworbisStatus.forEach(entity => {
          const update = {
            "startDate": this.apiService.getTodayDate(),
            "endDate": ''
          }
          this.supplierService.updateBusinessEntityIdentifiers(this.Config.ApiSupplierUrl + 'business-entity-identifiers/' + entity['row_id'], update).subscribe(_data => {

          })
        })
      }
      let exsistOrbisStatus = orbisStatus.filter(d1 => { return d1['value'] !== this.currentOrbisStatus })
      if (exsistOrbisStatus.length > 0) {
        exsistOrbisStatus.forEach(entity => {
          const update = {
            "endDate": this.apiService.getTodayDate(),
          }
          this.supplierService.updateBusinessEntityIdentifiers(this.Config.ApiSupplierUrl + 'business-entity-identifiers/' + entity['row_id'], update).subscribe(_data => {

          })
        })
      }
    } else {
      this.newOrbisStatus();
    }
  }
  newOrbisStatus() {
    if (this.currentOrbisStatus != '') {
      const const2 = {
        "businessEntityIdentifierTypeId": this.companyIdenKeys['orbis-status'],
        "businessEntityIdentifierTypeName": 'ORBIS-STATUS',
        "startDate": this.apiService.getTodayDate(),
        "businessEntityId": this.businessEntityIdSite,
        "value": this.currentOrbisStatus
      }
      this.supplierService.CreateBusinessEntityIdentifiers(this.Config.ApiSupplierUrl + 'business-entity-identifiers', const2).subscribe(_data => {

      })
    }
  }
  getSupplierActivity() {
    let tempTaxInFileForLocal = localStorage.getItem('listObjForTax') == null || localStorage.getItem('listObjForTax') == 'null' ? null : JSON.parse(localStorage.getItem('listObjForTax'));
    if (tempTaxInFileForLocal == null) {
      this.listObjForTax = [];
      this.companyIds = [];
      this.AvalueSelected = []
      this.Avalue = []
      this.activityA = [];
      this.optActivityA = []
      this.activityLoaded = false;
      this.CompanySelected = false;
      this.updateTaxStarted = false;
      this.totalTaxToImport = 0;
      this.noOfTaxinError = 0;
      let types: any[]
      let optA = [];
      this.BvDdata = '';
      this.showDownloadLogForTaxBatch = false;
      this.companyAliasAll = [];
      this.CompanyIdentiTypes = [];
      this.TaxIdentifierKeys = [];
      this.TaxIdentifierType = [];
      this.compAliasType = [];
      this.businessEntityIdSite = '';
      this.TextForCompleteUploadTax = '';
      this.errorMessArrImportTaxBatch = [];
      this.taxImportedAlready = [];
      this.supplierService.getCompanyNameTypes(this.Config.ApiSupplierUrl + 'company-name-types?name=SUPPLIER%20ACTIVITY').subscribe((data: any) => {
        data['company-name-types'].forEach(data => {
          data.description = data.description.replace('<p>', '')
          data.description = data.description.replace('</p>', '')
          types = data.description.split(/<br\s*\/?>/i)
        })
        types.forEach(datas => {
          if (datas.includes("A#")) {
            datas = datas.replace("A#", '')
            optA.push(datas)
          }
        })
      })

      setTimeout(() => {
        optA.forEach(data => {
          this.optActivityA.push({ value: data, checked: false })
          this.Avalue.push('A#' + data)
        })
        this.activityLoaded = true;

      }, THREE_THOUSAND_MS)
    }
    else {
      let selectedcomp = localStorage.getItem("selectedCompany");

    }
  }

  busEntIdentifiers(subscribeData = [], page = 1) {
    this.supplierService.getBuinessEntityIdentifierTypes(this.Config.ApiSupplierUrl + 'business-entity-identifier-types?_page=' + page).subscribe((data: any) => {
      if (data['business-entity-identifier-types'].length > 0) {
        data['business-entity-identifier-types'].forEach(element => {
          subscribeData.push(element);
        });
        if (data['maxPage'] > 1 && data['maxPage'] != page) {
          this.busEntIdentifiers(subscribeData, page + 1);
        } else if (data['maxPage'] == page) {
          subscribeData.forEach(element => {
            this.companyIdenKeys[element['name']] = element['row_id'];
          });
        }
      }
    });
  }
  getCpyShortNameTypes(page = 1) {
    this.supplierService.getCompanyNameTypes(this.Config.ApiSupplierUrl + 'company-name-types?_page=' + page).subscribe(data => {

      data['company-name-types'].forEach(ele => {
        this.cpyShortNameTypes[ele.name] = ele.row_id;
      });
      if (data['maxPage'] > 1 && data['maxPage'] != page) {
        this.getCpyShortNameTypes(page + 1);
      }
    });
  }

  leftFillNum(num, targetLength) {
    return num.toString().padStart(targetLength, "0");
  }

  getSourceSytemId(page = 1, subscribeData = []) {
    this.sitesService.getSourceSystems(this.Config.ApiSitesUrl + 'source-systems?_page=' + page).subscribe(data => {
      if (data['source-systems'].length > 0) {
        data['source-systems'].forEach(ele => {
          this.siteSourceSystems[ele.name] = ele.rowId;
        });
        if (data['maxPage'] > 1 && data['maxPage'] != page) {
          this.getSourceSytemId(page + 1, subscribeData);
        }
      }
    });
  }

  AddTaxIdentifiersType(_site_row_id, companyIdenKeys, value, typeName, businessEntityIdSite) {
    const const2 = {
      "businessEntityIdentifierTypeId": companyIdenKeys,
      "businessEntityIdentifierTypeName": typeName,
      "startDate": this.apiService.getTodayDate(),
      "businessEntityId": businessEntityIdSite,
      "value": value
    }
    this.supplierService.CreateBusinessEntityIdentifiers(this.Config.ApiSupplierUrl + 'business-entity-identifiers', const2).subscribe(_data => {
    });
  }


  changeImportAlcorBatch($event) {
    this.TextForCompleteUploadImportAlcor = '';
    this.readImportAlcorBatchThis($event.target);
  }

  changeImportContactsBatch($event) {
    this.TextForCompleteUploadImportContacts = '';
    this.readImportContactsBatchThis($event.target);
  }
  readImportContactsBatchThis(inputValue: any) {
    this.fileToUpload = null;
    this.fileToUpload = inputValue.files[0];

    if (!this.fileType(this.fileToUpload, 'xlsx')) {
      const reader: FileReader = new FileReader();
      reader.readAsBinaryString(this.fileToUpload);


      reader.onload = (e: any) => {
        const binarystr: string = e.target.result;

        const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: 'binary' });

        const wsname: string = wb.SheetNames[0];

        const ws: XLSX.WorkSheet = wb.Sheets[wsname];


        const data = XLSX.utils.sheet_to_json(ws).map(row =>
          Object.keys(row).reduce((obj, key) => {
            obj[key.trim()] = row[key];
            return obj;
          }, {})
        );
        this.listObjForContacts = data;

        console.info(data);

        this.currentContactsImportingStarted = 0;

        this.importContactsPreReq(data);

      }
    };
  }
  async importContactsPreReq(listObjForContacts, currentContactsImporting = 0, noOfContactsImported = 0, importContactsInError = 0, reload = false) {

    await this.getPersonRoleType(listObjForContacts, currentContactsImporting, noOfContactsImported, importContactsInError, reload = false);

    if (reload == false) {
      this.importContactsBatchThis();
    }

  }
  async getPersonRoleType(listObjForContacts, currentContactsImporting = 0, noOfContactsImported = 0, importContactsInError = 0, reload = false) {
    let page = 1;
    let maxPage = 1;
    this.PersonRoles = [];

    while (page <= maxPage) {
      try {
        const data: any = await firstValueFrom(this.contactsService.getPersonRoleTypes(this.Config.ApinewContactsUrl + 'personRoleTypes?_page=' + page));
        data['personRoleTypes'].forEach(element => {
          this.PersonRoles.push(element);
        });
        maxPage = data['maxPage'];
        page++;
      } catch (error) {
        console.error('Error fetching person role types:', error);
        currentContactsImporting = listObjForContacts.length;
        this.errorMessArrImportContactsBatch.push({ "error": "error while getting person role types" });
        localStorage.setItem("errorMessArrImportAlcorBatch", JSON.stringify(this.errorMessArrImportAlcorBatch));
        importContactsInError++;
        this.importContactsInError = importContactsInError;
        this.TextForContactsInError = 'Error: ' + importContactsInError;
        localStorage.setItem("importContactsInError", importContactsInError.toString());
        this.TextForAlcorInError = 'Error: ' + importContactsInError;
        setTimeout(() => {
          this.showDownloadLogForContactsBatchComplete = true;
        }, TEN_THOUSAND_MS);
        console.info("done")
        this.showDownloadLogForContactsBatch = true;
        this.inputFileVisibleForImportContacts = false;
        this.currentContactsImporting = null;
        this.noOfContactsImported = null;
        this.importContactsInError = null;
        localStorage.setItem("currentContactsImporting", this.currentContactsImporting);
        localStorage.setItem("tempContactsInFileForLocal", null);
        localStorage.setItem("noOfContactsImported", this.noOfContactsImported);
        localStorage.setItem("importContactsInError", this.importContactsInError);
        break;
      }
    }

  }
  importContactsBatchThis() {
    this.showDownloadLogForContactsBatch = false;
    this.showDownloadLogForContactsBatchComplete = false;
    this.TextForCompleteUploadImportContacts = 'Uploading...';
    this.errorMessArrImportContactsBatch = [];
    this.logOfImportContactsBatch = [];
    this.importContactsInError = 0;
    this.noOfContactsImported = 0;
    this.currentContactsImporting = 0;
    localStorage.setItem("tempContactsInFileForLocal", JSON.stringify(this.listObjForContacts));
    this.totalContactsToImport = this.listObjForContacts.length;
    localStorage.setItem("totalContactsToImport", this.listObjForContacts.length);
    this.importContactsStartFn(this.listObjForContacts);
  }
  readImportAlcorBatchThis(inputValue: any) {
    this.fileToUpload = null;
    this.fileToUpload = inputValue.files[0];
    if (!this.fileType(this.fileToUpload, 'xlsx')) {

      const reader: FileReader = new FileReader();
      reader.readAsBinaryString(this.fileToUpload);


      reader.onload = (e: any) => {
        const binarystr: string = e.target.result;

        const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: 'binary' });
        const wsname: string = wb.SheetNames[0];

        const ws: XLSX.WorkSheet = wb.Sheets[wsname];

        this.AlcorHeaders = XLSX.utils.sheet_to_json(ws, { header: 1 })[0];
        const data = XLSX.utils.sheet_to_json(ws).map(row =>
          Object.keys(row).reduce((obj, key) => {
            obj[key.trim()] = row[key];
            return obj;
          }, {})
        );
        this.listObjForAlcor = data;

        console.info(data);

        this.currentAlcorImportingStarted = 0;

        this.importAlcorPreReq(data);

      }
    };
  }

  importContactsStartFn(listObjForContacts, currentContactsImporting = 0, noOfContactsImported = 0, importContactsInError = 0) {
    this.showDownloadLogForContactsBatch = false;
    this.showDownloadLogForContactsBatchComplete = false;
    this.inputFileVisibleForImportContacts = false;
    this.TextForCompleteUploadImportContacts = 'Uploading...';
    console.info("listObjForContacts", listObjForContacts)

    if (importContactsInError < 1) {
      this.TextForContactsInError = '';
    } else {
      this.TextForContactsInError = 'Error: ' + importContactsInError;
    }
    this.TextForCompleteUploadImportContacts = 'Importing ' + noOfContactsImported + ' of ' + (listObjForContacts.length) + ' ';

    if (!this.CheckForRequiredFieldsContacts(listObjForContacts, currentContactsImporting, importContactsInError, noOfContactsImported, true)) {
      currentContactsImporting = listObjForContacts.length;
      this.errorMessArrImportAlcorBatch.push({ "error": "Please Upload a Valid file format " });
      localStorage.setItem("errorMessArrImportContactsBatch", JSON.stringify(this.errorMessArrImportContactsBatch));
      importContactsInError++;
      this.importContactsInError = importContactsInError;
      this.TextForContactsInError = 'Error: ' + importContactsInError;
      localStorage.setItem("importContactsInError", importContactsInError.toString());

      this.TextForCompleteUploadImportAlcor = 'Imported ' + noOfContactsImported + ' of ' + (listObjForContacts.length) + '.';
      if (importContactsInError > 0) {
        this.TextForAlcorInError = 'Error: ' + importContactsInError;
      }
      setTimeout(() => {
        this.showDownloadLogForContactsBatchComplete = true;
      }, TEN_THOUSAND_MS);
      console.info("done")
      this.showDownloadLogForContactsBatch = true;
      this.inputFileVisibleForImportContacts = false;
      this.currentContactsImporting = null;
      this.noOfContactsImported = null;
      this.importContactsInError = null;
      localStorage.setItem("currentContactsImporting", this.currentContactsImporting);
      localStorage.setItem("tempContactsInFileForLocal", null);
      localStorage.setItem("noOfContactsImported", this.noOfContactsImported);
      localStorage.setItem("importContactsInError", this.importContactsInError);
    } else {
      this.importContactsByFileFunction(listObjForContacts, currentContactsImporting, noOfContactsImported, importContactsInError);
    }
  }

  async importContactsByFileFunction(listObjForContacts, currentContactsImporting, noOfContactsImported, importContactsInError) {
    if (currentContactsImporting < listObjForContacts.length) {
      console.info("currentContactsImporting - ", currentContactsImporting + ' - CompanyId:' + listObjForContacts[currentContactsImporting].CompanyID + ' - email:' + listObjForContacts[currentContactsImporting].Email)
    } else {
      console.info("currentContactsImporting - ", currentContactsImporting)
    }
    this.currentContactsImporting = currentContactsImporting;
    localStorage.setItem("currentContactsImporting", this.currentContactsImporting);
    try {
      if (currentContactsImporting < listObjForContacts.length) {
        if (this.CheckForRequiredFieldsContacts(listObjForContacts, currentContactsImporting, importContactsInError, noOfContactsImported)) {
          try {
            let page = 1;
            let maxPage = 1;
            let CompanyContacts = [];
            const company = await this.handleApiCall(firstValueFrom(this.supplierService.getCompanies(this.Config.ApiSupplierUrl + 'companies?allianceIdentifier=' + listObjForContacts[currentContactsImporting].CompanyID)),
              'Error while getting company details', listObjForContacts, currentContactsImporting, noOfContactsImported, importContactsInError);
            if (company['companies'].length > 0) {
              while (page <= maxPage) {
                try {
                  const data: any = await firstValueFrom(this.contactsService.getSupplierCompanyRoles(this.Config.ApinewContactsUrl + 'supplierCompanyRoles?personSupplierCompany=CtcSupplierCompanyService:' + company['companies'][0].rowId + '&personRoleStatus=VALIDATED&_page=' + page));
                  data['supplierCompanyRoles'].forEach(element => {
                    CompanyContacts.push(element);
                  });
                  maxPage = data['maxPage'];
                  page++;
                } catch (error) {
                  this.errorMessArrImportContactsBatch.push({ "error": "CompanyId:" + listObjForContacts[currentContactsImporting].CompanyId + "Email:" + listObjForContacts[currentContactsImporting].Email + "- Error while getting Company contact roles" });
                  localStorage.setItem("errorMessArrImportContactsBatch", JSON.stringify(this.errorMessArrImportContactsBatch));
                  importContactsInError++;
                  this.importContactsInError = importContactsInError;
                  this.TextForContactsInError = 'Error: ' + importContactsInError;
                  localStorage.setItem("importAlcorInError", importContactsInError);
                  this.repeatLoopFnForImportContacts(listObjForContacts, currentContactsImporting, noOfContactsImported, importContactsInError);
                  break;
                }
              }
              console.info('company', company)
              console.info('CompanyContacts', CompanyContacts)

              this.contactsService.getPersonAddresses(this.Config.ApinewContactsUrl + "personAddresses?summary=" + listObjForContacts[currentContactsImporting].Email.trim()).subscribe(async (data: any) => {
                console.info('personAddresses', data['personAddresses'])
                if (data['personAddresses'].length == 0) {

                  const datas10 = {
                    personFirstName: listObjForContacts[currentContactsImporting].FirstName.trim(),
                    personLastName: listObjForContacts[currentContactsImporting].LastName.trim(),
                  };


                  let newPersonId = await this.handleApiCall(firstValueFrom(this.contactsService.createPersons(this.Config.ApinewContactsUrl + 'persons', datas10)),
                    'Error while creating person', listObjForContacts, currentContactsImporting, noOfContactsImported, importContactsInError);
                  const datas12 = {
                    email: listObjForContacts[currentContactsImporting].Email.trim()
                  };

                  let newPersonEmail = await this.handleApiCall(firstValueFrom(this.contactsService.createEmailAddress(this.Config.ApinewContactsUrl + 'emailAddresses', datas12)),
                    'Error while creating email', listObjForContacts, currentContactsImporting, noOfContactsImported, importContactsInError);
                  const datas13 = {
                    personRowId: newPersonId['rowId'],
                    addressId: newPersonEmail['rowId']
                  };

                  await this.handleApiCall(firstValueFrom(this.contactsService.createPersonAddresses(this.Config.ApinewContactsUrl + 'personAddresses', datas13)),
                    'Error while linking email to the person', listObjForContacts, currentContactsImporting, noOfContactsImported, importContactsInError);

                  let tempnum = listObjForContacts[currentContactsImporting].CellPhone.replace(/ /g, '').replace(/-/g, '').replace(/\+\+/g, '+');
                  const datas14 = {
                    phoneType: "P",
                    phoneNumber: tempnum.toString().trim()
                  };
                  let newPersonPhone = await this.handleApiCall(firstValueFrom(this.contactsService.createTelephoneAddress(this.Config.ApinewContactsUrl + 'telephoneAddresses', datas14)),
                    'Error while creating phone number', listObjForContacts, currentContactsImporting, noOfContactsImported, importContactsInError);



                  const datas15 = {
                    personRowId: newPersonId['rowId'],
                    addressId: newPersonPhone['rowId']
                  };
                  await this.handleApiCall(firstValueFrom(this.contactsService.createPersonAddresses(this.Config.ApinewContactsUrl + 'personAddresses', datas15)),
                    'Error while linking phone to the person', listObjForContacts, currentContactsImporting, noOfContactsImported, importContactsInError);
                  let role = this.PersonRoles.find(x => x.roleTypeCode == listObjForContacts[currentContactsImporting].Function);
                  if (role != undefined) {

                    const datas18 = {
                      roleTypeId: role['rowId'],
                      personRowId: newPersonId['rowId'],
                      personSupplierCompany: "CtcSupplierCompanyService:" + company['companies'][0].rowId,
                      personRoleStatus: "VALIDATED",
                      startDate: this.apiService.getTodayDate()
                    };
                    await this.handleApiCall(firstValueFrom(this.contactsService.createSupplierCompanyRoles(this.Config.ApinewContactsUrl + 'supplierCompanyRoles', datas18)),
                      'Error while company to the person', listObjForContacts, currentContactsImporting, noOfContactsImported, importContactsInError);
                    noOfContactsImported++
                    this.noOfContactsImported = noOfContactsImported;
                    this.TextForCompleteUploadImportContacts = 'Imported ' + noOfContactsImported + ' of ' + (listObjForContacts.length) + ' ';
                    localStorage.setItem("noOfContactsImported", noOfContactsImported);
                    this.repeatLoopFnForImportContacts(listObjForContacts, currentContactsImporting, noOfContactsImported, importContactsInError);
                  } else {
                    this.LogErrorforImportContacts(listObjForContacts, currentContactsImporting, noOfContactsImported, importContactsInError, '- Contact role:' + listObjForContacts[currentContactsImporting].Function + ' doesnot exists')

                  }
                } else {
                  let checkIfexists = CompanyContacts.filter(x => x.personTypeCode == listObjForContacts[currentContactsImporting].Function.trim() && x.personRowId == data['personAddresses'][0].personRowId)
                  if (checkIfexists.length == 0) {
                    let IPNexists = firstValueFrom(this.contactsService.getUsers(this.Config.ApinewContactsUrl + 'users?personRowId=' + data['personAddresses'][0].personRowId))
                    let role = this.PersonRoles.find(x => x.roleTypeCode == listObjForContacts[currentContactsImporting].Function.trim());
                    if (role != undefined) {
                      const datas = {
                        roleTypeId: role['rowId'],
                        personRowId: data['personAddresses'][0].personRowId,
                        personSupplierCompany: "CtcSupplierCompanyService:" + company['companies'][0].rowId,
                        personRoleStatus: "VALIDATED",
                        startDate: this.apiService.getTodayDate()
                      };

                      await this.handleApiCall(firstValueFrom(this.contactsService.createSupplierCompanyRoles(this.Config.ApinewContactsUrl + 'supplierCompanyRoles', datas)), ' Error creating contact role', listObjForContacts, currentContactsImporting, noOfContactsImported, importContactsInError)
                      noOfContactsImported++
                      this.noOfContactsImported = noOfContactsImported;
                      this.TextForCompleteUploadImportContacts = 'Imported ' + noOfContactsImported + ' of ' + (listObjForContacts.length) + ' ';
                      localStorage.setItem("noOfContactsImported", noOfContactsImported);

                      this.repeatLoopFnForImportContacts(listObjForContacts, currentContactsImporting, noOfContactsImported, importContactsInError);
                    } else {
                      this.LogErrorforImportContacts(listObjForContacts, currentContactsImporting, noOfContactsImported, importContactsInError, '- Contact role:' + listObjForContacts[currentContactsImporting].Function + ' doesnot exists')

                    }
                  } else {
                    this.LogErrorforImportContacts(listObjForContacts, currentContactsImporting, noOfContactsImported, importContactsInError, '- Contact role:' + listObjForContacts[currentContactsImporting].Function + ' already exists')

                  }
                }
              })
            } else {
              this.LogErrorforImportContacts(listObjForContacts, currentContactsImporting, noOfContactsImported, importContactsInError, '- Company doesnot exist :' + listObjForContacts[currentContactsImporting].CompanyID)

            }
          } catch (error) {
            this.LogErrorforImportContacts(listObjForContacts, currentContactsImporting, noOfContactsImported, importContactsInError, '- Error while creating person')
          }

        }
      }
    }
    catch (error) {
      console.info(error);
      this.errorMessArrImportContactsBatch.push({ "error": "CompanyId:" + listObjForContacts[currentContactsImporting].CompanyId + "- Email:" + listObjForContacts[currentContactsImporting].Email + "- Error occured while importing " });
      localStorage.setItem("errorMessArrImportContactsBatch", JSON.stringify(this.errorMessArrImportContactsBatch));
      this.TextForCompleteUploadImportContacts = 'Imported ' + noOfContactsImported + ' of ' + (listObjForContacts.length) + '.';
      if (importContactsInError > 0) {
        this.TextForContactsInError = 'Error: ' + importContactsInError;
      }
      setTimeout(() => {
        this.showDownloadLogForContactsBatchComplete = true;
      }, TEN_THOUSAND_MS);
      console.info("done")
      this.showDownloadLogForContactsBatch = true;
      this.inputFileVisibleForImportContacts = false;
      this.currentContactsImporting = null;
      this.noOfContactsImported = null;
      this.importContactsInError = null;
      localStorage.setItem("currentContactsImporting", this.currentContactsImporting);
      localStorage.setItem("tempContactsInFileForLocal", null);
      localStorage.setItem("noOfContactsImported", this.noOfAlcorImported);
      localStorage.setItem("importContactsInError", this.importContactsInError);
    }
    if (currentContactsImporting == listObjForContacts.length) {
      setTimeout(() => {

        this.TextForCompleteUploadImportContacts = 'Imported ' + noOfContactsImported + ' of ' + (listObjForContacts.length) + '.';
        if (importContactsInError > 0) {
          this.TextForContactsInError = 'Error: ' + importContactsInError;
        }



        console.info("done")
        this.showDownloadLogForContactsBatch = true;
        this.inputFileVisibleForImportContacts = false;
        this.currentContactsImporting = null;
        this.noOfContactsImported = null;
        this.importContactsInError = null;
        localStorage.setItem("currentContactsImporting", this.currentContactsImporting);
        localStorage.setItem("tempContactsInFileForLocal", null);
        localStorage.setItem("noOfContactsImported", this.noOfContactsImported);
        localStorage.setItem("importContactsInError", this.importContactsInError);
      }, THREE_THOUSAND_MS);
    }
  }

  LogErrorforImportContacts(listObjForContacts, currentContactsImporting, noOfContactsImported, importContactsInError, errorMsg) {
    this.errorMessArrImportContactsBatch.push({ "error": "CompanyId:" + listObjForContacts[currentContactsImporting].CompanyID + "- Email:" + listObjForContacts[currentContactsImporting].Email + errorMsg });
    localStorage.setItem("errorMessArrImportContactsBatch", JSON.stringify(this.errorMessArrImportContactsBatch));
    importContactsInError++;
    this.importContactsInError = importContactsInError;
    this.TextForContactsInError = 'Error: ' + importContactsInError;
    localStorage.setItem("importContactsInError", importContactsInError);
    this.repeatLoopFnForImportContacts(listObjForContacts, currentContactsImporting, noOfContactsImported, importContactsInError);
  }

  LogErrorforImportDUNS(listObjForDUNS, currentDUNSImporting, noOfDUNSImported, importDUNSInError, errorMsg) {
    this.errorMessArrImportDUNSBatch.push({ "error": "CompanyId:" + listObjForDUNS[currentDUNSImporting].CompanyID + errorMsg });
    localStorage.setItem("errorMessArrImportContactsBatch", JSON.stringify(this.errorMessArrImportContactsBatch));
    importDUNSInError++;
    this.importContactsInError = importDUNSInError;
    this.TextForContactsInError = 'Error: ' + importDUNSInError;
    localStorage.setItem("importContactsInError", importDUNSInError);
    this.repeatLoopFnForImportDUNS(listObjForDUNS, currentDUNSImporting, noOfDUNSImported, importDUNSInError);
  }
  LogErrorforImportAlcor(listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError, errorMsg) {
    this.errorMessArrImportDUNSBatch.push({ "error": "BVD-ID: " + listObjForAlcor[currentAlcorImporting]['BVD-ID'] + errorMsg });
    localStorage.setItem("errorMessArrImportAlcorBatch", JSON.stringify(this.errorMessArrImportAlcorBatch));
    importAlcorInError++;
    this.importContactsInError = importAlcorInError;
    this.TextForContactsInError = 'Error: ' + importAlcorInError;
    localStorage.setItem("importContactsInError", importAlcorInError);
    this.repeatLoopFnForImportAlcor(listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError);
  }
  LogErrorforImportTax(currentTaxImporting, _noOfTaxImported, errorMsg) {
    this.errorMessArrImportTaxBatch.push({ "error": errorMsg, 'CompanyId': this.companyIds[currentTaxImporting]['companyAllianceIdentifier'], 'Bvdid': this.siteBvdofCurrentImporting, 'siteId': this.siteIdofCurrentImporting });
    localStorage.setItem("errorMessArrImportTaxBatch", JSON.stringify(this.errorMessArrImportTaxBatch));
    this.repeatLoopFnForImportTax(currentTaxImporting);
  }
  repeatLoopFnForImportTax(currentTaxImporting) {
    console.info("repeating the loop")
    let twentyMinutesLater = new Date();
    let curentmni = twentyMinutesLater.setMinutes(twentyMinutesLater.getMinutes());
    console.info('curentmni', curentmni)
    if (currentTaxImporting < this.companyIds.length) {
      // if ((parseInt(localStorage.getItem('expiredtime')) - curentmni <= 120000 && (parseInt(localStorage.getItem('expiredtime')) - curentmni) > 0) || (parseInt(localStorage.getItem('IDPexpiredtime')) - curentmni <= 120000 && (parseInt(localStorage.getItem('IDPexpiredtime')) - curentmni) > 0)) {
      //   this.showSessionTimeoutTaxBatch = true
      //   setTimeout(() => {
      //     window.location.reload();
      //   }, 122000);
      // }
      // else if (parseInt(localStorage.getItem('expiredtime')) >= curentmni || parseInt(localStorage.getItem('IDPexpiredtime')) >= curentmni) {
        this.showSessionTimeoutTaxBatch = false

        if (currentTaxImporting == this.companyIds.length - 1) {
          setTimeout(() => {
            this.taxImportedAlready.push(this.companyIds[currentTaxImporting])
            localStorage.setItem("taxImportedAlready", JSON.stringify(this.taxImportedAlready));

            currentTaxImporting++;
            this.ImportTAxDisplayMsg = "Imported " + currentTaxImporting + " of " + this.companyIds.length + " ";
            this.TextForCompleteUploadTax = "Import done successfully"
            localStorage.setItem("listObjForTax", null);
            localStorage.setItem("noOfTaxImported", null);
            localStorage.setItem("currentTaxImporting", null);
            localStorage.setItem("totalTaxToImport", null);
            localStorage.setItem("listObjForTax", null);
            localStorage.setItem("noOfTaxinError", null);
            this.showDownloadLogForTaxBatch = true;

          }, FIFTEEN_HUNDRED_MS);
        } else {
          localStorage.setItem("noOfTaxImported", currentTaxImporting);
          currentTaxImporting++;
          if (this.taxImportedAlready.findIndex((x: any) => x == this.companyIds[currentTaxImporting]) == -1) {
            this.taxImportedAlready.push(this.companyIds[currentTaxImporting])
            localStorage.setItem("taxImportedAlready", JSON.stringify(this.taxImportedAlready));
            this.updateidentifiers(currentTaxImporting)

          } else {
            this.repeatLoopFnForImportTax(currentTaxImporting)
          }


        }
      // } else {
      //   window.location.reload();
      // }
    } else {
      this.showDownloadLogForTaxBatch = true;
      this.TextForCompleteUploadTax = "Import done successfully"
      localStorage.setItem("listObjForTax", null);
      localStorage.setItem("noOfTaxImported", null);
      localStorage.setItem("currentTaxImporting", null);
      localStorage.setItem("totalTaxToImport", null);
      localStorage.setItem("listObjForTax", null);
      localStorage.setItem("noOfTaxinError", null);
    }
  }

  async handleApiCallTax(apiCall: Promise<any>, errorMessage: string, currentContactsImporting, noofTaxImported) {
    try {
      return await apiCall;
    } catch (error) {
      console.error('errorMessage', error);
      this.noOfTaxinError++;
      localStorage.setItem("noOfTaxinError", this.noOfTaxinError);
      this.LogErrorforImportTax(currentContactsImporting, noofTaxImported, errorMessage);

    }
  }
  async handleApiCallTaxwithoutlog(apiCall: Promise<any>, _errorMessage: string, _currentContactsImporting, _noofTaxImported) {

    return await apiCall
  }

  async handleApiCall(apiCall: Promise<any>, errorMessage: string, listObjForContacts, currentContactsImporting, noOfContactsImported, importContactsInError, batch = '') {
    try {
      return await apiCall;
    } catch (error) {
      console.error(errorMessage, error);
      if (batch == '') {
        this.LogErrorforImportContacts(listObjForContacts, currentContactsImporting, noOfContactsImported, importContactsInError, errorMessage);
      } else if (batch == 'alcor') {
        this.LogErrorforImportAlcor(listObjForContacts, currentContactsImporting, noOfContactsImported, importContactsInError, errorMessage);
      } else if (batch == 'saer') {
        this.LogErrorforImportSaer(listObjForContacts, currentContactsImporting, noOfContactsImported, importContactsInError, errorMessage);
      } else if (batch == 'latam') {
        this.LogErrorforImportLatam(listObjForContacts, currentContactsImporting, noOfContactsImported, importContactsInError, errorMessage);
      } else if (batch == 'rnaipl') {
        this.LogErrorforImportRNAIPL(listObjForContacts, currentContactsImporting, noOfContactsImported, importContactsInError, errorMessage);
      }else {
        this.LogErrorforImportDUNS(listObjForContacts, currentContactsImporting, noOfContactsImported, importContactsInError, errorMessage);
      }
    }
  }
  async finished() {
    try {

      let count = this.bvdimportService.createdSite.length
      let update = 0
      for (const siteId of this.bvdimportService.createdSite) {
        if (siteId) {
          update++
          await this.blankupdate.siteBlankStatusUpdateAsync(siteId);
          if (update == count) {
            console.info('Updated count for' + this.listObjForBvdId[this.currentBvdIdImporting]['BVD-ID'])
            this.noOfBvdIdImported++
            localStorage.setItem('noOfBvdIdImported', String(this.noOfBvdIdImported));
            this.updateBvdIdProgress(this.noOfBvdIdImported, this.importBvdIdInError || 0, this.listObjForBvdId ? this.listObjForBvdId.length : 0);
          }
        }
      }
    } catch (err) {
      console.error('[BVD-IMPORT][finished] Blank status update failed', err);

    }
    // Check if import was interrupted by server error before continuing
    if (this.bvdimportService.Error502) {
      console.info('[BVD-IMPORT][finished] Stopping - Error502 flag is set');
      return;
    }
    setTimeout(() => {
      this.repeatLoopFnForImportBvdId(this.listObjForBvdId, this.currentBvdIdImporting, this.noOfBvdIdImported, this.importBvdIdInError)
    }, SIX_THOUSAND_MS)
  }
  async groupLinkError() {
    this.errorMessArrImportBvdIdBatch.push({ "error": "BVD-ID: " + this.listObjForBvdId[this.currentBvdIdImporting]['BVD-ID'] + this.bvdimportService.groupLinkError });
    localStorage.setItem('errorMessArrImportBvdIdBatch', JSON.stringify(this.errorMessArrImportBvdIdBatch));
    if (this.bvdimportService.Error502) {
      this.clearBvdIdImportStorage();
      this.showDownloadLogForBvdIdBatch = true;
      this.inputFileVisibleForImportBvdId = false;
      this.displayMessage = 'Import interrupted due to server issues. Please try again later.';
    } else {
      this.displayMessage = ''
      if (this.listObjForBvdId.length === 1 || this.currentBvdIdImporting === this.listObjForBvdId.length - 1) {
        this.showDownloadLogForBvdIdBatch = true;
        this.inputFileVisibleForImportBvdId = false;
        this.clearBvdIdImportStorage();
      }
      console.info('Errors', this.errorMessArrImportBvdIdBatch)
      this.importBvdIdInError++;
      this.updateBvdIdProgress(this.noOfBvdIdImported, this.importBvdIdInError || 0, this.listObjForBvdId ? this.listObjForBvdId.length : 0);
      setTimeout(() => {
        this.repeatLoopFnForImportBvdId(this.listObjForBvdId, this.currentBvdIdImporting, this.noOfBvdIdImported, this.importBvdIdInError)
      }, SIX_THOUSAND_MS)
    }
  }
  async repeatLoopFnForImportAlcor(listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError): Promise<void> {
    console.info("repeating the loop")
    this.SiteRowID = []
    let twentyMinutesLater = new Date();
    let curentmni = twentyMinutesLater.setMinutes(twentyMinutesLater.getMinutes());
    console.info('curentmni', curentmni)
    if (currentAlcorImporting < listObjForAlcor.length) {
      // if ((parseInt(localStorage.getItem('expiredtime')) - curentmni <= 120000 && (parseInt(localStorage.getItem('expiredtime')) - curentmni) > 0) || (parseInt(localStorage.getItem('IDPexpiredtime')) - curentmni <= 120000 && (parseInt(localStorage.getItem('IDPexpiredtime')) - curentmni) > 0)) {
      //   return Promise.resolve();
      // }
      // else if (parseInt(localStorage.getItem('expiredtime')) >= curentmni || parseInt(localStorage.getItem('IDPexpiredtime')) >= curentmni) {
        this.showSessionTimeoutAlcorBatch = false

        if (currentAlcorImporting % BATCH_SIZE == 0) {
          return new Promise<void>((resolve) => {
            setTimeout(() => {
              currentAlcorImporting++;
              if (this.currentAlcorImportingStarted != currentAlcorImporting) {
                this.importAlcorByFileFunction(listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError);
                this.currentAlcorImportingStarted = currentAlcorImporting;
              }
              resolve();
            }, SIX_THOUSAND_MS);
          });
        } else {
          currentAlcorImporting++;
          if (this.currentAlcorImportingStarted != currentAlcorImporting) {
            this.importAlcorByFileFunction(listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError);
            this.currentAlcorImportingStarted = currentAlcorImporting;
          }
          return Promise.resolve();
        }
      // } else {
      //   window.location.reload();
      //   return Promise.resolve();
      // }
    }
    return Promise.resolve();
  }
  importAlcorPreReq(listObjForAlcor, currentAlcorImporting = 0, _noOfAlcorImported = 0, importAlcorInError = 0, reload = false) {
    this.CompanyStatusAll = [];
    this.CompanyStatusAllForGuo = [];
    this.supplierService.getCompanySatus(this.Config.ApiSupplierUrl + 'company-status').subscribe((data: any) => {

      data['company-status'].forEach(element10 => {
        if (element10['code'] == 'Approved') {
          this.CompanyStatusAll.push(element10);
        }
        if (element10['code'] == 'Identified') {
          this.CompanyStatusAllForGuo.push(element10);
        }
      });

      this.getSiteIdenTypes();
      this.getSourceSytemId();
      this.busEntIdentifiers();
      this.getCpyShortNameTypes();
      this.AllCompanyIdentifierTypes();
      this.getGroupCategories();
      if (reload == false) {
        this.importAlcorBatchThis();
      }

    }, _err => {
      currentAlcorImporting = listObjForAlcor.length;
      this.errorMessArrImportAlcorBatch.push({ "error": "ALcor Code:" + this.leftFillNum(listObjForAlcor[currentAlcorImporting].ALCOR_CODE, SIX) + "error while getting company-status" });
      localStorage.setItem("errorMessArrImportAlcorBatch", JSON.stringify(this.errorMessArrImportAlcorBatch));
      importAlcorInError++;
      this.importAlcorInError = importAlcorInError;
      this.TextForAlcorInError = 'Error: ' + importAlcorInError;
      localStorage.setItem("importAlcorInError", importAlcorInError.toString());
      this.TextForAlcorInError = 'Error: ' + importAlcorInError;
      setTimeout(() => {
        this.showDownloadLogForAlcorBatchComplete = true;
      }, TEN_THOUSAND_MS);
      console.info("done")
      this.showDownloadLogForAlcorBatch = true;
      this.inputFileVisibleForImportAlcor = false;
      this.currentAlcorImporting = null;
      this.noOfAlcorImported = null;
      this.importAlcorInError = null;
      localStorage.setItem("currentAlcorImporting", this.currentAlcorImporting);
      localStorage.setItem("tempAlcorInFileForLocal", null);
      localStorage.setItem("noOfAlcorImported", this.noOfAlcorImported);
      localStorage.setItem("importAlcorInError", this.importAlcorInError);
    });

  }
  importAlcorPreReqForReload(listObjForAlcor, currentAlcorImporting = 0, noOfAlcorImported = 0, importAlcorInError = 0) {
    this.CompanyStatusAll = [];
    this.CompanyStatusAllForGuo = [];
    this.supplierService.getCompanySatus(this.Config.ApiSupplierUrl + 'company-status').subscribe((data: any) => {
      data['company-status'].forEach(element10 => {
        if (element10['code'] == 'Approved') {
          this.CompanyStatusAll.push(element10);
        }
        if (element10['code'] == 'Identified') {
          this.CompanyStatusAllForGuo.push(element10);
        }
      });

      this.getSiteIdenTypes();
      this.getSourceSytemId();
      this.busEntIdentifiers();
      this.getCpyShortNameTypes();
      this.AllCompanyIdentifierTypes();
      this.getGroupCategories();
      this.importAlcorByFileFunction(listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError)
    }, _err => {
      currentAlcorImporting = listObjForAlcor.length;
      this.errorMessArrImportAlcorBatch.push({ "error": "ALcor Code:" + this.leftFillNum(listObjForAlcor[currentAlcorImporting].ALCOR_CODE, SIX) + "error while getting company-status" });
      localStorage.setItem("errorMessArrImportAlcorBatch", JSON.stringify(this.errorMessArrImportAlcorBatch));
      importAlcorInError++;
      this.importAlcorInError = importAlcorInError;
      this.TextForAlcorInError = 'Error: ' + importAlcorInError;
      localStorage.setItem("importAlcorInError", importAlcorInError.toString());
      setTimeout(() => {
        this.showDownloadLogForAlcorBatchComplete = true;
      }, TEN_THOUSAND_MS);
      console.info("done")
      this.showDownloadLogForAlcorBatch = true;
      this.inputFileVisibleForImportAlcor = false;
      this.currentAlcorImporting = null;
      this.noOfAlcorImported = null;
      this.importAlcorInError = null;
      localStorage.setItem("currentAlcorImporting", this.currentAlcorImporting);
      localStorage.setItem("tempAlcorInFileForLocal", null);
      localStorage.setItem("noOfAlcorImported", this.noOfAlcorImported);
      localStorage.setItem("importAlcorInError", this.importAlcorInError);
    });

  }

  getGroupCategories(page = 1, subscribeData = []) {
    this.groupCategoryModel = '';
    this.supplierService.getGroupTypes(this.Config.ApiSupplierUrl + 'group-types?_page=' + page).pipe(takeUntil(this.ngUnsubscribe)).subscribe((data: any) => {
      if (data['group-types'] && data['group-types'] != null) {
        data['group-types'].forEach(e => {
          if (e.groupTypeCode == "BOP/NBOP" || e['groupTypeCode'].toLowercase() == 'external supplier') {
            subscribeData = e.row_id;
          }
        });
        if (data['maxPage'] > 1 && data['maxPage'] != page) {
          this.getGroupCategories(page + 1, subscribeData);
        } else if (data['maxPage'] == page) {
          this.groupCategoryModel = subscribeData;
        }
      }
    }, error => {
      console.info('data_error', error);
    });
  }

  importAlcorBatchThis() {
    this.showDownloadLogForAlcorBatch = false;
    this.showDownloadLogForAlcorBatchComplete = false;
    this.TextForCompleteUploadImportAlcor = 'Uploading...';
    this.errorMessArrImportAlcorBatch = [];
    this.logOfImportAlcorBatch = [];
    this.CountryNameKeyIds = "";
    this.CountryNameKeyIds = [];
    this.importAlcorInError = 0;
    this.noOfAlcorImported = 0;
    this.currentAlcorImporting = 0;
    localStorage.setItem("tempAlcorInFileForLocal", JSON.stringify(this.listObjForAlcor));
    this.totalAlcorToImport = this.listObjForAlcor.length;
    localStorage.setItem("totalAlcorToImport", this.listObjForAlcor.length);
    this.importAlcorStartFn(this.listObjForAlcor);
  }
  onImportAlcorClick() {
    this.uploadDocError = false
    let tempAlcorInFileForLocal = JSON.parse(localStorage.getItem('tempAlcorInFileForLocal'));
    if (tempAlcorInFileForLocal == null) {
      this.inputFileVisibleForImportAlcor = true;
      this.showDownloadLogForAlcorBatch = false;
      this.showDownloadLogForAlcorBatchComplete = false;
      this.TextForAlcorInError = '';
      this.TextForCompleteUploadImportAlcor = '';
    }
  }
  onImportContactsClick() {
    this.uploadDocError = false
    let tempContactsInFileForLocal = JSON.parse(localStorage.getItem('tempContactsInFileForLocal'));
    if (tempContactsInFileForLocal == null) {
      this.inputFileVisibleForImportContacts = true;
      this.showDownloadLogForContactsBatch = false;
      this.showDownloadLogForContactsBatchComplete = false;
      this.TextForContactsInError = '';
      this.TextForCompleteUploadImportContacts = '';
    }
  }


  onImportBvdIdBatchClick() {
    this.uploadDocError = false
    let tempBvdIdInFileForLocal = JSON.parse(localStorage.getItem('tempBvdIdInFileForLocal'));
    if (tempBvdIdInFileForLocal == null) {
      this.inputFileVisibleForImportBvdId = true;
      this.showDownloadLogForBvdIdBatch = false;
      this.showDownloadLogForBvdIdBatchComplete = false;
      this.TextForBvdIdInError = '';
      this.TextForCompleteUploadImportBvdId = '';
      this.displayMessage = ''
      this.errorMessArrImportBvdIdBatch = []
      localStorage.setItem("errorMessArrImportBvdIdBatch", null);
    }
  }
  changeImportBvdIdBatch($event) {
    this.TextForCompleteUploadImportBvdId = '';
    this.readImportBvdIdBatchThis($event.target)
  }

  readImportBvdIdBatchThis(inputValue) {
    this.fileToUpload = null;
    this.fileToUpload = inputValue.files[0];
    if (!this.fileType(this.fileToUpload, 'xlsx')) {
      const reader: FileReader = new FileReader();
      reader.readAsBinaryString(this.fileToUpload);
      reader.onload = (e: any) => {
        const binarystr: string = e.target.result;
        const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: 'binary' });
        const wsname: string = wb.SheetNames[0];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];

        const data = XLSX.utils.sheet_to_json(ws).map(row =>
          Object.keys(row).reduce((obj, key) => {
            obj[key.trim()] = row[key];
            return obj;
          }, {})
        );
        this.BvdHeaders = XLSX.utils.sheet_to_json(ws, { header: 1 })[0];
        this.listObjForBvdId = data
        console.info(data)
        this.currentBvdIdImporting = 0;
        this.importBvdIdBatchThis()
      }
    }
  }
  importBvdIdBatchThis() {
    this.showDownloadLogForBvdIdBatch = false;
    this.showDownloadLogForBvdIdBatchComplete = false;

    this.TextForCompleteUploadImportBvdId = 'Uploading...';
    this.errorMessArrImportBvdIdBatch = [];
    this.logOfImportBvdIdBatch = [];
    this.CountryNameKeyIds = "";
    this.CountryNameKeyIds = [];
    this.importBvdIdInError = 0;
    this.noOfBvdIdImported = 0;
    this.currentBvdIdImporting = 0;
    this.displayMessage = ''
    localStorage.setItem("tempBvdIdInFileForLocal", JSON.stringify(this.listObjForBvdId));

    this.totalBvdIdToImport = this.listObjForBvdId.length;
    localStorage.setItem("totalBvdIdToImport", this.totalBvdIdToImport);
    this.importBvdStartFn(this.listObjForBvdId);
  }
  importBvdStartFn(listObjForBvdId, currentBvdIdImporting = 0, noOfBvdIdImported = 0, importBvdIdInError = 0) {
    this.showDownloadLogForBvdIdBatch = false;
    this.showDownloadLogForBvdIdBatchComplete = false;
    this.inputFileVisibleForImportBvdId = false;
    this.TextForCompleteUploadImportBvdId = 'Uploading...'
    console.info("listObjforBvdId", listObjForBvdId)

    const persistedCurrent = localStorage.getItem('currentBvdIdImporting');
    const persistedImported = localStorage.getItem('noOfBvdIdImported');
    const persistedErrors = localStorage.getItem('importBvdIdInError');
    const persistedErrArr = localStorage.getItem('errorMessArrImportBvdIdBatch');
    if (persistedCurrent && persistedCurrent !== 'null') {
      currentBvdIdImporting = Number(persistedCurrent) || 0;
    }
    if (persistedImported && persistedImported !== 'null') {
      noOfBvdIdImported = Number(persistedImported) || 0;
    }
    if (persistedErrors && persistedErrors !== 'null') {
      importBvdIdInError = Number(persistedErrors) || 0;
    }
    if (persistedErrArr && persistedErrArr !== 'null') {
      try { this.errorMessArrImportBvdIdBatch = JSON.parse(persistedErrArr) || []; } catch (e) { this.errorMessArrImportBvdIdBatch = []; }
    }
    this.updateBvdIdProgress(noOfBvdIdImported, importBvdIdInError, listObjForBvdId.length);
    if (importBvdIdInError < 1) {
      this.TextForBvdIdInError = '';
    } else {
      this.TextForDUNSInError = 'Error: ' + importBvdIdInError;
    }
    this.TextForCompleteUploadImportBvdId = 'Importing ' + noOfBvdIdImported + ' of ' + (listObjForBvdId.length) + ' ';
    if (!this.checkFileFormat('BvdId', listObjForBvdId)) {
      currentBvdIdImporting = listObjForBvdId.length
      this.errorMessArrImportBvdIdBatch.push({ "error": "Please Upload Valid file format " })
      localStorage.setItem("errorMessArrImportBvdIdBatch", JSON.stringify(this.errorMessArrImportBvdIdBatch));
      importBvdIdInError++;
      this.importBvdIdInError = importBvdIdInError;
      this.TextForBvdIdInError = 'Error: ' + importBvdIdInError;
      localStorage.setItem("importBvdIdInError", importBvdIdInError.toString());
      this.TextForCompleteUploadImportBvdId = 'Imported ' + noOfBvdIdImported + ' of ' + (listObjForBvdId.length) + '.';
      if (importBvdIdInError > 0) {
        this.TextForBvdIdInError = 'Error: ' + importBvdIdInError;
      } setTimeout(() => {
        this.showDownloadLogForDUNSBatchComplete = true;
      }, TEN_THOUSAND_MS);
      console.info("done")
      this.showDownloadLogForBvdIdBatch = true;
      this.inputFileVisibleForImportBvdId = false;
      this.currentBvdIdImporting = null;
      this.noOfBvdIdImported = null;
      this.importBvdIdInError = null;
      localStorage.setItem("currentBvdIdImporting", this.currentBvdIdImporting);
      localStorage.setItem("tempBvdIdInFileForLocal", null);
      localStorage.setItem("noOfBvdIdImported", this.noOfBvdIdImported);
      localStorage.setItem("importBvdIdInError", this.importBvdIdInError);
    } else {
      this.importBvdIdByFile(listObjForBvdId, currentBvdIdImporting, noOfBvdIdImported, importBvdIdInError);
    }
  }
  repeatLoopFnForImportBvdId(listObjforBvdId, currentBvdIdImporting, noOfBvdIdImported, importBvdIdInError) {
    console.info("repeating the loop")
    this.updateBvdIdProgress(noOfBvdIdImported, importBvdIdInError, listObjforBvdId ? listObjforBvdId.length : 0);
    let twentyMinutesLater = new Date();
    let curentmni = twentyMinutesLater.setMinutes(twentyMinutesLater.getMinutes());
    console.info('curentmni', curentmni)
    if (currentBvdIdImporting < listObjforBvdId.length) {
      if (currentBvdIdImporting == listObjforBvdId.length - 1) {
        this.showDownloadLogForBvdIdBatch = true;
        this.inputFileVisibleForImportBvdId = false;
        this.TextForCompleteUploadImportBvdId = 'Imported ' + noOfBvdIdImported + ' of ' + listObjforBvdId.length + '.';
        if (importBvdIdInError > 0) {
          this.TextForBvdIdInError = 'Error: ' + importBvdIdInError;
        }
        localStorage.setItem("listObjForBvdId", null);
        localStorage.setItem("noOfBvdIdImported", null);
        localStorage.setItem("currentBvdIdImporting", null);
        localStorage.setItem("totalBvdIdToImport", null);
        localStorage.setItem("listObjForBvdId", null);
        localStorage.setItem("importBvdIdInError", null);
        localStorage.setItem('errorMessageImportBvdIdBatch', null);
        localStorage.setItem('tempBvdIdInFileForLocal', null);
      } else {
        this.showSessionTimeoutBvdIdBatch = false
        this.scheduleNextBvdImport(listObjforBvdId, currentBvdIdImporting, noOfBvdIdImported, importBvdIdInError);
      }

    }
  }
  private updateBvdIdProgress(noOfBvdIdImported: number, importBvdIdInError: number, total: number) {
    const successPortion = 'Importing ' + noOfBvdIdImported + ' of ' + total + '.';
    this.TextForCompleteUploadImportBvdId = successPortion;
    if (importBvdIdInError > 0) {
      this.TextForBvdIdInError = 'Error: ' + importBvdIdInError;
    }

    localStorage.setItem('noOfBvdIdImported', String(noOfBvdIdImported));
    localStorage.setItem('importBvdIdInError', String(importBvdIdInError));

    if (Array.isArray(this.errorMessArrImportBvdIdBatch)) {
      localStorage.setItem('errorMessArrImportBvdIdBatch', JSON.stringify(this.errorMessArrImportBvdIdBatch));
    }
  }
  private scheduleNextBvdImport(listObjforBvdId, currentBvdIdImporting: number, noOfBvdIdImported: number, importBvdIdInError: number) {
    const nextIndex = currentBvdIdImporting + 1;
    this.bvdimportService.financeType2
    // Always use minimum 3000ms delay between imports to prevent race conditions
    // where shared state (this.BvDdata) gets overwritten by parallel imports
    const delay = THREE_THOUSAND_MS;
    if (nextIndex >= listObjforBvdId.length) {
      return;
    }
    console.info('[BVD-IMPORT] Scheduling next index', nextIndex, 'after', delay, 'ms. lastStarted=', this.currentBvdIdImportingStarted, 'lastProcessed=', this.currentBvdIdImporting);
    setTimeout(() => {
      const alreadyMarkedStarted = this.currentBvdIdImportingStarted === nextIndex;
      const alreadyProcessedOrProcessing = this.currentBvdIdImporting >= nextIndex;
      if (alreadyMarkedStarted && !alreadyProcessedOrProcessing) {
        console.warn('[BVD-IMPORT] Recovering stuck index', nextIndex);
      } else if (alreadyMarkedStarted && alreadyProcessedOrProcessing) {
        console.info('[BVD-IMPORT] Skip dispatch, index already in progress or processed', nextIndex);
        return;
      }
      this.currentBvdIdImportingStarted = nextIndex;
      this.importBvdIdByFile(listObjforBvdId, nextIndex, noOfBvdIdImported, importBvdIdInError);
    }, delay);
  }
  importBvdIdByFile(listObjForBvdId, currentBvdIdImporting, noOfBvdIdImported, importBvdIdInError) {
    if (currentBvdIdImporting < listObjForBvdId.length) {
      console.info("currentBvdIdImporting - ", currentBvdIdImporting + 'BVD-ID' + listObjForBvdId[currentBvdIdImporting]['BVD-ID'])
    } else {
      console.info('currentBvdIdImporting - ', currentBvdIdImporting)
    }
    this.currentBvdIdImporting = currentBvdIdImporting
    this.bvdimportService.currentBvdIdImporting = currentBvdIdImporting
    this.bvdimportService.c2bName = ''
    this.bvdimportService.financeType2 = ''
    localStorage.setItem("currentBvdIdImporting", this.currentBvdIdImporting);
    if (currentBvdIdImporting < listObjForBvdId.length) {
      let BvDAssignBvd = listObjForBvdId[currentBvdIdImporting]['BVD-ID']
      this.supplierService.getBusinessEntityIdentifiers(this.Config.ApiSupplierUrl + 'business-entity-identifiers?businessEntityIdentifierTypeName=BVD ID&value=' + BvDAssignBvd).subscribe((data: any) => {
        if (data['business-entity-identifiers'].length > 0) {
          this.errorMessArrImportBvdIdBatch.push({ "error": "BVD-ID: " + listObjForBvdId[currentBvdIdImporting]['BVD-ID'] + " already In RFS" });
          localStorage.setItem('errorMessArrImportBvdIdBatch', JSON.stringify(this.errorMessArrImportBvdIdBatch));
          if (listObjForBvdId.length === 1 || currentBvdIdImporting === listObjForBvdId.length - 1) {
            this.showDownloadLogForBvdIdBatch = true;
            this.inputFileVisibleForImportBvdId = false;
            this.clearBvdIdImportStorage();
          }
          console.info('Errors', this.errorMessArrImportBvdIdBatch)
          importBvdIdInError++;
          this.importBvdIdInError = importBvdIdInError;
          this.updateBvdIdProgress(noOfBvdIdImported, importBvdIdInError, listObjForBvdId.length);
          this.repeatLoopFnForImportBvdId(listObjForBvdId, currentBvdIdImporting, noOfBvdIdImported, importBvdIdInError);
        } else {
          let datas = { 'bvd-id': listObjForBvdId[currentBvdIdImporting]['BVD-ID'] }
          this.supplierService.createBvdInterface(this.Config.ApiSupplierUrl + 'bvd-interface', datas).subscribe((data: any) => {
            let obj = JSON.parse(data.result);
            this.bvdimportService.detailsFetch(obj['Data']);
            if (obj['Data'].length == 0) {
              this.errorMessArrImportBvdIdBatch.push({ "error": "BVD-ID: " + listObjForBvdId[currentBvdIdImporting]['BVD-ID'] + " doesn't exist in Orbis" });
              localStorage.setItem('errorMessArrImportBvdIdBatch', JSON.stringify(this.errorMessArrImportBvdIdBatch));
              if (listObjForBvdId.length === 1 || currentBvdIdImporting === listObjForBvdId.length - 1) {
                this.showDownloadLogForBvdIdBatch = true;
                this.inputFileVisibleForImportBvdId = false;
                this.clearBvdIdImportStorage();
              }
              console.info('Errors', this.errorMessArrImportBvdIdBatch)
              importBvdIdInError++;
              this.importBvdIdInError = importBvdIdInError;
              this.updateBvdIdProgress(noOfBvdIdImported, importBvdIdInError, listObjForBvdId.length);
              this.repeatLoopFnForImportBvdId(listObjForBvdId, currentBvdIdImporting, noOfBvdIdImported, importBvdIdInError);
            } else {
              this.bvdDataToImport = obj['Data']
              let type1 = ['BOP', 'NBOP', 'FINANCE', 'OTHER']
              if (type1.includes(listObjForBvdId[currentBvdIdImporting]['TYPE-1'])) {
                if (listObjForBvdId[currentBvdIdImporting]['TYPE-1'] == 'BOP') {
                  this.bvdimportService.typeName = 'bop'
                  this.bvdimportService.CheckImportSupplierNew();
                  this.noOfBvdIdImported = noOfBvdIdImported;
                  this.updateBvdIdProgress(noOfBvdIdImported, importBvdIdInError, listObjForBvdId.length);
                } else if (listObjForBvdId[currentBvdIdImporting]['TYPE-1'] == 'NBOP') {
                  this.bvdimportService.typeName = 'nbop'
                  if (listObjForBvdId[currentBvdIdImporting]['TYPE-2'] != undefined) {
                    this.bvdimportService.checkvalidatec2b(listObjForBvdId[currentBvdIdImporting]['TYPE-2']).subscribe(error => {
                      if (error != 'valid') {
                        this.errorMessArrImportBvdIdBatch.push({ "error": "BVD-ID: " + listObjForBvdId[currentBvdIdImporting]['BVD-ID'] + " " + error });
                        localStorage.setItem('errorMessArrImportBvdIdBatch', JSON.stringify(this.errorMessArrImportBvdIdBatch));
                        if (listObjForBvdId.length === 1 || currentBvdIdImporting === listObjForBvdId.length - 1) {
                          this.showDownloadLogForBvdIdBatch = true;
                          this.inputFileVisibleForImportBvdId = false;
                          this.clearBvdIdImportStorage();
                        }
                        console.info('Errors', this.errorMessArrImportBvdIdBatch)
                        importBvdIdInError++;
                        this.importBvdIdInError = importBvdIdInError;
                        this.updateBvdIdProgress(noOfBvdIdImported, importBvdIdInError, listObjForBvdId.length);
                        this.repeatLoopFnForImportBvdId(listObjForBvdId, currentBvdIdImporting, noOfBvdIdImported, importBvdIdInError);
                      } else {
                        this.bvdimportService.CheckImportSupplierNew()
                      }
                        }, error => {
                          this.handleBvdIdImportFailure(listObjForBvdId, currentBvdIdImporting, noOfBvdIdImported, importBvdIdInError, 'TYPE-2 validation failed', error);
                        })
                  } else if (listObjForBvdId[currentBvdIdImporting]['TYPE-2'] == undefined) {
                    this.bvdimportService.C2bDisplay = false
                    this.bvdimportService.c2bName = ''
                    this.bvdimportService.CheckImportSupplierNew()
                  }
                } else if (listObjForBvdId[currentBvdIdImporting]['TYPE-1'] == 'FINANCE') {
                  this.bvdimportService.typeName = 'finance'
                  let type2 = ['FINANCE-FACTOR', 'FINANCE-LAWYER', 'FINANCE-RENT']
                  if (type2.includes(listObjForBvdId[currentBvdIdImporting]['TYPE-2']) || listObjForBvdId[currentBvdIdImporting]['TYPE-2'] == undefined) {
                    this.bvdimportService.financeType2 = listObjForBvdId[currentBvdIdImporting]['TYPE-2']
                    this.bvdimportService.CheckImportSupplierNew()
                  } else {
                    this.errorMessArrImportBvdIdBatch.push({ "error": "BVD-ID: " + listObjForBvdId[currentBvdIdImporting]['BVD-ID'] + " FINANCE TYPE is not valid" });
                    localStorage.setItem('errorMessArrImportBvdIdBatch', JSON.stringify(this.errorMessArrImportBvdIdBatch));
                    if (listObjForBvdId.length === 1 || currentBvdIdImporting === listObjForBvdId.length - 1) {
                      this.showDownloadLogForBvdIdBatch = true;
                      this.inputFileVisibleForImportBvdId = false;
                      this.clearBvdIdImportStorage();
                    }
                    console.info('Errors', this.errorMessArrImportBvdIdBatch)
                    importBvdIdInError++;
                    this.importBvdIdInError = importBvdIdInError;
                    this.updateBvdIdProgress(noOfBvdIdImported, importBvdIdInError, listObjForBvdId.length);
                    this.repeatLoopFnForImportBvdId(listObjForBvdId, currentBvdIdImporting, noOfBvdIdImported, importBvdIdInError);
                  }
                } else if (listObjForBvdId[currentBvdIdImporting]['TYPE-1'] == 'OTHER') {
                  this.bvdimportService.typeName = ''
                  this.bvdimportService.CheckImportSupplierNew()
                }

                if (['NBOP', 'FINANCE', 'OTHER'].includes(listObjForBvdId[currentBvdIdImporting]['TYPE-1'])) {


                  this.noOfBvdIdImported = noOfBvdIdImported;
                  this.updateBvdIdProgress(noOfBvdIdImported, importBvdIdInError, listObjForBvdId.length);
                }
              } else {
                this.errorMessArrImportBvdIdBatch.push({ "error": "BVD-ID: " + listObjForBvdId[currentBvdIdImporting]['BVD-ID'] + " undefined TYPE-1 value" });
                localStorage.setItem('errorMessArrImportBvdIdBatch', JSON.stringify(this.errorMessArrImportBvdIdBatch));
                if (listObjForBvdId.length === 1 || currentBvdIdImporting === listObjForBvdId.length - 1) {
                  this.showDownloadLogForBvdIdBatch = true;
                  this.inputFileVisibleForImportBvdId = false;
                  this.clearBvdIdImportStorage();
                }
                console.info('Errors', this.errorMessArrImportBvdIdBatch)
                importBvdIdInError++;
                this.importBvdIdInError = importBvdIdInError;
                this.updateBvdIdProgress(noOfBvdIdImported, importBvdIdInError, listObjForBvdId.length);
                this.repeatLoopFnForImportBvdId(listObjForBvdId, currentBvdIdImporting, noOfBvdIdImported, importBvdIdInError);
              }
            }
          }, error => {
            this.handleBvdIdImportFailure(listObjForBvdId, currentBvdIdImporting, noOfBvdIdImported, importBvdIdInError, 'BVD interface creation failed', error);
          })
        }
      }, error => {
        this.handleBvdIdImportFailure(listObjForBvdId, currentBvdIdImporting, noOfBvdIdImported, importBvdIdInError, 'BVD-ID lookup failed', error);
      })
    }
    if (currentBvdIdImporting == listObjForBvdId.length) {
      setTimeout(() => {

        this.updateBvdIdProgress(noOfBvdIdImported, importBvdIdInError, listObjForBvdId.length);
        if (importBvdIdInError > 0) {
          this.TextForBvdIdInError = 'Error: ' + importBvdIdInError;
        }
        this.TextForCompleteUploadImportBvdId = 'Imported ' + noOfBvdIdImported + ' of ' + listObjForBvdId.length + '.';
        setTimeout(() => {
          this.showDownloadLogForBvdIdBatchComplete = true;
        }, TEN_THOUSAND_MS);
        console.info("done")
        this.showDownloadLogForBvdIdBatch = true;
        this.inputFileVisibleForImportBvdId = false;
        this.currentBvdIdImporting = null;
        this.noOfBvdIdImported = null;
        this.importBvdIdInError = null;
        this.clearBvdIdImportStorage();
      }, THREE_THOUSAND_MS);
    }
  }
  private handleBvdIdImportFailure(listObjForBvdId, currentBvdIdImporting, noOfBvdIdImported, importBvdIdInError, message: string, error: unknown): void {
    console.error('[BVD-IMPORT]', message, error);
    this.errorMessArrImportBvdIdBatch.push({ "error": "BVD-ID: " + listObjForBvdId[currentBvdIdImporting]['BVD-ID'] + " " + message });
    localStorage.setItem('errorMessArrImportBvdIdBatch', JSON.stringify(this.errorMessArrImportBvdIdBatch));
    importBvdIdInError++;
    this.importBvdIdInError = importBvdIdInError;
    this.updateBvdIdProgress(noOfBvdIdImported, importBvdIdInError, listObjForBvdId.length);
    this.repeatLoopFnForImportBvdId(listObjForBvdId, currentBvdIdImporting, noOfBvdIdImported, importBvdIdInError);
  }
  private clearBvdIdImportStorage() {
    const keys = ['currentBvdIdImporting', 'importBvdIdInError', 'tempBvdIdInFileForLocal', 'noOfBvdIdImported', 'importBvdIdInError', 'totalBvdIdToImport', 'errorMessArrImportBvdIdBatch'];
    keys.forEach(k => localStorage.setItem(k, null));
  }
  downloadLogFileForImportBvdIdBatch() {
    try {
      const compErrors = Array.isArray(this.errorMessArrImportBvdIdBatch) ? this.errorMessArrImportBvdIdBatch : [];
      const svcErrors = ''

      const mergedMap = new Map<string, any>();
      [...compErrors, ...svcErrors].forEach((e: any) => {
        if (!e) return;
        const raw = e.error || e.message || JSON.stringify(e);
        if (!mergedMap.has(raw)) {

          let bvdIdMatch = raw.match(/BVD-ID:?\s*([^\s]+)*/i);
          let bvdId = bvdIdMatch ? (bvdIdMatch[1] || '').replace(/[^A-Za-z0-9_-]/g, '') : '';
          mergedMap.set(raw, { raw, bvdId, message: raw });
        }
      });
      const rows = Array.from(mergedMap.values()).map((v, idx) => ({
        Index: idx + 1,
        'BVD-ID': v.bvdId,
        Message: v.message
      }));
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(rows);
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'BVD Errors');
      XLSX.writeFile(wb, 'ImportBvdIdBatchErrors.xlsx');
    } catch (err) {
      console.error('[BVD-IMPORT] Failed to export errors', err);
    }
  }


  importAlcorStartFn(listObjForAlcor, currentAlcorImporting = 0, noOfAlcorImported = 0, importAlcorInError = 0) {
    this.showDownloadLogForAlcorBatch = false;
    this.showDownloadLogForAlcorBatchComplete = false;
    this.inputFileVisibleForImportAlcor = false;
    this.TextForCompleteUploadImportAlcor = 'Uploading...';
    console.info("listObjForAlcor", listObjForAlcor)
    if (importAlcorInError < 1) {
      this.TextForAlcorInError = '';
    } else {
      this.TextForAlcorInError = 'Error: ' + importAlcorInError;
    }
    this.TextForCompleteUploadImportAlcor = 'Importing ' + noOfAlcorImported + ' of ' + (listObjForAlcor.length) + ' ';

    if (!this.CompanyStatusAll || this.CompanyStatusAll.length == 0 || this.groupCategoryModel == '' || this.siteSourceSystems.length == 0 || this.companyIdenKeys.length > 0 || this.cpyShortNameTypes.length == 0 || this.IsNullValue(this.alcorRowId) || this.siteIdentTypesData.length == 0) {
      this.importAlcorPreReq(listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError, true);
    }

    if (!this.checkFileFormat('ALCOR_CODE', listObjForAlcor)) {
      currentAlcorImporting = listObjForAlcor.length;
      this.errorMessArrImportAlcorBatch.push({ "error": "Please Upload a Valid file format " });
      localStorage.setItem("errorMessArrImportAlcorBatch", JSON.stringify(this.errorMessArrImportAlcorBatch));
      importAlcorInError++;
      this.importAlcorInError = importAlcorInError;
      this.TextForAlcorInError = 'Error: ' + importAlcorInError;
      localStorage.setItem("importAlcorInError", importAlcorInError.toString());

      this.TextForCompleteUploadImportAlcor = 'Imported ' + noOfAlcorImported + ' of ' + (listObjForAlcor.length) + '.';
      if (importAlcorInError > 0) {
        this.TextForAlcorInError = 'Error: ' + importAlcorInError;
      }
      setTimeout(() => {
        this.showDownloadLogForAlcorBatchComplete = true;
      }, TEN_THOUSAND_MS);
      console.info("done")
      this.showDownloadLogForAlcorBatch = true;
      this.inputFileVisibleForImportAlcor = false;
      this.currentAlcorImporting = null;
      this.noOfAlcorImported = null;
      this.importAlcorInError = null;
      localStorage.setItem("currentAlcorImporting", this.currentAlcorImporting);
      localStorage.setItem("tempAlcorInFileForLocal", null);
      localStorage.setItem("noOfAlcorImported", this.noOfAlcorImported);
      localStorage.setItem("importAlcorInError", this.importAlcorInError);
    } else {
      this.importAlcorByFileFunction(listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError);
    }
  }

  checkFileFormat(batch, list) {
    if (list.length == 0) {
      return false;
    } else if (batch == 'CompanyID') {
      if (list[0][batch] == undefined) {
        return false;
      }
    } else if (batch == 'BvdId' || batch == 'ALCOR_CODE' || batch == 'SAER_CODE' || batch == 'LATAM_CODE' || batch == 'RNAIPL_CODE') {
      const bvdHead = ['BVD-ID', 'TYPE-1', 'TYPE-2']
      const alcorHead = ['BVD-ID', 'ALCOR-CODE', 'ALCOR-NAME']
      const saerHead = ['BVD-ID', 'SAER-CODE', 'SAER-NAME']
      const latamHead = ['BVD-ID', 'LATAM-CODE', 'LATAM-NAME']
      const rnaiplHead = ['BVD-ID', 'RNAIPL-CODE', 'RNAIPL-NAME']
      if (list[0]['BVD-ID'] == undefined || list[0]['']) {
        return false
      }
      if (batch == 'BvdId') {
        if (JSON.stringify(this.BvdHeaders) !== JSON.stringify(bvdHead)) {
          return false
        }
      } else if(batch == 'SAER_CODE') {
        if (JSON.stringify(this.SaerHeaders) !== JSON.stringify(saerHead)) {
          return false
        }
      } else if(batch == 'LATAM_CODE') {
        if (JSON.stringify(this.LatamHeaders) !== JSON.stringify(latamHead)) {
          return false
        }
      }  else if(batch == 'RNAIPL_CODE') {
        if (JSON.stringify(this.RNAIPLHeaders) !== JSON.stringify(rnaiplHead)) {
          return false
        }
      }else {
        if (JSON.stringify(this.AlcorHeaders) !== JSON.stringify(alcorHead)) {
          return false
        }
      }
    } else {
      if (list[0][batch] == undefined || list[0]['GUO_BVD_ID'] == undefined) {
        return false;
      }
    }
    return true;
  }
  IsNullValue(val) {
    if (val == undefined || val == null || val == '') {
      return true
    }
    return false;
  }
  CheckForRequiredFieldsContacts(listObjForContacts, currentContactsImporting, importContactsInError, noOfContactsImported, _ifstart = false) {
    let isrequired = true;
    const keys = ['CompanyID', 'Email', 'FirstName', 'LastName', 'CellPhone', 'Function'];
    keys.forEach(field => {
      if (this.IsNullValue(listObjForContacts[currentContactsImporting][field])) {
        this.errorMessArrImportContactsBatch.push({ error: 'There is no value for ' + field });
        localStorage.setItem('errorMessArrImportContactsBatch', JSON.stringify(this.errorMessArrImportContactsBatch));
        importContactsInError++;
        this.importContactsInError = importContactsInError;
        this.TextForContactsInError = 'Error: ' + importContactsInError;
        localStorage.setItem('importContactsInError', importContactsInError);
        this.repeatLoopFnForImportContacts(listObjForContacts, currentContactsImporting, noOfContactsImported, importContactsInError);
        isrequired = false;
      }
    });
    return isrequired;
  }
  async importAlcorByFileFunction(listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError) {
    if (currentAlcorImporting < listObjForAlcor.length) {
      console.info("currentAlcorImporting - ", currentAlcorImporting + ' - ALCOR CODE:' + listObjForAlcor[currentAlcorImporting]['ALCOR-CODE'])
    } else {
      console.info("currentAlcorImporting - ", currentAlcorImporting)
    }
    this.currentAlcorImporting = currentAlcorImporting;
    localStorage.setItem("currentAlcorImporting", this.currentAlcorImporting);
    try {
      if (currentAlcorImporting < listObjForAlcor.length) {
        let BvDAssignBvd = listObjForAlcor[currentAlcorImporting]['BVD-ID']
        let data2 = await this.handleApiCall(this.supplierService.getCompanyIdentifiers(this.Config.ApiSupplierUrl + 'company-identifiers?companyIdentifierKeyName=ALCOR&value=' + listObjForAlcor[currentAlcorImporting]['ALCOR-CODE']).toPromise(), 'Error in getting CompanyIdentifiers', listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError, 'alcor')
        if (data2['company-identifiers'].length == 0) {
          let data = await this.handleApiCall(this.supplierService.getBusinessEntityIdentifiers(this.Config.ApiSupplierUrl + 'business-entity-identifiers?businessEntityIdentifierTypeName=BVD ID&value=' + BvDAssignBvd).toPromise(), 'Error in getting business entity identifiers', listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError, 'alcor')
          if (data['business-entity-identifiers'].length == 1) {
            data['business-entity-identifiers'].forEach(async entity => {
              let data3 = await this.handleApiCall(this.supplierService.getBusinessEntityById(this.Config.ApiSupplierUrl + 'business-entities/' + entity['businessEntityId']).toPromise(), 'Error in getting BusinessEntities', listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError, 'alcor')
              if (data3['isHQ'] == 'Y') {
                if ((listObjForAlcor[currentAlcorImporting]['ALCOR-CODE'] != undefined && listObjForAlcor[currentAlcorImporting]['ALCOR-CODE'] != '' && !isNaN(listObjForAlcor[currentAlcorImporting]['ALCOR-CODE']) && (listObjForAlcor[currentAlcorImporting]['ALCOR-CODE']).toString().length == SIX)) {
                  if ((listObjForAlcor[currentAlcorImporting]['ALCOR-NAME'] != undefined && listObjForAlcor[currentAlcorImporting]['ALCOR-NAME'] != '') && listObjForAlcor[currentAlcorImporting]['ALCOR-NAME'].length <= TEN) {
                    let data4 = await this.handleApiCall(this.supplierService.getCompanyById(this.Config.ApiSupplierUrl + 'companies/' + data3['companyId']).toPromise(), 'Error in getting Company', listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError, 'alcor')
                    if (data4['companyStatusCode'].toLowerCase() == 'identified') {
                      let alcor = {
                        "companyAllianceIdentifier": data4['allianceIdentifier'],
                        "linkedCompanyId": data4['rowId'],
                        "companyIdentifierKeyName": "ALCOR",
                        "companyIdentifierTypeId": this.alcorRowId,
                        "value": listObjForAlcor[currentAlcorImporting]['ALCOR-CODE'],
                        "startDate": this.apiService.getTodayDate()
                      }
                      let status = {
                        companyStatusId: this.CompanyStatusAll[0]['row_id'],
                        companyStatusCode: this.CompanyStatusAll[0]['code']
                      }
                      await this.updateAlcorName(data4['rowId'], listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError)
                      await this.updateAlcorCode(data4['rowId'], listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError, alcor)
                      await this.updateUsualName(data4['rowId'], listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError)
                      await this.handleApiCall(this.supplierService.UpdateCompany(this.Config.ApiSupplierUrl + 'companies/' + data4['rowId'], status).toPromise(), 'Error in Updating Company Status', listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError, 'alcor')
                      this.blankupdate.CompanyBlankStatusUpdate(data4['rowId'])
                      const subscription = this.blankupdate.uploadCompleted$.subscribe(completed => {
                        if (!completed) {
                          subscription.unsubscribe();
                          noOfAlcorImported++;
                          this.noOfAlcorImported = noOfAlcorImported;
                          localStorage.setItem("noOfAlcorImported", noOfAlcorImported.toString());
                          this.updateAlcorProgress(noOfAlcorImported, importAlcorInError, listObjForAlcor.length);
                          this.repeatLoopFnForImportAlcor(listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError);
                        }
                      });
                    } else {
                      this.errorMessArrImportAlcorBatch.push({ "error": "BVD-ID: " + listObjForAlcor[currentAlcorImporting]['BVD-ID'] + " company " + data4['allianceIdentifier'] + ' is ' + data4['companyStatusCode'] + ' status' });
                      importAlcorInError++;
                      this.updateAlcorProgress(noOfAlcorImported, importAlcorInError, listObjForAlcor.length)
                      this.repeatLoopFnForImportAlcor(listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError);
                      localStorage.setItem("errorMessArrImportAlcorBatch", JSON.stringify(this.errorMessArrImportAlcorBatch));
                      this.importAlcorInError = importAlcorInError;
                    }

                  } else {
                    this.errorMessArrImportAlcorBatch.push({ "error": "BVD-ID: " + listObjForAlcor[currentAlcorImporting]['BVD-ID'] + " Alcor Name " + listObjForAlcor[currentAlcorImporting]['ALCOR-NAME'] + " is not OK" });
                    importAlcorInError++;
                    this.updateAlcorProgress(noOfAlcorImported, importAlcorInError, listObjForAlcor.length)
                    this.repeatLoopFnForImportAlcor(listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError);
                    localStorage.setItem("errorMessArrImportAlcorBatch", JSON.stringify(this.errorMessArrImportAlcorBatch));
                    this.importAlcorInError = importAlcorInError;
                  }
                } else {
                  this.errorMessArrImportAlcorBatch.push({ "error": "BVD-ID: " + listObjForAlcor[currentAlcorImporting]['BVD-ID'] + " Alcor Code is not OK" });
                  importAlcorInError++;
                  this.updateAlcorProgress(noOfAlcorImported, importAlcorInError, listObjForAlcor.length)
                  this.repeatLoopFnForImportAlcor(listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError);
                  localStorage.setItem("errorMessArrImportAlcorBatch", JSON.stringify(this.errorMessArrImportAlcorBatch));
                  this.importAlcorInError = importAlcorInError;
                }
              } else {
                this.errorMessArrImportAlcorBatch.push({ "error": "BVD-ID: " + listObjForAlcor[currentAlcorImporting]['BVD-ID'] + " is not HQ" });
                importAlcorInError++;
                this.updateAlcorProgress(noOfAlcorImported, importAlcorInError, listObjForAlcor.length)
                this.repeatLoopFnForImportAlcor(listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError);
                localStorage.setItem("errorMessArrImportAlcorBatch", JSON.stringify(this.errorMessArrImportAlcorBatch));
                this.importAlcorInError = importAlcorInError;
              }
            })
          } else if (data['business-entity-identifiers'].length > 1) {
            this.errorMessArrImportAlcorBatch.push({ "error": 'There is more than one occurrence for ' + listObjForAlcor[currentAlcorImporting]['BVD-ID'] });
            importAlcorInError++;
            this.updateAlcorProgress(noOfAlcorImported, importAlcorInError, listObjForAlcor.length)
            this.repeatLoopFnForImportAlcor(listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError);
            localStorage.setItem("errorMessArrImportAlcorBatch", JSON.stringify(this.errorMessArrImportAlcorBatch));
            this.importAlcorInError = importAlcorInError;
          } else {
            this.errorMessArrImportAlcorBatch.push({ "error": "BVD-ID: " + listObjForAlcor[currentAlcorImporting]['BVD-ID'] + " Not in RFS" });
            importAlcorInError++;
            this.updateAlcorProgress(noOfAlcorImported, importAlcorInError, listObjForAlcor.length)
            this.repeatLoopFnForImportAlcor(listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError);
            localStorage.setItem("errorMessArrImportAlcorBatch", JSON.stringify(this.errorMessArrImportAlcorBatch));
            this.importAlcorInError = importAlcorInError;
          }
        } else {
          this.errorMessArrImportAlcorBatch.push({ "error": "BVD-ID: " + listObjForAlcor[currentAlcorImporting]['BVD-ID'] + " ALCOR CODE " + listObjForAlcor[currentAlcorImporting]['ALCOR-CODE'] + " already in RFF in " + data2['company-identifiers'][0]['companyAllianceIdentifier'] });
          importAlcorInError++;
          this.updateAlcorProgress(noOfAlcorImported, importAlcorInError, listObjForAlcor.length)
          this.repeatLoopFnForImportAlcor(listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError);
          localStorage.setItem("errorMessArrImportAlcorBatch", JSON.stringify(this.errorMessArrImportAlcorBatch));
          this.importAlcorInError = importAlcorInError;
        }

      }
    } catch (error) {

    }
    if (currentAlcorImporting == listObjForAlcor.length) {
      setTimeout(() => {

        this.TextForCompleteUploadImportAlcor = 'Imported ' + noOfAlcorImported + ' of ' + (listObjForAlcor.length) + '.';
        if (importAlcorInError > 0) {
          this.TextForAlcorInError = 'Error: ' + importAlcorInError;
        }
        setTimeout(() => {
          this.showDownloadLogForAlcorBatchComplete = true;
        }, TEN_THOUSAND_MS);
        console.info("done")
        this.showDownloadLogForAlcorBatch = true;
        this.inputFileVisibleForImportAlcor = false;
        this.currentAlcorImporting = null;
        this.noOfAlcorImported = null;
        this.importAlcorInError = null;
        localStorage.setItem("currentAlcorImporting", this.currentAlcorImporting);
        localStorage.setItem("tempAlcorInFileForLocal", null);
        localStorage.setItem("noOfAlcorImported", this.noOfAlcorImported);
        localStorage.setItem("importAlcorInError", this.importAlcorInError);
        localStorage.setItem('errorMessArrImportAlcorBatch', null);
        localStorage.setItem('totalAlcorToImport', null)
      }, THREE_THOUSAND_MS);
    }
  }
  async updateAlcorName(rowId, listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError) {
    let shortName = { "value": listObjForAlcor[currentAlcorImporting]['ALCOR-NAME'] }
    let companyrow_id = await this.handleApiCall(firstValueFrom(this.supplierService.getCompanyNames(this.Config.ApiSupplierUrl + 'company-names?companyId=' + rowId + '&companyNameTypeName=SHORT NAME')), 'Erron in getting Company Short Name', listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError, 'alcor')
    this.handleApiCall(firstValueFrom(this.supplierService.updateCompanyNames(this.Config.ApiSupplierUrl + 'company-names/' + companyrow_id['company-names'][0]['row_id'], shortName)), 'Erron in Updating Company Short Name', listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError, 'alcor')
  }
  async updateUsualName(rowId, listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError) {
    if(this.SiteRowID.length==0){
      await this.getSiteDetails(rowId, listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError)
      this.UpdateSiteUsualName(rowId, listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError);
    }else{
      this.UpdateSiteUsualName(rowId, listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError);
    }
  }
  UpdateSiteUsualName(_rowId, listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError){
    for (const element of this.SiteRowID) {
      firstValueFrom(this.sitesService.getSitebyId(this.Config.ApiSitesUrl + 'sites/' + element)).then(async (siteData: any) => {
        let siteUpdate = {
        'usualName': listObjForAlcor[currentAlcorImporting]['ALCOR-NAME'] + ' ' + siteData['cityName'],
        'rowId':  siteData['rowId']
      }
      await this.handleApiCall(firstValueFrom(this.sitesService.updateSite(this.Config.ApiSitesUrl + 'sites/' +element,siteUpdate )), 'Error in updating Site Usual Name', listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError, 'alcor');
      })
    }
  }
  async getSiteDetails(rowId, listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError, page = 1, subscribedData = []) {
    let subscribeData = page == 1 ? [] : subscribedData
    let site = await this.handleApiCall(firstValueFrom(this.supplierService.getSiteAssignments(this.Config.ApiSupplierUrl + 'site-assignments?businessEntityCompanyId=' + rowId + '&_page=' + page)), 'Errorin getting Sites', listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError, 'alcor')
    if (site['site-assignments'].length > 0) {
      site['site-assignments'].forEach(element => {
        if (element['status'] != 'ARCHIVED') {
          subscribeData.push(element)
        }
      })
      if (site['maxPage'] > 1 && site['maxPage'] != page) {
        await this.getSiteDetails(rowId, listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError, page + 1, subscribeData)
      } else if (site['maxPage'] == page) {
        subscribeData.forEach(element => {
          if (element.site.href) {
            let site_row_ID = element.site.href.split("/");

            let SiteRowIDExis = this.SiteRowID.indexOf(site_row_ID[1]);
            if (SiteRowIDExis == -1) {
              this.SiteRowID.push(site_row_ID[1]);
            }
          }
        });
      }
    }
  }
  async updateAlcorCode(rowId, listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError, alcor) {
    await this.handleApiCall(firstValueFrom(this.supplierService.createCompanyIdentifiers(this.Config.ApiSupplierUrl + 'company-identifiers?companyId=' + rowId, alcor)), 'Erron in Creating Alcor Code', listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError, 'alcor')
    await this.getSiteDetails(rowId, listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError)
    let data0 = await this.handleApiCall(firstValueFrom(this.sitesService.getRealEstateAssetIdentifiers(this.Config.ApiSitesUrl + 'real-estate-asset-identifiers?businessIdentifierValue=' + listObjForAlcor[currentAlcorImporting]['ALCOR-CODE'] + '&_page=1')), 'Error in getting RealEstateAssetIdentifiers', listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError, 'alcor')
    if (data0['pageCount'] == 0) {

      for (const element of this.SiteRowID) {
        const const1 = {
          "sourceSystemId": "2",
          "businessIdentifierId": this.siteIdentTypesData['RAFT_ACCOUNT'],
          "effectiveDate": this.apiService.getTodayDate(),
          "businessIdentifierValue": listObjForAlcor[currentAlcorImporting]['ALCOR-CODE'],
          "businessIdentifierName": listObjForAlcor[currentAlcorImporting]['ALCOR-NAME'],
          "realEstateAssetId": element
        }
        await this.handleApiCall(firstValueFrom(this.sitesService.createRealEstateAssetIdentifier(this.Config.ApiSitesUrl + 'real-estate-asset-identifiers', const1)), 'Error in Creating tRealEstateAssetIdentifiers', listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError, 'alcor');
      }
    } else {
      let tempRowId = [];
      const const2 = { "endDate": "" }

      for (let i = 0; i < data0['pageCount']; i++) {
        await this.handleApiCall(firstValueFrom(this.sitesService.updateRealEstateAssetIdentifier(this.Config.ApiSitesUrl + 'real-estate-asset-identifiers/' + data0['real-estate-asset-identifiers'][i]['rowId'], const2)), 'Error updating real estate asset identifier', listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError, 'alcor');
        tempRowId.push(data0['real-estate-asset-identifiers'][i]['rowId']);
      }

      for (const ele of this.SiteRowID) {
        if (tempRowId.indexOf(ele) != -1) {
          const const12 =
          {
            "sourceSystemId": "2",
            "businessIdentifierId": this.siteIdentTypesData['RAFT_ACCOUNT'],
            "effectiveDate": this.apiService.getTodayDate(),
            "businessIdentifierValue": listObjForAlcor[currentAlcorImporting]['ALCOR-CODE'],
            "businessIdentifierName": listObjForAlcor[currentAlcorImporting]['ALCOR-NAME'],
            "realEstateAssetId": ele
          }
          await this.handleApiCall(firstValueFrom(this.sitesService.createRealEstateAssetIdentifier(this.Config.ApiSitesUrl + 'real-estate-asset-identifiers', const12)), 'Error in Creating tRealEstateAssetIdentifiers', listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError, 'alcor');
        }
      }
    }
  }
  private updateAlcorProgress(noOfAlcorIdImported: number, importAlcorInError: number, total: number) {
    const successPortion = 'Importing ' + noOfAlcorIdImported + ' of ' + total + '.';
    this.TextForCompleteUploadImportAlcor = successPortion;
    if (importAlcorInError > 0) {
      this.TextForAlcorInError = 'Error: ' + importAlcorInError;
    }

    localStorage.setItem('noOfAlcorImported', noOfAlcorIdImported.toString());
    localStorage.setItem('importAlcorInError', importAlcorInError.toString());

    if (Array.isArray(this.errorMessArrImportAlcorBatch)) {
      localStorage.setItem('errorMessArrImportAlcorBatch', JSON.stringify(this.errorMessArrImportAlcorBatch));
    }
  }
  private createAlcorName(listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError) {
    let realestate = this.handleApiCall(firstValueFrom(this.sitesService.getRealEstateAssetIdentifiers(this.Config.ApiSitesUrl + 'real-estate-asset-identifiers?businessIdentifierValue=' + listObjForAlcor[currentAlcorImporting])), 'Error in getting real estate asset-identifiers', listObjForAlcor, currentAlcorImporting, noOfAlcorImported, importAlcorInError, 'alcor')
    realestate['real-estate-asset-identifiers']
  }

  repeatLoopFnForImportContacts(listObjForContacts, currentContactsImporting, noOfContactsImported, importContactsInError) {
    console.info("repeating the loop")
    let twentyMinutesLater = new Date();
    let curentmni = twentyMinutesLater.setMinutes(twentyMinutesLater.getMinutes());
    console.info('curentmni', curentmni)
    if (currentContactsImporting < listObjForContacts.length) {
    //   if ((parseInt(localStorage.getItem('expiredtime')) - curentmni <= 120000 && (parseInt(localStorage.getItem('expiredtime')) - curentmni) > 0) || (parseInt(localStorage.getItem('IDPexpiredtime')) - curentmni <= 120000 && (parseInt(localStorage.getItem('IDPexpiredtime')) - curentmni) > 0)) {
    //     this.showSessionTimeoutContactsBatch = true
    //     setTimeout(() => {
    //       window.location.reload();
    //     }, 122000);
    //   }
    //   else if (parseInt(localStorage.getItem('expiredtime')) >= curentmni || parseInt(localStorage.getItem('IDPexpiredtime')) >= curentmni) {
        this.showSessionTimeoutContactsBatch = false

        if (currentContactsImporting % BATCH_SIZE == 0) {
          setTimeout(() => {
            currentContactsImporting++;
            if (this.currentContactsImportingStarted != currentContactsImporting) {
              this.importContactsByFileFunction(listObjForContacts, currentContactsImporting, noOfContactsImported, importContactsInError);
              this.currentContactsImportingStarted = currentContactsImporting;
            }
          }, FIFTEEN_HUNDRED_MS);
        } else {
          currentContactsImporting++;
          if (this.currentAlcorImportingStarted != currentContactsImporting) {
            this.importContactsByFileFunction(listObjForContacts, currentContactsImporting, noOfContactsImported, importContactsInError);
            this.currentAlcorImportingStarted = currentContactsImporting;
          }

        }
      // } else {
      //   window.location.reload();
      // }
    }
  }

  downloadLogFileForImportAlcorBatch() {
    let element = document.getElementById('excelTableLogForImportAlcorBatch');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Import Alcor Batch');
    XLSX.writeFile(wb, 'ImportAlcorBatch.xlsx');
  }

  downloadLogFileForLogOfImportAlcorBatch() {
    let element = document.getElementById('excelTableLogForLogOfImportAlcorBatch');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Import Alcor Batch complete log');
    XLSX.writeFile(wb, 'ImportAlcorBatchCompleteLog.xlsx');
  }


  downloadLogFileForImportContactsBatch() {
    let element = document.getElementById('excelTableLogForImportContactsBatch');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Import Contacts Batch');
    XLSX.writeFile(wb, 'ImportContactsBatch.xlsx');
  }

  downloadLogFileForImportTaxBatch() {
    let element = document.getElementById('excelTableLogForImportTaxBatch');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Import Tax Identifiers Batch');
    XLSX.writeFile(wb, 'ImportTaxIdsBatch.xlsx');
  }

  downloadLogFileForLogOfImportContactsBatch() {
    let element = document.getElementById('excelTableLogForLogOfImportContactsBatch');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Import Contacts Batch complete log');
    XLSX.writeFile(wb, 'ImportContactsBatchCompleteLog.xlsx');
  }

  checkLocalStorageForImpAlcor() {
    let tempAlcorInFileForLocal = JSON.parse(localStorage.getItem('tempAlcorInFileForLocal'));
    let errorMessArrImportAlcorBatch = (localStorage.getItem('errorMessArrImportAlcorBatch') == null || localStorage.getItem('errorMessArrImportAlcorBatch') == undefined ||
      localStorage.getItem('errorMessArrImportAlcorBatch') == '') ? null : JSON.parse(localStorage.getItem('errorMessArrImportAlcorBatch'));
    let logOfImportAlcorBatch = JSON.parse(localStorage.getItem('logOfImportAlcorBatch'));
    let currentAlcorImporting = localStorage.getItem("currentAlcorImporting");
    let noOfAlcorImported = localStorage.getItem("noOfAlcorImported");
    let importAlcorInError = localStorage.getItem("importAlcorInError");
    let totalAlcorToImport = localStorage.getItem("totalAlcorToImport");
    console.info("no of Alcor rows complete", localStorage.getItem("currentAlcorImporting"))
    console.info("no of Alcor already uploaded ", localStorage.getItem("noOfSAlcorImported"))
    console.info("no of Alcor in error ", localStorage.getItem("importAlcorInError"))
    console.info("no of Alcor in total ", localStorage.getItem("totalAlcorToImport"))
    if (currentAlcorImporting != null && currentAlcorImporting != 'null') {
      if (noOfAlcorImported == null || noOfAlcorImported == 'null') {
        noOfAlcorImported = '0';
      }
      if (importAlcorInError == null || importAlcorInError == 'null') {
        importAlcorInError = '0';
      }
      if (errorMessArrImportAlcorBatch == null || errorMessArrImportAlcorBatch == 'null') {
        this.errorMessArrImportAlcorBatch = [];
      } else {
        this.errorMessArrImportAlcorBatch = errorMessArrImportAlcorBatch;
      }
      if (logOfImportAlcorBatch == null || logOfImportAlcorBatch == 'null') {
        this.logOfImportAlcorBatch = [];
      } else {
        this.logOfImportAlcorBatch = logOfImportAlcorBatch;
      }
      if (totalAlcorToImport == null || totalAlcorToImport == 'null') {
        this.totalAlcorToImport = '0';
      } else {
        this.totalAlcorToImport = totalAlcorToImport;
      }
      console.info("exc alcor")

      setTimeout(() => {
        this.importAlcorPreReqForReload(tempAlcorInFileForLocal, parseInt(currentAlcorImporting), parseInt(noOfAlcorImported), parseInt(importAlcorInError));
      }, FIFTEEN_HUNDRED_MS);

      document.getElementById('btnForImportAlcorBatch').click();
      this.updateAlcorProgress(parseInt(noOfAlcorImported), parseInt(importAlcorInError),tempAlcorInFileForLocal.length)
      this.inputFileVisibleForImportAlcor = false;
    } else {
      this.inputFileVisibleForImportAlcor = true;
      this.TextForCompleteUploadImportAlcor = "";
      this.errorMessArrImportAlcorBatch = [];
      this.logOfImportAlcorBatch = [];
      this.totalAlcorToImport = null;
      localStorage.setItem("errorMessArrImportAlcorBatch", null);
      localStorage.setItem("logOfImportAlcorBatch", null);
      localStorage.setItem("totalAlcorToImport", this.totalAlcorToImport);
      this.TextForAlcorInError = "";
    }
  }
  async importContactsPreReqForReload(listObjForContacts, currentContactsImporting = 0, noOfContactsImported = 0, importContactsInError = 0) {
    await this.getPersonRoleType(listObjForContacts, currentContactsImporting, noOfContactsImported, importContactsInError)
    this.importContactsStartFn(listObjForContacts, currentContactsImporting, noOfContactsImported, importContactsInError)
  }
  checkLocalStorageForImpContacts() {
    let tempContactsInFileForLocal = JSON.parse(localStorage.getItem('tempContactsInFileForLocal'));
    let errorMessArrImportContactsBatch = (localStorage.getItem('errorMessArrImportContactsBatch') == null || localStorage.getItem('errorMessArrImportContactsBatch') == undefined ||
      localStorage.getItem('errorMessArrImportContactsBatch') == '') ? null : JSON.parse(localStorage.getItem('errorMessArrImportContactsBatch'));
    let logOfImportContactsBatch = JSON.parse(localStorage.getItem('logOfImportContactsBatch'));
    let currentContactsImporting = localStorage.getItem("currentContactsImporting");
    let noOfContactsImported = localStorage.getItem("noOfContactsImported");
    let importContactsInError = localStorage.getItem("importContactsInError");
    let totalContactsToImport = localStorage.getItem("totalContactsToImport");
    console.info("no of Contacts rows complete", localStorage.getItem("currentContactsImporting"))
    console.info("no of Contacts already uploaded ", localStorage.getItem("noOfContactsImported"))
    console.info("no of Contacts in error ", localStorage.getItem("importContactsInError"))
    console.info("no of Contacts in total ", localStorage.getItem("totalContactsToImport"))
    if (currentContactsImporting != null && currentContactsImporting != 'null') {
      if (noOfContactsImported == null || noOfContactsImported == 'null') {
        noOfContactsImported = '0';
      }
      if (importContactsInError == null || importContactsInError == 'null') {
        importContactsInError = '0';
      }
      if (errorMessArrImportContactsBatch == null || errorMessArrImportContactsBatch == 'null') {
        this.errorMessArrImportContactsBatch = [];
      } else {
        this.errorMessArrImportContactsBatch = errorMessArrImportContactsBatch;
      }
      if (logOfImportContactsBatch == null || logOfImportContactsBatch == 'null') {
        this.logOfImportContactsBatch = [];
      } else {
        this.logOfImportContactsBatch = logOfImportContactsBatch;
      }
      if (totalContactsToImport == null || totalContactsToImport == 'null') {
        this.totalContactsToImport = '0';
      } else {
        this.totalContactsToImport = totalContactsToImport;
      }
      console.info("exc Contacts")
      setTimeout(() => {
        this.importContactsPreReqForReload(tempContactsInFileForLocal, parseInt(currentContactsImporting), parseInt(noOfContactsImported), parseInt(importContactsInError));
      }, FIFTEEN_HUNDRED_MS);

      document.getElementById('btnForImportContactsBatch').click();
      this.inputFileVisibleForImportContacts = false;
    } else {
      this.inputFileVisibleForImportContacts = true;
      this.TextForCompleteUploadImportContacts = "";
      this.errorMessArrImportContactsBatch = [];
      this.logOfImportContactsBatch = [];
      this.totalContactsToImport = null;
      localStorage.setItem("errorMessArrImportContactsBatch", null);
      localStorage.setItem("logOfImportContactsBatch", null);
      localStorage.setItem("totalContactsToImport", this.totalContactsToImport);
      this.TextForContactsInError = "";
    }
  }

}